// CB Staff Dashboard v31 — Send-by-SMS success check now matches the LIVE-VERIFIED /api/deposit-link-sms contract: success = {status:"ok"} (accepts ok:true for forward-compat), not `ok !== false`. Without this, a soft-fail (HTTP 200 + status:"error") would have shown "Sent" wrongly. (Success path live-verified 2026-06-16 — real SMS delivered.)
// CB Staff Dashboard v30 — Deposit Link tool gains a "Send by SMS" button: enter the client's mobile → POST the BEARER-GATED agent endpoint /api/deposit-link-sms (agent rebuilds the link via WF84 + sends via WF87 + logs to Communications). The raw cb-send-sms webhook is NOT browser-wired (it's an unauthenticated Twilio relay — FIX-117 class); the send routes through the PII-Bearer-gated agent endpoint instead.
// CB Staff Dashboard v29 — adds the Deposit Link tool (Today header): staff mint the £50 deposit link for a slot via WF84 (cb-deposit-link) and copy it / a ready message, for when an automated channel (e.g. an IG DM outside the 24h window) can't deliver it. Salon-branded SMS send stays server-side (agent) — cb-send-sms is not browser-wired (FIX-117 class).
// CB Staff Dashboard v23 — Cancel-button guard: warn if Cancel is clicked after editing date/time/stylist (FIX-119, marium fumble). v22 removed the Brevo key from the browser (FIX-117).
// CB Staff Dashboard v21 — adds Tasks tab (salon manager team tasks: view, resolve, route back)
// CB Staff Dashboard v7 — Calendar, Holidays, Performance, Morning Briefing, Call Logging
(function () {
  // ===== STYLES =====
  var s = document.createElement("style");
  s.textContent = [
    "*{margin:0;padding:0;box-sizing:border-box}",
    "body{background:#FDFAF8;font-family:'DM Sans',sans-serif}",
    "@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}",
    "@keyframes fadeIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}",
    "@keyframes slideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}",
    "::-webkit-scrollbar{width:6px;height:6px}",
    "::-webkit-scrollbar-track{background:rgba(139,115,74,0.05)}",
    "::-webkit-scrollbar-thumb{background:rgba(139,115,74,0.2);border-radius:3px}",
    "button:hover{opacity:0.85}",
    "input,select{font-family:'DM Sans',sans-serif;font-size:13px;padding:8px 10px;border:1px solid rgba(139,115,74,0.25);border-radius:4px;background:#fff;color:#2A2131;outline:none}",
    "input:focus,select:focus{border-color:#8B734A;box-shadow:0 0 0 2px rgba(139,115,74,0.1)}",
    ".cb-overlay{position:fixed;inset:0;background:rgba(42,33,49,0.5);z-index:10000;display:flex;align-items:center;justify-content:center;animation:fadeIn 0.15s ease;padding:20px 0;overflow-y:auto}",
    ".cb-modal{background:#FDFAF8;border-radius:8px;padding:24px;width:92%;max-width:420px;box-shadow:0 20px 60px rgba(0,0,0,0.3);animation:slideUp 0.25s ease;max-height:calc(100vh - 40px);overflow-y:auto;position:relative}",
    ".cb-modal h3{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:500;color:#2A2131;margin-bottom:16px}",
    ".cb-modal label{display:block;font-size:11px;color:#8B734A;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;margin-top:12px}",
    ".cb-modal label:first-of-type{margin-top:0}",
    ".cbd-btn{padding:8px 16px;border:none;border-radius:4px;cursor:pointer;font-size:12px;font-weight:600;letter-spacing:0.03em;transition:all 0.2s}",
    ".cbd-btn-primary{background:#8B734A;color:#F6EFED}",
    ".cbd-btn-secondary{background:rgba(139,115,74,0.12);color:#8B734A;border:1px solid rgba(139,115,74,0.2)}",
    ".cbd-btn-danger{background:rgba(200,60,60,0.12);color:#c83c3c;border:1px solid rgba(200,60,60,0.2)}",
    ".cbd-btn-row{display:flex;gap:8px;margin-top:20px;justify-content:flex-end}",
    ".cbd-toast{position:fixed;bottom:20px;right:20px;background:#2A2131;color:#F6EFED;padding:10px 20px;border-radius:6px;font-size:12px;z-index:200;animation:slideUp 0.3s ease;box-shadow:0 4px 20px rgba(0,0,0,0.3)}",
    ".cbd-toast.cbd-error{background:#c83c3c}"
  ].join("\n");
  document.head.appendChild(s);
})();

var STAFF_PIN = window.__CB_STAFF_PIN || "";
const { useState, useEffect, useCallback, useMemo } = React;

// ===== CONSTANTS =====
const STYLISTS = [
  { name: "Catherine", role: "Founder", color: "#F5D76E" },
  { name: "Amber", role: "Senior Colourist", color: "#89CFF0" },
  { name: "Jess L", role: "Senior Colourist", color: "#F4A6C1" },
  { name: "Jess S", role: "Stylist", color: "#C3A6D8" }
];

// FIX-046 (2026-05-13) — Jess S was null in STYLIST_CAPACITY, which excluded her
// from morning-briefing openings and rendered her capacity as "0" with no "/N" denominator.
// Per CLAUDE.md team table, Jess S has 3/day capacity same as Amber + Jess L.
const STYLIST_CAPACITY = { "Catherine": 4, "Amber": 3, "Jess L": 3, "Jess S": 3 };
const LOG_API = "https://n8n.catherineboden.com/webhook/cb-log-interaction";

const VIEW_API = "https://n8n.catherineboden.com/webhook/cb-team-calendar";
const MANAGE_API = "https://n8n.catherineboden.com/webhook/cb-booking-manage";
const INTERACTIONS_API = "https://n8n.catherineboden.com/webhook/cb-interactions-v2";
const ACTIVITY_API = "https://n8n.catherineboden.com/webhook/cb-activity";
const KB_API = "https://n8n.catherineboden.com/webhook/cb-knowledge-base";
const BOOKING_CREATE_API = "https://n8n.catherineboden.com/webhook/cb-booking-create";
const RESCHEDULE_API = "https://n8n.catherineboden.com/webhook/cb-reschedule";
const LOOKUP_API = "https://n8n.catherineboden.com/webhook/cb-lookup-bookings";
const KB_SUGGEST_API = "https://n8n.catherineboden.com/webhook/cb-kb-suggest";
const STAFF_PHOTO_API = "https://n8n.catherineboden.com/webhook/cb-staff-photo";
const DEPOSIT_LINK_API = "https://n8n.catherineboden.com/webhook/cb-deposit-link";

// ===== SALON MANAGER AGENT =====
// The salon manager agent raises team tasks (e.g. squeeze-in requests) and accepts
// resolutions back. Single config constant, mirroring the CB_CHAT_CONFIG seam in
// cb-team-chat-v1.js, so the host can be re-pointed without touching the Tasks tab.
const CB_AGENT_BASE = "https://agent.catherineboden.com";
const TASKS_API = CB_AGENT_BASE + "/api/tasks";
const TASK_RESOLVED_API = CB_AGENT_BASE + "/api/webhook/task-resolved";

// Read a File as base64 (no data: prefix)
function readFileAsBase64(file) {
  return new Promise(function(resolve, reject) {
    var r = new FileReader();
    r.onload = function() { var s = r.result || ""; var i = s.indexOf(","); resolve(i >= 0 ? s.slice(i + 1) : s); };
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

// Upload a Before/After photo to a booking (via calendar event id)
function uploadStaffPhoto(opts) {
  // opts: { calendarEventId, kind, file, onStart, onDone, onError }
  if (!opts.file) return;
  if (opts.file.size > 10 * 1024 * 1024) { opts.onError && opts.onError("Photo is too large (max 10MB)"); return; }
  opts.onStart && opts.onStart();
  readFileAsBase64(opts.file).then(function(b64) {
    return fetch(STAFF_PHOTO_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        calendar_event_id: opts.calendarEventId,
        kind: opts.kind,
        staff_pin: STAFF_PIN,
        filename: opts.file.name || "photo.jpg",
        content_type: opts.file.type || "image/jpeg",
        base64: b64
      })
    }).then(function(r) { return r.json(); });
  }).then(function(d) {
    if (!d || d.ok === false) { opts.onError && opts.onError((d && d.error) || "Upload failed"); return; }
    opts.onDone && opts.onDone(d);
  }).catch(function(err) { opts.onError && opts.onError(String(err)); });
}

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

function getLondonDate() {
  // FIX-047 — Safari can't always parse en-US toLocaleString output back into a Date,
  // which silently returned Invalid Date and cascaded into "undefined NaN undefined" in
  // the Tuesday Consultations strip. Use Intl.DateTimeFormat parts directly — works in
  // every browser that supports timezone IANA names.
  try {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function(x) { if (x.type !== "literal") p[x.type] = x.value; });
    if (p.year && p.month && p.day) {
      // p.hour can be "24" in some locales when midnight — clamp to 0.
      var h = parseInt(p.hour, 10); if (h === 24) h = 0;
      return new Date(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10), h, parseInt(p.minute, 10), parseInt(p.second, 10));
    }
  } catch (e) { /* fall through */ }
  // Last-ditch fallback — local Date with no zone adjustment. Worse than no fix but better
  // than rendering NaN.
  return new Date();
}
function fmtDate(d) {
  return d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
}
function parseDate(s) {
  var p = s.split("-").map(Number);
  return new Date(p[0], p[1]-1, p[2]);
}
function fmtDayLong(d) {
  // FIX-047 — guard against Invalid Date (parseDate of empty/undefined string).
  // Previous behaviour rendered the literal string "undefined NaN undefined" in the UI
  // for the Tuesday Consultations strip when tuesdayStr was not yet computed.
  if (!d || isNaN(d.getTime())) return "";
  var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  return days[d.getDay()] + " " + d.getDate() + " " + MONTHS[d.getMonth()];
}
function getStylistColor(name) {
  var s = STYLISTS.find(function(x){ return x.name === name; });
  return s ? s.color : "#8B734A";
}

// ===== SERVICE TYPE CLASSIFIER =====
function classifyService(summary) {
  var s = (summary || "").toUpperCase();
  if (s.includes("HOLIDAY") || s.includes("ANNUAL LEAVE") || s.includes("SICK")) return "holiday";
  if (s.includes("BLOCK") || s.includes("BREAK") || s.includes("LUNCH") || s.includes("MEETING")) return "blocked";
  if (s.includes("CONSULTATION") || s.includes("CONSULT")) return "consultation";
  if (s.includes("COLOUR CORRECTION") || s.includes("COLOR CORRECTION")) return "correction";
  if (s.includes("FULL WORKS") || s.includes("HCB FULL")) return "fullworks";
  if (s.includes("REFRESH") || s.includes("TONER") || s.includes("HCB REFRESH")) return "refresh";
  if (s.includes("CUT & STYLE") || s.includes("CUT AND STYLE") || s.includes("BLOW DRY") || s.includes("CUT ") || s === "CUT") return "cut";
  return "standard";
}

var SERVICE_STYLES = {
  fullworks:    { label: "Full Works", bg: "1",    border: "1",    pattern: "solid" },
  refresh:      { label: "Refresh / Toner", bg: "0.18", border: "1",    pattern: "light" },
  correction:   { label: "Colour Correction", bg: "0.25", border: "1",    pattern: "striped" },
  cut:          { label: "Cut / Blow Dry",  bg: "0",    border: "1",    pattern: "outline" },
  consultation: { label: "Consultation",    bg: "0.12", border: "1",    pattern: "compact" },
  blocked:      { label: "Break / Block",   bg: "1",    border: "1",    pattern: "muted" },
  holiday:      { label: "Holiday",         bg: "1",    border: "1",    pattern: "muted" },
  standard:     { label: "Appointment",     bg: "0.5",  border: "1",    pattern: "solid" }
};

function getEventStyle(serviceType, stylistColor) {
  var hex = stylistColor || "#8B734A";
  var r = parseInt(hex.slice(1,3), 16), g = parseInt(hex.slice(3,5), 16), b = parseInt(hex.slice(5,7), 16);
  var style = { borderLeft: "3px solid " + hex, borderRadius: 5, padding: "8px 12px", marginBottom: 4 };
  if (serviceType === "fullworks") {
    style.background = "rgba(" + r + "," + g + "," + b + ",0.25)";
    style.fontWeight = 600;
  } else if (serviceType === "refresh") {
    style.background = "rgba(" + r + "," + g + "," + b + ",0.10)";
  } else if (serviceType === "correction") {
    style.background = "repeating-linear-gradient(135deg, rgba(" + r + "," + g + "," + b + ",0.12), rgba(" + r + "," + g + "," + b + ",0.12) 4px, rgba(" + r + "," + g + "," + b + ",0.04) 4px, rgba(" + r + "," + g + "," + b + ",0.04) 8px)";
  } else if (serviceType === "cut") {
    style.background = "transparent";
    style.border = "1px dashed " + hex;
    style.borderLeft = "3px solid " + hex;
  } else if (serviceType === "consultation") {
    style.background = "rgba(" + r + "," + g + "," + b + ",0.08)";
    style.padding = "5px 12px";
  } else if (serviceType === "blocked" || serviceType === "holiday") {
    style.background = "rgba(138,132,144,0.08)";
    style.borderLeft = "3px solid #8A8490";
  } else {
    style.background = "rgba(" + r + "," + g + "," + b + ",0.15)";
  }
  return style;
}

function parseClientAndService(summary) {
  var parts = summary.split(/ - | \| /);
  if (parts.length >= 2) return { client: parts[0].trim(), service: parts.slice(1).join(" - ").trim() };
  return { client: summary, service: "" };
}

// ===== TOAST =====
function Toast({ message, isError, onClose }) {
  useEffect(function() {
    var t = setTimeout(onClose, 3000);
    return function() { clearTimeout(t); };
  }, []);
  return React.createElement("div", { className: "cbd-toast" + (isError ? " cbd-error" : "") }, message);
}

// ===== PIN SCREEN =====
function PinScreen({ onUnlock }) {
  var _s = useState(""), pin = _s[0], setPin = _s[1];
  var _e = useState(false), err = _e[0], setErr = _e[1];
  var _c = useState(false), checking = _c[0], setChecking = _c[1];

  function handleSubmit(e) {
    e.preventDefault();
    if (checking) return;
    var auth = window.CB_AUTH;
    // PII gate: the PIN is validated SERVER-SIDE (mints a Bearer token). Fall back to the
    // client-side check only if the auth helper is absent (old cache) or the agent is
    // unreachable — UI opens, agent tabs degrade gracefully until a token can be minted.
    if (!auth) { if (pin === STAFF_PIN) { onUnlock(); } else { setErr(true); setPin(""); } return; }
    setChecking(true); setErr(false);
    auth.login(pin).then(function (res) {
      setChecking(false);
      if (res.ok) { onUnlock(); }
      else if (res.unreachable && STAFF_PIN && pin === STAFF_PIN) { onUnlock(); }
      else { setErr(true); setPin(""); }
    });
  }

  return React.createElement("div", {
    style: { display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", background:"#FDFAF8" }
  },
    React.createElement("form", {
      onSubmit: handleSubmit,
      style: { textAlign:"center", animation:"fadeIn 0.4s ease" }
    },
      React.createElement("div", {
        style: { width:60, height:60, borderRadius:"50%", background:"rgba(139,115,74,0.1)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }
      },
        React.createElement("span", { style: { fontSize:24 } }, "\uD83D\uDD12")
      ),
      React.createElement("h2", {
        style: { fontFamily:"'Cormorant Garamond',serif", fontSize:24, fontWeight:400, color:"#2A2131", marginBottom:4 }
      }, "Staff Dashboard"),
      React.createElement("p", {
        style: { fontSize:12, color:"#8B734A", marginBottom:24 }
      }, "Enter your staff PIN to continue"),
      React.createElement("input", {
        type: "password",
        inputMode: "numeric",
        maxLength: 4,
        value: pin,
        onChange: function(e) { setPin(e.target.value.replace(/\D/g,"")); setErr(false); },
        placeholder: "____",
        autoFocus: true,
        style: { width:120, textAlign:"center", fontSize:24, letterSpacing:"0.3em", padding:"10px", borderColor: err ? "#c83c3c" : "rgba(139,115,74,0.25)" }
      }),
      err && React.createElement("p", { style: { color:"#c83c3c", fontSize:11, marginTop:8 } }, "Incorrect PIN"),
      React.createElement("br", null),
      React.createElement("button", {
        type: "submit",
        className: "cbd-btn cbd-btn-primary",
        style: { marginTop:16, padding:"10px 32px" }
      }, "Unlock")
    )
  );
}

// ===== ADD HOLIDAY MODAL =====
function AddHolidayModal({ onClose, onSave }) {
  var _st = useState("Catherine"), stylist = _st[0], setStylist = _st[1];
  var _sd = useState(fmtDate(getLondonDate())), startDate = _sd[0], setStartDate = _sd[1];
  var _ed = useState(fmtDate(getLondonDate())), endDate = _ed[0], setEndDate = _ed[1];
  var _r = useState("Annual Leave"), reason = _r[0], setReason = _r[1];
  var _sv = useState(false), saving = _sv[0], setSaving = _sv[1];

  function handleSave() {
    setSaving(true);
    var start = parseDate(startDate);
    var end = parseDate(endDate);
    var promises = [];
    var d = new Date(start);
    while (d <= end) {
      var dow = d.getDay();
      if (dow >= 3 && dow <= 6) {
        promises.push(fetch(MANAGE_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "add",
            stylist: stylist,
            clientName: "HOLIDAY",
            service: reason,
            date: fmtDate(d),
            startTime: "09:30",
            endTime: "17:30",
            notes: "Holiday: " + reason
          })
        }));
      }
      d.setDate(d.getDate() + 1);
    }
    if (promises.length === 0) {
      onSave(null, "No working days in selected range");
      setSaving(false);
      return;
    }
    Promise.all(promises).then(function() {
      // 2026-05-25 v20: removed dead fetch to CONFIRM_API (cb-booking-confirm-email).
      // That endpoint was never wired to any active workflow \u2014 every holiday add
      // silently 404'd and the toast misled staff into thinking Catherine was
      // notified. If a WF18-style holiday-notification workflow is ever built,
      // re-add the fetch HERE (the original payload shape was kept in v19 for
      // reference: clientName/clientEmail/service/stylist/date/startTime).
      onSave("Holiday added for " + stylist + " (" + promises.length + " day" + (promises.length > 1 ? "s" : "") + "). Please tell Catherine directly.");
    }).catch(function() {
      onSave(null, "Failed to add holiday");
    }).finally(function() { setSaving(false); });
  }

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal" },
      React.createElement("h3", null, "Add Holiday / Time Off"),
      React.createElement("label", null, "Stylist"),
      React.createElement("select", { style: { width: "100%" }, value: stylist, onChange: function(e) { setStylist(e.target.value); } },
        STYLISTS.map(function(s) { return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.role + ")"); })
      ),
      React.createElement("label", null, "Reason"),
      React.createElement("select", { style: { width: "100%" }, value: reason, onChange: function(e) { setReason(e.target.value); } },
        ["Annual Leave", "Sick Day", "Training", "Personal", "Bank Holiday", "Other"].map(function(r) {
          return React.createElement("option", { key: r, value: r }, r);
        })
      ),
      React.createElement("div", { style: { display: "flex", gap: 8 } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Start Date"),
          React.createElement("input", { type: "date", style: { width: "100%" }, value: startDate, onChange: function(e) { setStartDate(e.target.value); } })
        ),
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "End Date"),
          React.createElement("input", { type: "date", style: { width: "100%" }, value: endDate, onChange: function(e) { setEndDate(e.target.value); } })
        )
      ),
      React.createElement("div", { className: "cbd-btn-row" },
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose }, "Cancel"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: handleSave, disabled: saving }, saving ? "Saving..." : "Add Holiday")
      )
    )
  );
}

// ===== BLOCK TIME MODAL =====
function BlockTimeModal({ onClose, onSave }) {
  var _st = useState("Catherine"), stylist = _st[0], setStylist = _st[1];
  var _d = useState(fmtDate(getLondonDate())), date = _d[0], setDate = _d[1];
  var _s = useState("10:00"), startTime = _s[0], setStartTime = _s[1];
  var _e = useState("11:00"), endTime = _e[0], setEndTime = _e[1];
  var _r = useState("Team Meeting"), reason = _r[0], setReason = _r[1];
  var _sv = useState(false), saving = _sv[0], setSaving = _sv[1];

  function handleSave() {
    if (startTime >= endTime) { onSave(null, "End time must be after start time"); return; }
    setSaving(true);
    fetch(MANAGE_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action: "add",
        stylist: stylist,
        clientName: "BLOCK",
        service: reason,
        date: date,
        startTime: startTime,
        endTime: endTime,
        notes: "Blocked: " + reason
      })
    }).then(function(r) {
      if (r.ok) onSave("Time blocked for " + stylist + " \u2014 " + reason);
      else onSave(null, "Failed to block time");
    }).catch(function() {
      onSave(null, "Failed to block time");
    }).finally(function() { setSaving(false); });
  }

  var timeOptions = [];
  for (var h = 9; h <= 17; h++) {
    for (var m = 0; m < 60; m += 15) {
      var val = String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
      var h12 = h > 12 ? h - 12 : (h === 0 ? 12 : h);
      var label = h12 + ":" + String(m).padStart(2, "0") + (h >= 12 ? "pm" : "am");
      timeOptions.push({ val: val, label: label });
    }
  }

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal" },
      React.createElement("h3", null, "Block Time"),
      React.createElement("label", null, "Stylist"),
      React.createElement("select", { style: { width: "100%" }, value: stylist, onChange: function(e) { setStylist(e.target.value); } },
        STYLISTS.map(function(s) { return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.role + ")"); })
      ),
      React.createElement("label", null, "Reason"),
      React.createElement("select", { style: { width: "100%" }, value: reason, onChange: function(e) { setReason(e.target.value); } },
        ["Team Meeting", "Training", "Personal", "Break", "Salon Event", "Other"].map(function(r) {
          return React.createElement("option", { key: r, value: r }, r);
        })
      ),
      React.createElement("label", null, "Date"),
      React.createElement("input", { type: "date", style: { width: "100%" }, value: date, onChange: function(e) { setDate(e.target.value); } }),
      React.createElement("div", { style: { display: "flex", gap: 8 } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Start Time"),
          React.createElement("select", { style: { width: "100%" }, value: startTime, onChange: function(e) { setStartTime(e.target.value); } },
            timeOptions.map(function(t) { return React.createElement("option", { key: "s" + t.val, value: t.val }, t.label); })
          )
        ),
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "End Time"),
          React.createElement("select", { style: { width: "100%" }, value: endTime, onChange: function(e) { setEndTime(e.target.value); } },
            timeOptions.map(function(t) { return React.createElement("option", { key: "e" + t.val, value: t.val }, t.label); })
          )
        )
      ),
      React.createElement("div", { className: "cbd-btn-row" },
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose }, "Cancel"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: handleSave, disabled: saving }, saving ? "Saving..." : "Block Time")
      )
    )
  );
}

// ===== LOG CALL MODAL =====
function LogCallModal({ onClose, onSave }) {
  var _n = useState(""), clientName = _n[0], setClientName = _n[1];
  var _c = useState(""), contact = _c[0], setContact = _c[1];
  var _no = useState(""), notes = _no[0], setNotes = _no[1];
  var _sv = useState(false), saving = _sv[0], setSaving = _sv[1];

  function handleSave() {
    if (!clientName.trim()) { onSave(null, "Please enter a client name"); return; }
    setSaving(true);
    fetch(LOG_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        channel: "telephone",
        clientName: clientName.trim(),
        clientContact: contact.trim(),
        summary: notes.trim() || "Phone call logged",
        direction: "inbound",
        handledBy: "team",
        timestamp: new Date().toISOString()
      })
    }).then(function(r) {
      if (r.ok) onSave("Call logged for " + clientName.trim());
      else onSave("Call logged locally (sync pending)");
    }).catch(function() {
      onSave("Call logged locally (sync pending)");
    }).finally(function() { setSaving(false); });
  }

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal" },
      React.createElement("h3", null, "Log Phone Call"),
      React.createElement("label", null, "Client Name"),
      React.createElement("input", { style: { width: "100%" }, value: clientName, onChange: function(e) { setClientName(e.target.value); }, placeholder: "e.g. Sarah Jones", autoFocus: true }),
      React.createElement("label", null, "Phone or Email (optional)"),
      React.createElement("input", { style: { width: "100%" }, value: contact, onChange: function(e) { setContact(e.target.value); }, placeholder: "e.g. 07700 900000" }),
      React.createElement("label", null, "Notes"),
      React.createElement("textarea", { style: { width: "100%", minHeight: 80, padding: "8px 10px", fontSize: 13, fontFamily: "'DM Sans',sans-serif", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, resize: "vertical" }, value: notes, onChange: function(e) { setNotes(e.target.value); }, placeholder: "Brief notes about the call..." }),
      React.createElement("div", { className: "cbd-btn-row" },
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose }, "Cancel"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: handleSave, disabled: saving }, saving ? "Saving..." : "Log Call")
      )
    )
  );
}

// ===== NEW BOOKING MODAL (in-salon manual entry) =====
function NewBookingModal({ onClose, onSave }) {
  var _kb = useState(null), kb = _kb[0], setKb = _kb[1];
  var _kbErr = useState(false), kbErr = _kbErr[0], setKbErr = _kbErr[1];
  var _st = useState("Catherine"), stylist = _st[0], setStylist = _st[1];
  var _sv = useState(""), service = _sv[0], setService = _sv[1];
  var _cn = useState(""), clientName = _cn[0], setClientName = _cn[1];
  var _ce = useState(""), clientEmail = _ce[0], setClientEmail = _ce[1];
  var _cp = useState(""), clientPhone = _cp[0], setClientPhone = _cp[1];
  // Client typeahead — searches Airtable Clients by name/phone/email via WF44.
  // When staff picks a match the form auto-fills name/email/phone so they don't re-type
  // a returning client's details. Empty/short queries clear results.
  var _q = useState(""), clientQuery = _q[0], setClientQuery = _q[1];
  var _qr = useState([]), clientMatches = _qr[0], setClientMatches = _qr[1];
  var _ql = useState(false), clientSearching = _ql[0], setClientSearching = _ql[1];
  var _qs = useState(false), clientPicked = _qs[0], setClientPicked = _qs[1];
  var _d = useState(fmtDate(getLondonDate())), date = _d[0], setDate = _d[1];
  var _s = useState("10:00"), startTime = _s[0], setStartTime = _s[1];
  var _p = useState(""), price = _p[0], setPrice = _p[1];
  var _dep = useState(false), depositPaid = _dep[0], setDepositPaid = _dep[1];
  var _no = useState(""), notes = _no[0], setNotes = _no[1];
  var _saving = useState(false), saving = _saving[0], setSaving = _saving[1];

  useEffect(function() {
    fetch(KB_API)
      .then(function(r) { return r.json(); })
      .then(function(d) { setKb(d); })
      .catch(function() { setKbErr(true); });
  }, []);

  // Debounced client search. Picks the right query key based on what staff typed:
  // looks like an email → email, mostly digits → phone, else → name.
  useEffect(function() {
    var q = clientQuery.trim();
    if (clientPicked) return; // staff already chose a match — don't re-search
    if (q.length < 2) { setClientMatches([]); return; }
    var key = "name";
    if (q.indexOf("@") > -1) key = "email";
    else if (q.replace(/\D/g, "").length >= q.length - 2 && q.replace(/\D/g, "").length >= 4) key = "phone";
    setClientSearching(true);
    var cancelled = false;
    var t = setTimeout(function() {
      fetch(LOOKUP_API + "?scope=upcoming&" + key + "=" + encodeURIComponent(q))
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (cancelled) return;
          var rows = (d && d.results) ? d.results.map(function(r) { return r.client; }) : [];
          setClientMatches(rows.slice(0, 8));
        })
        .catch(function() { if (!cancelled) setClientMatches([]); })
        .finally(function() { if (!cancelled) setClientSearching(false); });
    }, 250);
    return function() { cancelled = true; clearTimeout(t); };
  }, [clientQuery, clientPicked]);

  function pickClient(c) {
    setClientName(c.name || "");
    setClientEmail(c.email || "");
    setClientPhone(c.phone || "");
    setClientQuery(c.name || c.email || c.phone || "");
    setClientMatches([]);
    setClientPicked(true);
  }
  function clearPick() {
    setClientPicked(false);
    setClientQuery("");
    setClientName("");
    setClientEmail("");
    setClientPhone("");
  }

  // Stylist meta from KB team (whitelist via team.services + blacklist via doesNotOffer)
  var stylistMeta = null;
  if (kb && kb.team) {
    stylistMeta = (kb.team || []).find(function(t) { return t.name === stylist; });
  }
  var stylistKey = ({ "Catherine": "catherine", "Amber": "amber", "Jess L": "jessL", "Jess S": "jessS" })[stylist];

  // Build flat service list from KB pricing for the SELECTED stylist.
  // KB shape: pricing.colourServices[] / cuttingStyling[] use per-stylist price fields (null = not offered).
  // additionalServices[] use a `stylists` array.
  // Each item has `service` (name) and `slotDuration` (mins).
  var availableServices = [];
  if (kb && kb.pricing && stylistKey) {
    ["colourServices", "cuttingStyling"].forEach(function(g) {
      (kb.pricing[g] || []).forEach(function(s) {
        var price = s[stylistKey];
        if (!price) return; // null = stylist doesn't offer
        availableServices.push({ name: s.service, duration: s.slotDuration || 45, price: price });
      });
    });
    (kb.pricing.additionalServices || []).forEach(function(s) {
      var stylists = s.stylists || [];
      if (stylists.indexOf(stylist) === -1) return;
      availableServices.push({ name: s.service, duration: s.slotDuration || 45, price: s.price || "" });
    });
  }
  // Apply team.doesNotOffer as a final blacklist (matches by short name within longer s.service strings)
  if (stylistMeta && Array.isArray(stylistMeta.doesNotOffer) && stylistMeta.doesNotOffer.length) {
    availableServices = availableServices.filter(function(s) {
      return !stylistMeta.doesNotOffer.some(function(bad) { return s.name.indexOf(bad) !== -1; });
    });
  }

  // Auto-set default service if current selection invalid
  useEffect(function() {
    if (availableServices.length === 0) return;
    if (!service || !availableServices.some(function(s) { return s.name === service; })) {
      setService(availableServices[0].name);
    }
  }, [stylist, availableServices.length]);

  var selected = availableServices.find(function(s) { return s.name === service; });
  var duration = selected ? selected.duration : 45;

  // End time calc
  function addMinutes(hhmm, mins) {
    var parts = hhmm.split(":");
    var total = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10) + mins;
    var h = Math.floor(total / 60), m = total % 60;
    return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
  }
  var endTime = addMinutes(startTime, duration);

  var timeOptions = [];
  for (var h = 9; h <= 17; h++) {
    for (var m = 0; m < 60; m += 15) {
      var val = String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
      var h12 = h > 12 ? h - 12 : (h === 0 ? 12 : h);
      var label = h12 + ":" + String(m).padStart(2, "0") + (h >= 12 ? "pm" : "am");
      timeOptions.push({ val: val, label: label });
    }
  }

  function handleSave() {
    if (!clientName.trim()) { onSave(null, "Client name required"); return; }
    if (!clientEmail.trim() && !clientPhone.trim()) { onSave(null, "Email or phone required"); return; }
    if (!service) { onSave(null, "Select a service"); return; }
    var basePayload = {
      clientName: clientName.trim(),
      clientEmail: clientEmail.trim(),
      clientPhone: clientPhone.trim(),
      stylist: stylist,
      service: service,
      date: date,
      startTime: startTime,
      durationMins: duration,
      priceCharged: price ? parseFloat(price) : null,
      depositPaid: depositPaid,
      bookedVia: "In-Salon",
      notes: notes.trim()
    };
    function submit(withOverride) {
      var payload = basePayload;
      if (withOverride) {
        payload = Object.assign({}, basePayload, {
          overrideValidation: true,
          overrideReason: "Staff confirmed book-anyway despite cap/conflict"
        });
      }
      setSaving(true);
      fetch(BOOKING_CREATE_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }).then(function(r) {
        return r.json().then(function(j) { return { ok: r.ok, body: j }; }).catch(function() { return { ok: r.ok, body: null }; });
      }).then(function(res) {
        if (res.ok) {
          var ref = res.body && (res.body.bookingKey || res.body.bookingRef) ? " (" + (res.body.bookingKey || res.body.bookingRef) + ")" : "";
          var prefix = withOverride ? "Booking saved (override) for " : "Booking saved for ";
          onSave(prefix + clientName.trim() + ref);
          return;
        }
        // FIX-072 (2026-05-16): WF41 returns HTTP 409 + structured body on
        // SLOT_CONFLICT / DAY_AT_CAP. 2026-05-18: offer override on those two
        // reasons only — Catherine has explicitly authorised book-anyway in
        // some cases. Other errors (missing fields etc.) are not overridable.
        var b = res.body || {};
        if (!withOverride && (b.reason === "SLOT_CONFLICT" || b.reason === "DAY_AT_CAP")) {
          setSaving(false);
          var prompt = (b.message || "Catherine is fully booked.") +
            "\n\nBook anyway? Catherine has approved running over cap or in parallel slots in special cases. The override will be flagged in the calendar event description.";
          if (window.confirm(prompt)) { submit(true); return; }
          // user declined override — fall through to standard error message
        }
        var msg = b.message || "Failed to save booking";
        if (b.suggestedTimes && b.suggestedTimes.length) {
          msg += " Try: " + b.suggestedTimes.slice(0, 4).join(", ") + ".";
        }
        onSave(null, msg);
      }).catch(function() {
        onSave(null, "Failed to save booking");
      }).finally(function() { setSaving(false); });
    }
    submit(false);
  }

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal", style: { maxWidth: 520 } },
      React.createElement("h3", null, "New Booking"),
      kbErr && React.createElement("div", { style: { fontSize: 11, color: "#c44", marginBottom: 8 } }, "Could not load service list — using defaults"),
      !kb && !kbErr && React.createElement("div", { style: { fontSize: 11, color: "#8B734A", marginBottom: 8 } }, "Loading services..."),

      React.createElement("label", null, "Find existing client (name, phone, or email)"),
      React.createElement("div", { style: { position: "relative", marginBottom: 4 } },
        React.createElement("input", {
          style: { width: "100%" },
          value: clientQuery,
          onChange: function(e) { setClientQuery(e.target.value); setClientPicked(false); },
          placeholder: "Start typing to search…",
          autoFocus: true
        }),
        clientPicked && React.createElement("button", {
          type: "button",
          onClick: clearPick,
          style: { position: "absolute", right: 6, top: 6, fontSize: 11, padding: "2px 8px", background: "transparent", border: "1px solid rgba(139,115,74,0.4)", borderRadius: 3, cursor: "pointer", color: "#8B734A" }
        }, "Clear"),
        clientMatches.length > 0 && !clientPicked && React.createElement("div", {
          style: { position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid rgba(139,115,74,0.3)", borderRadius: 4, marginTop: 2, maxHeight: 240, overflowY: "auto", zIndex: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }
        },
          clientMatches.map(function(c) {
            var sub = [c.email, c.phone].filter(Boolean).join(" · ");
            var visit = c.last_visit_date ? "Last visit " + c.last_visit_date : "New client";
            return React.createElement("div", {
              key: c.id,
              onClick: function() { pickClient(c); },
              style: { padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid rgba(139,115,74,0.1)", fontSize: 13 },
              onMouseEnter: function(e) { e.currentTarget.style.background = "rgba(139,115,74,0.08)"; },
              onMouseLeave: function(e) { e.currentTarget.style.background = "transparent"; }
            },
              React.createElement("div", { style: { fontWeight: 600, color: "#2A2131" } }, c.name || "(no name)"),
              sub && React.createElement("div", { style: { fontSize: 11, color: "#8A8490" } }, sub),
              React.createElement("div", { style: { fontSize: 10, color: "#8B734A" } }, visit + " · " + (c.total_visits || 0) + " visits")
            );
          })
        ),
        clientSearching && !clientPicked && React.createElement("div", { style: { fontSize: 10, color: "#8B734A", marginTop: 2 } }, "Searching…"),
        !clientSearching && clientQuery.trim().length >= 2 && clientMatches.length === 0 && !clientPicked &&
          React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 2 } }, "No match — fill in details below for a new client")
      ),

      React.createElement("label", null, "Client Name"),
      React.createElement("input", { style: { width: "100%" }, value: clientName, onChange: function(e) { setClientName(e.target.value); } , placeholder: "e.g. Sarah Jones" }),

      React.createElement("div", { style: { display: "flex", gap: 8 } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Email"),
          React.createElement("input", { type: "email", style: { width: "100%" }, value: clientEmail, onChange: function(e) { setClientEmail(e.target.value); }, placeholder: "name@example.com" })
        ),
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Phone"),
          React.createElement("input", { type: "tel", style: { width: "100%" }, value: clientPhone, onChange: function(e) { setClientPhone(e.target.value); }, placeholder: "07700 900000" })
        )
      ),

      React.createElement("label", null, "Stylist"),
      React.createElement("select", { style: { width: "100%" }, value: stylist, onChange: function(e) { setStylist(e.target.value); } },
        STYLISTS.map(function(s) { return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.role + ")"); })
      ),

      React.createElement("label", null, "Service"),
      React.createElement("select", { style: { width: "100%" }, value: service, onChange: function(e) { setService(e.target.value); }, disabled: availableServices.length === 0 },
        availableServices.length === 0 ?
          React.createElement("option", { value: "" }, "No services available") :
          availableServices.map(function(s) {
            return React.createElement("option", { key: s.name, value: s.name },
              s.name + " (" + s.duration + " min" + (s.price ? ", " + s.price : "") + ")"
            );
          })
      ),

      React.createElement("label", null, "Date"),
      React.createElement("input", { type: "date", style: { width: "100%" }, value: date, onChange: function(e) { setDate(e.target.value); } }),

      React.createElement("div", { style: { display: "flex", gap: 8 } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Start Time"),
          React.createElement("select", { style: { width: "100%" }, value: startTime, onChange: function(e) { setStartTime(e.target.value); } },
            timeOptions.map(function(t) { return React.createElement("option", { key: "s" + t.val, value: t.val }, t.label); })
          )
        ),
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "End Time"),
          React.createElement("input", { type: "text", style: { width: "100%", background: "rgba(139,115,74,0.06)" }, value: endTime, readOnly: true })
        )
      ),

      React.createElement("div", { style: { display: "flex", gap: 8, alignItems: "flex-end" } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Price Charged (\u00a3)"),
          React.createElement("input", { type: "number", step: "0.01", style: { width: "100%" }, value: price, onChange: function(e) { setPrice(e.target.value); }, placeholder: "Optional" })
        ),
        React.createElement("label", { style: { flex: 1, display: "flex", alignItems: "center", gap: 6, fontSize: 12, paddingBottom: 8 } },
          React.createElement("input", { type: "checkbox", checked: depositPaid, onChange: function(e) { setDepositPaid(e.target.checked); } }),
          "Deposit paid (POS)"
        )
      ),

      React.createElement("label", null, "Notes (optional)"),
      React.createElement("textarea", {
        style: { width: "100%", minHeight: 60, padding: "8px 10px", fontSize: 13, fontFamily: "'DM Sans',sans-serif", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, resize: "vertical" },
        value: notes, onChange: function(e) { setNotes(e.target.value); },
        placeholder: "Any internal notes about this booking..."
      }),

      React.createElement("div", { className: "cbd-btn-row" },
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose }, "Cancel"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: handleSave, disabled: saving || !kb }, saving ? "Saving..." : "Save Booking")
      )
    )
  );
}

// ===== DEPOSIT LINK MODAL (staff: mint + copy the £50 deposit link for a slot) =====
// Generates the canonical £50 deposit cart link via WF84 (cb-deposit-link) — the SAME
// single-source builder the salon-manager agent uses — so staff can send a deposit link
// when an automated channel (e.g. an Instagram DM outside the 24h window) can't deliver it.
// Mirrors the New Booking modal's KB-driven, per-stylist service list. Generate -> Copy,
// OR (v30) "Send by SMS" via the BEARER-GATED agent endpoint POST /api/deposit-link-sms
// (agent rebuilds the link via WF84 + sends via WF87 + logs to Communications). We do NOT
// browser-wire the raw cb-send-sms webhook — that's an unauthenticated Twilio relay (FIX-117
// class); the send goes through the agent's PII-Bearer-gated endpoint instead. The IG
// out-of-window auto-SMS-fallback is separately handled server-side by the agent (FIX-153).
function DepositLinkModal({ onClose }) {
  var _kb = useState(null), kb = _kb[0], setKb = _kb[1];
  var _kbErr = useState(false), kbErr = _kbErr[0], setKbErr = _kbErr[1];
  var _st = useState("Catherine"), stylist = _st[0], setStylist = _st[1];
  var _sv = useState(""), service = _sv[0], setService = _sv[1];
  var _dt = useState(fmtDate(getLondonDate())), date = _dt[0], setDate = _dt[1];
  var _tm = useState("10:00"), time = _tm[0], setTime = _tm[1];
  var _cn = useState(""), clientName = _cn[0], setClientName = _cn[1];
  var _busy = useState(false), busy = _busy[0], setBusy = _busy[1];
  var _err = useState(""), err = _err[0], setErr = _err[1];
  var _res = useState(null), res = _res[0], setRes = _res[1];
  var _copied = useState(""), copied = _copied[0], setCopied = _copied[1];
  var _to = useState(""), to = _to[0], setTo = _to[1];
  var _sending = useState(false), sending = _sending[0], setSending = _sending[1];
  var _sent = useState(""), sent = _sent[0], setSent = _sent[1];

  useEffect(function() {
    fetch(KB_API).then(function(r) { return r.json(); }).then(setKb).catch(function() { setKbErr(true); });
  }, []);

  var stylistKey = ({ "Catherine": "catherine", "Amber": "amber", "Jess L": "jessL", "Jess S": "jessS" })[stylist];
  var stylistMeta = (kb && kb.team) ? (kb.team || []).find(function(t) { return t.name === stylist; }) : null;
  var availableServices = [];
  if (kb && kb.pricing && stylistKey) {
    ["colourServices", "cuttingStyling"].forEach(function(g) {
      (kb.pricing[g] || []).forEach(function(s) {
        var price = s[stylistKey];
        if (!price) return;
        availableServices.push({ name: s.service, duration: s.slotDuration || 45, price: price });
      });
    });
    (kb.pricing.additionalServices || []).forEach(function(s) {
      if ((s.stylists || []).indexOf(stylist) === -1) return;
      availableServices.push({ name: s.service, duration: s.slotDuration || 45, price: s.price || "" });
    });
  }
  if (stylistMeta && Array.isArray(stylistMeta.doesNotOffer) && stylistMeta.doesNotOffer.length) {
    availableServices = availableServices.filter(function(s) {
      return !stylistMeta.doesNotOffer.some(function(bad) { return s.name.indexOf(bad) !== -1; });
    });
  }
  useEffect(function() {
    if (availableServices.length === 0) return;
    if (!service || !availableServices.some(function(s) { return s.name === service; })) {
      setService(availableServices[0].name);
    }
  }, [stylist, availableServices.length]);

  var timeOptions = [];
  for (var hh = 9; hh <= 17; hh++) {
    for (var mm = 0; mm < 60; mm += 15) {
      var val = String(hh).padStart(2, "0") + ":" + String(mm).padStart(2, "0");
      var h12 = hh > 12 ? hh - 12 : (hh === 0 ? 12 : hh);
      timeOptions.push({ val: val, label: h12 + ":" + String(mm).padStart(2, "0") + (hh >= 12 ? "pm" : "am") });
    }
  }

  function prettyDate(ymd) {
    var p = (ymd || "").split("-");
    if (p.length !== 3) return ymd || "";
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return parseInt(p[2], 10) + " " + (months[parseInt(p[1], 10) - 1] || "") + " " + p[0];
  }

  function smsText(url) {
    var who = clientName.trim() ? "Hi " + clientName.trim() + ", " : "Hi, ";
    return who + "to secure your " + service + " with " + stylist + " on " + prettyDate(date) + " at " + time +
      ", please pay your £50 deposit here: " + url + " Once it's paid your booking is confirmed. Colour Blend x";
  }

  function generate() {
    setErr(""); setRes(null); setCopied("");
    var selected = availableServices.find(function(s) { return s.name === service; });
    if (!service) { setErr("Select a service"); return; }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) { setErr("Pick a valid date"); return; }
    setBusy(true);
    fetch(DEPOSIT_LINK_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        service: service, stylist: stylist, date: date, time: time,
        duration: selected ? selected.duration : undefined,
        bookingPath: "staff-dashboard"
      })
    }).then(function(r) {
      return r.json().then(function(j) { return { ok: r.ok, body: j }; }).catch(function() { return { ok: r.ok, body: null }; });
    }).then(function(out) {
      var b = out.body || {};
      if (out.ok && b.ok && b.url) { setRes({ url: b.url }); return; }
      setErr((b && (b.message || (b.errors && b.errors.join(", ")))) || "Could not build a deposit link");
    }).catch(function() {
      setErr("Could not reach the deposit-link builder");
    }).finally(function() { setBusy(false); });
  }

  function copy(text, which) {
    function done() { setCopied(which); setTimeout(function() { setCopied(""); }, 1600); }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function() {});
        return;
      }
    } catch (e) {}
    var ta = document.createElement("textarea"); ta.value = text; document.body.appendChild(ta);
    ta.select(); try { document.execCommand("copy"); done(); } catch (e2) {} document.body.removeChild(ta);
  }

  // Send the £50 deposit link by salon-branded SMS via the BEARER-GATED agent endpoint
  // (the agent rebuilds the link via WF84 + sends via WF87 server-side + logs to Communications).
  // Never the raw unauthenticated cb-send-sms webhook (FIX-117 class).
  function sendSms() {
    setSent("");
    if (!service) { setSent("err:Select a service"); return; }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) { setSent("err:Pick a valid date"); return; }
    var toNum = (to || "").trim();
    if (toNum.replace(/\D/g, "").length < 7) { setSent("err:Enter the client's mobile"); return; }
    setSending(true);
    fetch(CB_AGENT_BASE + "/api/deposit-link-sms", {
      method: "POST",
      headers: Object.assign({ "Content-Type": "application/json" }, window.CB_AUTH ? window.CB_AUTH.headers() : {}),
      body: JSON.stringify({ service: service, stylist: stylist, date: date, time: time, to: toNum, name: clientName.trim() })
    }).then(function(r) {
      if (r.status === 401 && window.CB_AUTH) { window.CB_AUTH.onAuthFail(); throw new Error("__auth__"); }
      return r.json().then(function(j) { return { ok: r.ok, body: j }; }).catch(function() { return { ok: r.ok, body: null }; });
    }).then(function(out) {
      var b = out.body || {};
      // success contract (verified live 2026-06-16): endpoint returns {status:"ok",...}; accept ok:true for forward-compat
      if (out.ok && b && (b.status === "ok" || b.ok === true)) { setSent("ok:Sent the deposit link to " + toNum); }
      else { setSent("err:" + ((b && (b.error || b.message || b.status)) || "Send failed")); }
    }).catch(function(e) {
      setSent(e && e.message === "__auth__" ? "err:Session expired — re-enter PIN" : "err:Could not reach the SMS sender");
    }).finally(function() { setSending(false); });
  }

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal", style: { maxWidth: 460 } },
      React.createElement("h3", null, "Deposit Link"),
      React.createElement("p", { style: { fontSize: 11, color: "#8B734A", marginTop: -8, marginBottom: 12 } },
        "Generate the £50 deposit link for a slot, then copy it (or the ready message) to send by email, SMS or DM."),
      kbErr && React.createElement("div", { style: { fontSize: 11, color: "#c44", marginBottom: 8 } }, "Could not load service list from the KB"),
      !kb && !kbErr && React.createElement("div", { style: { fontSize: 11, color: "#8B734A", marginBottom: 8 } }, "Loading services..."),

      React.createElement("label", null, "Stylist"),
      React.createElement("select", { style: { width: "100%" }, value: stylist, onChange: function(e) { setStylist(e.target.value); } },
        STYLISTS.map(function(s) { return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.role + ")"); })
      ),

      React.createElement("label", null, "Service"),
      React.createElement("select", { style: { width: "100%" }, value: service, onChange: function(e) { setService(e.target.value); }, disabled: availableServices.length === 0 },
        availableServices.length === 0 ?
          React.createElement("option", { value: "" }, "No services available") :
          availableServices.map(function(s) {
            return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.duration + " min" + (s.price ? ", " + s.price : "") + ")");
          })
      ),

      React.createElement("div", { style: { display: "flex", gap: 8 } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Date"),
          React.createElement("input", { type: "date", style: { width: "100%" }, value: date, onChange: function(e) { setDate(e.target.value); } })
        ),
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Time"),
          React.createElement("select", { style: { width: "100%" }, value: time, onChange: function(e) { setTime(e.target.value); } },
            timeOptions.map(function(t) { return React.createElement("option", { key: t.val, value: t.val }, t.label); })
          )
        )
      ),

      React.createElement("label", null, "Client name (optional — for the message)"),
      React.createElement("input", { style: { width: "100%" }, value: clientName, onChange: function(e) { setClientName(e.target.value); }, placeholder: "e.g. Kirsty" }),

      React.createElement("label", null, "Client mobile (to send by SMS)"),
      React.createElement("input", { type: "tel", style: { width: "100%" }, value: to, onChange: function(e) { setTo(e.target.value); }, placeholder: "07… (optional — only needed to text the link)" }),

      sent && React.createElement("div", { style: { fontSize: 12, marginTop: 10, fontWeight: 500, color: sent.indexOf("ok:") === 0 ? "#2e7d32" : "#c83c3c" } }, sent.replace(/^(ok|err):/, "")),

      err && React.createElement("div", { style: { fontSize: 12, color: "#c83c3c", marginTop: 12 } }, err),

      res && React.createElement("div", { style: { marginTop: 14, padding: 12, background: "rgba(139,115,74,0.07)", borderRadius: 6, border: "1px solid rgba(139,115,74,0.18)" } },
        React.createElement("label", { style: { marginTop: 0 } }, "Deposit link"),
        React.createElement("input", { readOnly: true, value: res.url, onFocus: function(e) { e.target.select(); }, style: { width: "100%", fontSize: 11, background: "#fff" } }),
        React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 10 } },
          React.createElement("button", { className: "cbd-btn cbd-btn-primary", style: { flex: 1 }, onClick: function() { copy(res.url, "link"); } }, copied === "link" ? "Copied!" : "Copy link"),
          React.createElement("button", { className: "cbd-btn cbd-btn-secondary", style: { flex: 1 }, onClick: function() { copy(smsText(res.url), "msg"); } }, copied === "msg" ? "Copied!" : "Copy message")
        ),
        React.createElement("p", { style: { fontSize: 10, color: "#8A8490", marginTop: 8 } }, "Paste into your reply, an SMS, or the customer's email. Once they pay, the booking confirms automatically.")
      ),

      React.createElement("div", { className: "cbd-btn-row" },
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose }, "Close"),
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: sendSms, disabled: sending || !service || !to.trim() }, sending ? "Sending..." : "Send by SMS"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: generate, disabled: busy || !kb || !service }, busy ? "Generating..." : "Generate link")
      )
    )
  );
}

// ===== EDIT BOOKING MODAL (existing booking — staff full flexibility) =====
// Opens when a booking chip is clicked. Pre-fills from the calendar event, lets staff
// change client name / service / stylist / date / start / end / notes, and offers
// a Cancel Booking action. Wires to MANAGE_API (cb-booking-manage) — same endpoint
// the team-calendar page uses for add/edit/delete.
function EditBookingModal({ event, currentStylist, currentDate, onClose, onSave }) {
  var parsed = parseClientAndService(event.summary || "");
  var _kb = useState(null), kb = _kb[0], setKb = _kb[1];
  var _kbErr = useState(false), kbErr = _kbErr[0], setKbErr = _kbErr[1];
  var _st = useState(currentStylist || "Catherine"), stylist = _st[0], setStylist = _st[1];
  var _sv = useState(parsed.service || ""), service = _sv[0], setService = _sv[1];
  var _cn = useState(parsed.client || ""), clientName = _cn[0], setClientName = _cn[1];
  var _d = useState(currentDate || fmtDate(getLondonDate())), date = _d[0], setDate = _d[1];
  var _s = useState(event.startTime || "10:00"), startTime = _s[0], setStartTime = _s[1];
  // FIX-054 — derive endTime from startTime + 45min when missing, not the literal "10:45".
  // The old default produced endTime BEFORE startTime when staff edited startTime, sending
  // garbage to Google Calendar (WF17 "Bad request"). Compute a sensible default instead.
  var _defaultEnd = (function() {
    var s = event.startTime || "10:00";
    var parts = s.split(":").map(Number);
    if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return "10:45";
    var mins = parts[0] * 60 + parts[1] + 45;
    return String(Math.floor(mins / 60)).padStart(2, "0") + ":" + String(mins % 60).padStart(2, "0");
  })();
  var _e = useState(event.endTime || _defaultEnd), endTime = _e[0], setEndTime = _e[1];
  var _no = useState(event.description || ""), notes = _no[0], setNotes = _no[1];
  var _saving = useState(false), saving = _saving[0], setSaving = _saving[1];
  var _confirm = useState(false), confirmCancel = _confirm[0], setConfirmCancel = _confirm[1];

  useEffect(function() {
    fetch(KB_API).then(function(r) { return r.json(); }).then(setKb).catch(function() { setKbErr(true); });
  }, []);

  var stylistMeta = (kb && kb.team) ? (kb.team || []).find(function(t) { return t.name === stylist; }) : null;
  var stylistKey = ({ "Catherine": "catherine", "Amber": "amber", "Jess L": "jessL", "Jess S": "jessS" })[stylist];
  var availableServices = [];
  if (kb && kb.pricing && stylistKey) {
    ["colourServices", "cuttingStyling"].forEach(function(g) {
      (kb.pricing[g] || []).forEach(function(s) {
        var p = s[stylistKey];
        if (!p) return;
        availableServices.push({ name: s.service, duration: s.slotDuration || 45, price: p });
      });
    });
    (kb.pricing.additionalServices || []).forEach(function(s) {
      if ((s.stylists || []).indexOf(stylist) === -1) return;
      availableServices.push({ name: s.service, duration: s.slotDuration || 45, price: s.price || "" });
    });
  }
  if (stylistMeta && Array.isArray(stylistMeta.doesNotOffer) && stylistMeta.doesNotOffer.length) {
    availableServices = availableServices.filter(function(s) {
      return !stylistMeta.doesNotOffer.some(function(bad) { return s.name.indexOf(bad) !== -1; });
    });
  }

  function addMinutes(hhmm, mins) {
    var p = hhmm.split(":");
    var total = parseInt(p[0], 10) * 60 + parseInt(p[1], 10) + mins;
    var h = Math.floor(total / 60), m = total % 60;
    return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
  }
  function onServiceChange(newService) {
    setService(newService);
    var sel = availableServices.find(function(s) { return s.name === newService; });
    if (sel && sel.duration) setEndTime(addMinutes(startTime, sel.duration));
  }

  var timeOptions = [];
  for (var h = 9; h <= 18; h++) {
    for (var m = 0; m < 60; m += 15) {
      var val = String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
      timeOptions.push({ val: val, label: val });
    }
  }

  function handleSave() {
    if (!clientName.trim()) { onSave(null, "Client name required"); return; }
    setSaving(true);
    var stylistChanged = stylist !== currentStylist;
    var payload = {
      stylist: stylist,
      eventId: event.eventId,
      clientName: clientName.trim(),
      service: service,
      date: date,
      startTime: startTime,
      endTime: endTime,
      notes: notes
    };
    var p;
    if (stylistChanged) {
      // Move between stylist calendars: delete from old, create on new.
      p = fetch(MANAGE_API, { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "delete", stylist: currentStylist, eventId: event.eventId }) })
        .then(function() {
          return fetch(MANAGE_API, { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify(Object.assign({ action: "add" }, payload)) });
        });
    } else {
      p = fetch(MANAGE_API, { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify(Object.assign({ action: "edit" }, payload)) });
    }
    p.then(function(r) {
      if (r && r.ok === false) throw new Error("save failed: HTTP " + r.status);
      onSave("Booking updated");
    }).catch(function(err) {
      console.error("Edit booking save failed:", err);
      onSave(null, "Failed to update booking — check console");
    }).finally(function() { setSaving(false); });
  }

  // Parse email/phone from the booking's calendar description (CB-02 puts them there).
  function extractEmail(text) {
    var m = String(text || "").match(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/);
    return m ? m[0] : "";
  }
  function extractPhone(text) {
    var m = String(text || "").match(/(?:\+?\d[\d\s().-]{8,16}\d)/);
    return m ? m[0].replace(/[^\d+]/g, "") : "";
  }
  var bookingEmail = extractEmail(notes) || extractEmail(event.summary || "");
  var bookingPhone = extractPhone(notes);

  function handleReschedule() {
    if (!clientName.trim()) { onSave(null, "Client name required"); return; }
    if (!bookingEmail && !bookingPhone) {
      onSave(null, "Cannot reschedule — no email or phone found in booking notes. Use Save instead (silent edit).");
      return;
    }
    var changes = [];
    if (date !== currentDate) changes.push("date → " + date);
    if (startTime !== (event.startTime || "")) changes.push("time → " + startTime);
    if (stylist !== currentStylist) changes.push("stylist → " + stylist);
    if (changes.length === 0) {
      onSave(null, "No changes to reschedule. Edit a field first.");
      return;
    }
    if (!window.confirm("Reschedule " + clientName + "?\n\n" + changes.join("\n") + "\n\nThe client will receive a confirmation email at " + (bookingEmail || bookingPhone) + ".")) return;
    var basePayload = {
      customer_name: clientName.trim(),
      customer_email: bookingEmail,
      customer_phone: bookingPhone,
      new_preferred_date: date,
      new_preferred_time: startTime,
      channel: "staff-dashboard"
    };
    if (stylist !== currentStylist) basePayload.new_stylist = stylist;
    // Only send new_service if it differs and is in the KB list (avoid sending the legacy "(current)" placeholder)
    var legacyService = parsed.service || "";
    if (service && service !== legacyService) basePayload.new_service = service;
    function submit(withOverride) {
      var payload = withOverride
        ? Object.assign({}, basePayload, { overrideValidation: true, overrideReason: "Staff confirmed reschedule-anyway despite conflict" })
        : basePayload;
      setSaving(true);
      fetch(RESCHEDULE_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function(r) {
          return r.json().then(function(j) { return { ok: r.ok, body: j, status: r.status }; }).catch(function() { return { ok: r.ok, body: null, status: r.status }; });
        })
        .then(function(res) {
          var b = res.body || {};
          // 2026-05-18 — offer override on TIME_CONFLICT (WF38 returns valid:false + reason)
          if (!withOverride && (b.reason === "TIME_CONFLICT" || b.reason === "DAY_AT_CAP")) {
            setSaving(false);
            var prompt = (b.error || "Stylist already has an appointment at that time.") +
              "\n\nReschedule anyway? Catherine has approved double-booking in special cases. The override will be flagged in the calendar event description.";
            if (window.confirm(prompt)) { submit(true); return; }
            onSave(null, "Reschedule cancelled — " + (b.error || "time conflict"));
            return;
          }
          if (!res.ok || b.error) {
            var msg = b.error || b.message || ("HTTP " + res.status);
            onSave(null, "Reschedule failed — " + msg);
            return;
          }
          var suffix = withOverride ? " (override)" : "";
          onSave("Reschedule confirmed" + suffix + " — client emailed");
        })
        .catch(function(err) {
          console.error("Reschedule failed:", err);
          onSave(null, "Reschedule failed — " + (err.message || "check console"));
        })
        .finally(function() { setSaving(false); });
    }
    submit(false);
  }

  // Cancel via CB-39 — removes the calendar event, marks Airtable cancelled, emails the client
  // a cancellation confirmation, and applies the 48hr deposit policy.
  var CANCEL_API = "https://n8n.catherineboden.com/webhook/cb-cancel";
  function handleCancelBooking() {
    // FIX-119 (marium razzaq fumble guard): Cancel and Reschedule share the modal footer, and
    // Cancel acts by CUSTOMER IDENTITY (not slot) → cancelling a just-edited booking cancels the
    // live booking and fires a spurious deposit/refund alert. If date/time/stylist were edited the
    // staffer is almost certainly mid-reschedule, so warn before proceeding. Additive — an unedited
    // Cancel is unchanged.
    var editedForReschedule = (date !== currentDate) || (startTime !== (event.startTime || "")) || (stylist !== currentStylist);
    if (editedForReschedule) {
      if (!window.confirm(
        "You've changed the date/time/stylist for " + (clientName || "this booking") + ".\n\n" +
        "Did you mean RESCHEDULE? The Reschedule button moves the booking and emails the client.\n\n" +
        "Cancel Booking will CANCEL this booking entirely (and may trigger a deposit/refund alert) — it will NOT move it.\n\n" +
        "Press OK only if you genuinely want to cancel."
      )) return;
    }
    var who = clientName || "this booking";
    if (!bookingEmail && !bookingPhone) {
      // Fallback to silent delete if there's no contact info to email/lookup with.
      if (!window.confirm("Cancel " + who + "?\n\nNo email/phone in booking notes — falling back to silent delete (no client email).")) return;
      setSaving(true);
      fetch(MANAGE_API, { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", stylist: currentStylist, eventId: event.eventId }) })
        .then(function(r) { if (!r.ok) throw new Error("HTTP " + r.status); onSave("Booking cancelled (no email sent)"); })
        .catch(function(err) { console.error("Cancel failed:", err); onSave(null, "Failed to cancel — check console"); })
        .finally(function() { setSaving(false); });
      return;
    }
    if (!window.confirm("Cancel " + who + " on " + date + " at " + startTime + " with " + currentStylist + "?\n\nThe client will be emailed a cancellation confirmation at " + (bookingEmail || bookingPhone) + ". Within 48hrs: deposit non-refundable per policy.")) return;
    setSaving(true);
    fetch(CANCEL_API, { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_name: clientName.trim(),
        customer_email: bookingEmail || "",
        customer_phone: bookingPhone || "",
        channel: "staff-dashboard"
      }) })
      .then(function(r) {
        return r.json().then(function(j) { return { ok: r.ok, body: j, status: r.status }; }).catch(function() { return { ok: r.ok, body: null, status: r.status }; });
      })
      .then(function(res) {
        // WF39 returns 200 with { success, path, message } in all branches.
        //   path === 'cancelled_with_refund' → actually cancelled (calendar deleted, Airtable updated, emails sent)
        //   path === 'within_48hr'           → blocked by deposit policy (staff cancels bypass this, so should not hit from dashboard)
        //   path === 'error' / success false → booking not found or upstream error
        var b = res.body || {};
        if (!res.ok || b.success === false || (b.error && !b.path)) {
          throw new Error(b.error || b.message || ("HTTP " + res.status));
        }
        if (b.path && b.path !== 'cancelled_with_refund') {
          throw new Error(b.message || ("Could not cancel — server returned " + b.path));
        }
        onSave("Cancelled — client emailed");
      })
      .catch(function(err) {
        console.error("Cancel booking failed:", err);
        onSave(null, "Failed to cancel — " + (err.message || "check console"));
      })
      .finally(function() { setSaving(false); });
  }

  // Show the current service even if KB doesn't list it (legacy bookings imported with non-standard names)
  var serviceInList = availableServices.some(function(s) { return s.name === service; });

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal", style: { maxWidth: 520 } },
      React.createElement("h3", null, "Edit Booking"),
      kbErr && React.createElement("div", { style: { fontSize: 11, color: "#c44", marginBottom: 8 } }, "Could not load services"),
      !kb && !kbErr && React.createElement("div", { style: { fontSize: 11, color: "#8B734A", marginBottom: 8 } }, "Loading services..."),

      React.createElement("label", null, "Client Name"),
      React.createElement("input", { style: { width: "100%" }, value: clientName, onChange: function(e) { setClientName(e.target.value); } }),

      React.createElement("label", null, "Service"),
      React.createElement("select", { style: { width: "100%" }, value: service, onChange: function(e) { onServiceChange(e.target.value); }, disabled: !kb },
        !serviceInList && service ? React.createElement("option", { value: service }, service + " (current)") : null,
        availableServices.map(function(s) {
          return React.createElement("option", { key: s.name, value: s.name },
            s.name + " (" + s.duration + " min" + (s.price ? ", " + s.price : "") + ")");
        })
      ),

      React.createElement("label", null, "Stylist"),
      React.createElement("select", { style: { width: "100%" }, value: stylist, onChange: function(e) { setStylist(e.target.value); } },
        STYLISTS.map(function(s) { return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.role + ")"); })
      ),

      React.createElement("label", null, "Date"),
      React.createElement("input", { type: "date", style: { width: "100%" }, value: date, onChange: function(e) { setDate(e.target.value); } }),

      React.createElement("div", { style: { display: "flex", gap: 8 } },
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "Start"),
          React.createElement("select", { style: { width: "100%" }, value: startTime, onChange: function(e) { setStartTime(e.target.value); } },
            timeOptions.map(function(t) { return React.createElement("option", { key: t.val, value: t.val }, t.label); })
          )
        ),
        React.createElement("div", { style: { flex: 1 } },
          React.createElement("label", null, "End"),
          React.createElement("select", { style: { width: "100%" }, value: endTime, onChange: function(e) { setEndTime(e.target.value); } },
            timeOptions.map(function(t) { return React.createElement("option", { key: t.val, value: t.val }, t.label); })
          )
        )
      ),

      React.createElement("label", null, "Notes"),
      React.createElement("textarea", { style: { width: "100%", minHeight: 60, fontFamily: "inherit" }, value: notes, onChange: function(e) { setNotes(e.target.value); } }),

      // Reschedule helper text — explains the difference between Save and Reschedule.
      React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 14, padding: "8px 10px", background: "rgba(139,115,74,0.06)", borderRadius: 4, lineHeight: 1.4 } },
        React.createElement("strong", { style: { color: "#8B734A" } }, "Save"), " = silent edit (no client email). ",
        React.createElement("strong", { style: { color: "#8B734A" } }, "Reschedule"), " = updates booking + emails the client a confirmation. Use ",
        React.createElement("strong", null, "Reschedule"), " when the change affects the client (date/time/stylist)."
      ),
      React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 12, alignItems: "center", flexWrap: "wrap" } },
        React.createElement("button", { className: "cbd-btn cbd-btn-danger", onClick: handleCancelBooking, disabled: saving, type: "button" }, saving ? "Working..." : "Cancel Booking"),
        React.createElement("div", { style: { flex: 1 } }),
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose, disabled: saving, type: "button" }, "Close"),
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: handleSave, disabled: saving, type: "button", title: "Silent edit — no client email" }, saving ? "Saving..." : "Save"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: handleReschedule, disabled: saving, type: "button", title: "Reschedule + email client" }, saving ? "..." : "Reschedule")
      )
    )
  );
}

// ===== RESCHEDULE SEARCH MODAL (top-level) =====
// Staff click "+ Reschedule" on the dashboard; this opens a search by name/email/phone,
// shows the matching client(s) + their upcoming bookings, then lets staff pick a booking
// and submit a reschedule via CB-38 (which emails the client a confirmation).
function RescheduleSearchModal({ onClose, onSave }) {
  var _q = useState(""), query = _q[0], setQuery = _q[1];
  var _searching = useState(false), searching = _searching[0], setSearching = _searching[1];
  var _err = useState(""), searchErr = _err[0], setSearchErr = _err[1];
  var _r = useState(null), results = _r[0], setResults = _r[1];
  var _sel = useState(null), selected = _sel[0], setSelected = _sel[1]; // { client, booking }
  var _kb = useState(null), kb = _kb[0], setKb = _kb[1];
  var _newDate = useState(""), newDate = _newDate[0], setNewDate = _newDate[1];
  var _newTime = useState(""), newTime = _newTime[0], setNewTime = _newTime[1];
  var _newStylist = useState(""), newStylist = _newStylist[0], setNewStylist = _newStylist[1];
  var _newService = useState(""), newService = _newService[0], setNewService = _newService[1];
  var _saving = useState(false), saving = _saving[0], setSaving = _saving[1];

  useEffect(function() {
    fetch(KB_API).then(function(r) { return r.json(); }).then(setKb).catch(function() {});
  }, []);

  function detectKey(q) {
    if (!q) return null;
    if (q.indexOf("@") > -1) return "email";
    if (/[\d+]/.test(q) && q.replace(/\D/g, "").length >= 7) return "phone";
    return "name";
  }

  function runSearch() {
    var q = (query || "").trim();
    if (!q) return;
    setSearching(true);
    setSearchErr("");
    setResults(null);
    var key = detectKey(q);
    var url = LOOKUP_API + "?scope=upcoming&" + key + "=" + encodeURIComponent(q);
    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.found) {
          setSearchErr("No client found matching \"" + q + "\".");
          setResults([]);
        } else {
          setResults(data.results || []);
        }
      })
      .catch(function(err) {
        console.error("Lookup failed:", err);
        setSearchErr("Lookup failed — try again.");
      })
      .finally(function() { setSearching(false); });
  }

  function pickBooking(client, booking) {
    setSelected({ client: client, booking: booking });
    setNewDate(booking.date || "");
    setNewTime((booking.time || "").substring(0, 5) || "");
    setNewStylist(booking.stylist || "");
    setNewService(booking.service || "");
  }

  // Build available services for the (possibly newly-chosen) stylist
  var stylistKey = ({ "Catherine": "catherine", "Amber": "amber", "Jess L": "jessL", "Jess S": "jessS" })[newStylist];
  var availableServices = [];
  if (kb && kb.pricing && stylistKey) {
    ["colourServices", "cuttingStyling"].forEach(function(g) {
      (kb.pricing[g] || []).forEach(function(s) {
        var p = s[stylistKey];
        if (!p) return;
        availableServices.push({ name: s.service, duration: s.slotDuration || 45 });
      });
    });
    (kb.pricing.additionalServices || []).forEach(function(s) {
      if ((s.stylists || []).indexOf(newStylist) === -1) return;
      availableServices.push({ name: s.service, duration: s.slotDuration || 45 });
    });
  }
  var serviceInList = availableServices.some(function(s) { return s.name === newService; });

  var timeOptions = [];
  for (var h = 9; h <= 18; h++) {
    for (var m = 0; m < 60; m += 15) {
      var v = String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
      timeOptions.push(v);
    }
  }

  function submitReschedule() {
    if (!selected) return;
    var c = selected.client, b = selected.booking;
    if (!c.email && !c.phone) {
      onSave(null, "Cannot reschedule — client record has no email or phone.");
      return;
    }
    var changes = [];
    if (newDate !== b.date) changes.push("date → " + newDate);
    if (newTime !== (b.time || "").substring(0, 5)) changes.push("time → " + newTime);
    if (newStylist !== b.stylist) changes.push("stylist → " + newStylist);
    if (newService !== b.service) changes.push("service → " + newService);
    if (changes.length === 0) {
      onSave(null, "No changes — adjust at least one field.");
      return;
    }
    if (!window.confirm("Reschedule " + c.name + "?\n\n" + changes.join("\n") + "\n\nClient will be emailed a confirmation at " + (c.email || c.phone) + ".")) return;
    var basePayload = {
      customer_name: c.name,
      customer_email: c.email || "",
      customer_phone: c.phone || "",
      new_preferred_date: newDate,
      new_preferred_time: newTime,
      channel: "staff-dashboard"
    };
    if (newStylist !== b.stylist) basePayload.new_stylist = newStylist;
    if (newService !== b.service && serviceInList) basePayload.new_service = newService;
    function submit(withOverride) {
      var payload = withOverride
        ? Object.assign({}, basePayload, { overrideValidation: true, overrideReason: "Staff confirmed reschedule-anyway despite conflict" })
        : basePayload;
      setSaving(true);
      fetch(RESCHEDULE_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function(r) {
          return r.json().then(function(j) { return { ok: r.ok, body: j, status: r.status }; }).catch(function() { return { ok: r.ok, body: null, status: r.status }; });
        })
        .then(function(res) {
          var bd = res.body || {};
          if (!withOverride && (bd.reason === "TIME_CONFLICT" || bd.reason === "DAY_AT_CAP")) {
            setSaving(false);
            var prompt = (bd.error || "Stylist already has an appointment at that time.") +
              "\n\nReschedule anyway? Catherine has approved double-booking in special cases. The override will be flagged in the calendar event description.";
            if (window.confirm(prompt)) { submit(true); return; }
            onSave(null, "Reschedule cancelled — " + (bd.error || "time conflict"));
            return;
          }
          if (!res.ok || bd.error) {
            var msg = bd.error || bd.message || ("HTTP " + res.status);
            onSave(null, "Reschedule failed — " + msg);
            return;
          }
          var suffix = withOverride ? " (override)" : "";
          onSave("Reschedule confirmed for " + c.name + suffix + " — client emailed");
        })
        .catch(function(err) {
          console.error("Reschedule failed:", err);
          onSave(null, "Reschedule failed — " + (err.message || "check console"));
        })
        .finally(function() { setSaving(false); });
    }
    submit(false);
  }

  // ----- Render -----
  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) onClose(); } },
    React.createElement("div", { className: "cb-modal", style: { maxWidth: 600 } },
      React.createElement("h3", null, selected ? "Reschedule Booking" : "Find Booking to Reschedule"),

      // SEARCH STEP
      !selected && React.createElement("div", null,
        React.createElement("p", { style: { fontSize: 12, color: "#8A8490", marginBottom: 10 } }, "Search by client name, email, or phone."),
        React.createElement("div", { style: { display: "flex", gap: 8 } },
          React.createElement("input", {
            style: { flex: 1, width: "auto" },
            value: query,
            onChange: function(e) { setQuery(e.target.value); },
            onKeyDown: function(e) { if (e.key === "Enter") runSearch(); },
            placeholder: "e.g. Sarah, sarah@example.com, 07700 900000",
            autoFocus: true
          }),
          React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: runSearch, disabled: searching || !query.trim(), type: "button" }, searching ? "..." : "Search")
        ),
        searchErr && React.createElement("div", { style: { marginTop: 12, padding: 10, fontSize: 12, color: "#c44", background: "rgba(220,80,80,0.08)", borderRadius: 4 } }, searchErr),
        results && results.length > 0 && React.createElement("div", { style: { marginTop: 16, maxHeight: 400, overflowY: "auto" } },
          results.map(function(r, ri) {
            var c = r.client;
            return React.createElement("div", { key: ri, style: { padding: "10px 12px", marginBottom: 8, background: "rgba(139,115,74,0.04)", borderRadius: 6, border: "1px solid rgba(139,115,74,0.12)" } },
              React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: "#2A2131" } }, c.name),
              React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 2 } },
                (c.email || "(no email)") + (c.phone ? " · " + c.phone : "")
              ),
              r.bookings.length === 0 ?
                React.createElement("div", { style: { fontSize: 11, color: "#8A8490", fontStyle: "italic", marginTop: 6 } }, "No upcoming bookings") :
                r.bookings.map(function(b, bi) {
                  return React.createElement("button", {
                    key: bi,
                    type: "button",
                    style: { display: "block", width: "100%", textAlign: "left", marginTop: 6, padding: "8px 10px", background: "#fff", border: "1px solid rgba(139,115,74,0.2)", borderRadius: 4, cursor: "pointer", fontSize: 12, color: "#2A2131" },
                    onClick: function() { pickBooking(c, b); }
                  },
                    React.createElement("strong", null, b.date + " " + (b.time || "").substring(0, 5)),
                    " — " + (b.service || "?") + " with " + (b.stylist || "?") + " (" + (b.status || "?") + ")"
                  );
                })
            );
          })
        ),
        React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" } },
          React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose, type: "button" }, "Close")
        )
      ),

      // RESCHEDULE STEP
      selected && React.createElement("div", null,
        React.createElement("div", { style: { padding: 10, marginBottom: 14, background: "rgba(139,115,74,0.06)", borderRadius: 4, fontSize: 12, color: "#2A2131" } },
          React.createElement("strong", null, selected.client.name), " — ",
          (selected.client.email || selected.client.phone || ""),
          React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 4 } },
            "Original: " + selected.booking.date + " " + (selected.booking.time || "").substring(0, 5) + " — " + (selected.booking.service || "?") + " with " + (selected.booking.stylist || "?")
          )
        ),

        React.createElement("label", null, "New Date"),
        React.createElement("input", { type: "date", style: { width: "100%" }, value: newDate, onChange: function(e) { setNewDate(e.target.value); } }),

        React.createElement("div", { style: { display: "flex", gap: 8 } },
          React.createElement("div", { style: { flex: 1 } },
            React.createElement("label", null, "New Time"),
            React.createElement("select", { style: { width: "100%" }, value: newTime, onChange: function(e) { setNewTime(e.target.value); } },
              timeOptions.map(function(t) { return React.createElement("option", { key: t, value: t }, t); })
            )
          ),
          React.createElement("div", { style: { flex: 1 } },
            React.createElement("label", null, "New Stylist"),
            React.createElement("select", { style: { width: "100%" }, value: newStylist, onChange: function(e) { setNewStylist(e.target.value); } },
              STYLISTS.map(function(s) { return React.createElement("option", { key: s.name, value: s.name }, s.name); })
            )
          )
        ),

        React.createElement("label", null, "New Service"),
        React.createElement("select", { style: { width: "100%" }, value: newService, onChange: function(e) { setNewService(e.target.value); }, disabled: !kb },
          !serviceInList && newService ? React.createElement("option", { value: newService }, newService + " (current)") : null,
          availableServices.map(function(s) {
            return React.createElement("option", { key: s.name, value: s.name }, s.name + " (" + s.duration + " min)");
          })
        ),

        React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 16, alignItems: "center" } },
          React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: function() { setSelected(null); }, disabled: saving, type: "button" }, "← Back"),
          React.createElement("div", { style: { flex: 1 } }),
          React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: onClose, disabled: saving, type: "button" }, "Cancel"),
          React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: submitReschedule, disabled: saving, type: "button" }, saving ? "Sending..." : "Reschedule + Email Client")
        )
      )
    )
  );
}

// ===== MORNING BRIEFING PANEL =====
function MorningBriefing({ data, dateStr, closures }) {
  var today = getLondonDate();
  var isClosed = closures && closures.length > 0;
  var isSalonDay = today.getDay() >= 3 && today.getDay() <= 6;

  if (isClosed) {
    return React.createElement("div", {
      style: { background: "#c83c3c", borderRadius: 8, padding: "16px 20px", marginBottom: 24, textAlign: "center" }
    },
      React.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: "#fff", fontFamily: "'Cormorant Garamond',serif" } }, "SALON CLOSED TODAY"),
      React.createElement("div", { style: { fontSize: 12, color: "rgba(255,255,255,0.8)", marginTop: 4 } }, closures[0].summary || "Closure")
    );
  }

  if (!isSalonDay) {
    return React.createElement("div", {
      style: { background: "rgba(139,115,74,0.06)", borderRadius: 8, padding: "14px 20px", marginBottom: 24, textAlign: "center", border: "1px solid rgba(139,115,74,0.12)" }
    },
      React.createElement("div", { style: { fontSize: 14, fontWeight: 500, color: "#8B734A", fontFamily: "'Cormorant Garamond',serif" } }, "Salon closed today"),
      React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 2 } }, "Next open day is Wednesday")
    );
  }

  var stylistData = (data && data[dateStr] && data[dateStr].stylists) || {};
  var totalAppts = 0, totalCapacity = 0, openings = [];
  var cards = STYLISTS.map(function(st) {
    var evts = (stylistData[st.name] || []).filter(function(e) {
      var s = (e.summary || "").toUpperCase();
      return !s.includes("HOLIDAY") && !s.includes("BLOCK") && !s.includes("BREAK") && !s.includes("LUNCH") && !s.includes("MEETING");
    });
    var hasHoliday = (stylistData[st.name] || []).some(function(e) { return (e.summary || "").toUpperCase().includes("HOLIDAY"); });
    var cap = STYLIST_CAPACITY[st.name];
    var count = evts.length;
    totalAppts += count;
    if (cap) totalCapacity += cap;
    var isFull = cap && count >= cap;
    if (!hasHoliday && cap && count < cap) openings.push(st.name + " has " + (cap - count) + " opening" + (cap - count > 1 ? "s" : ""));
    return { name: st.name, color: st.color, count: count, cap: cap, isFull: isFull, hasHoliday: hasHoliday };
  });
  var pct = totalCapacity > 0 ? Math.round((totalAppts / totalCapacity) * 100) : 0;

  return React.createElement("div", {
    style: { background: "#2A2131", borderRadius: 8, padding: "16px 20px", marginBottom: 24, color: "#F6EFED" }
  },
    React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 } },
      React.createElement("div", null,
        React.createElement("div", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 18, fontWeight: 400 } }, "Morning Briefing"),
        React.createElement("div", { style: { fontSize: 11, color: "#C4A97A", marginTop: 2 } }, fmtDayLong(today))
      ),
      React.createElement("div", { style: { textAlign: "right" } },
        React.createElement("div", { style: { fontSize: 22, fontWeight: 700, color: "#C4A97A" } }, pct + "%"),
        React.createElement("div", { style: { fontSize: 9, color: "rgba(246,239,237,0.5)", textTransform: "uppercase", letterSpacing: "0.06em" } }, "capacity")
      )
    ),
    // Capacity bar
    React.createElement("div", { style: { height: 6, background: "rgba(246,239,237,0.1)", borderRadius: 3, marginBottom: 14, overflow: "hidden" } },
      React.createElement("div", { style: { height: "100%", width: Math.min(pct, 100) + "%", background: pct >= 90 ? "#4CAF50" : "#C4A97A", borderRadius: 3, transition: "width 0.6s ease" } })
    ),
    // Per-stylist row
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))", gap: 8, marginBottom: 10 } },
      cards.map(function(c) {
        return React.createElement("div", {
          key: c.name,
          style: { background: "rgba(246,239,237,0.06)", borderRadius: 6, padding: "8px 10px", borderTop: "2px solid " + c.color, textAlign: "center" }
        },
          React.createElement("div", { style: { fontSize: 11, fontWeight: 600, color: "#F6EFED" } }, c.name),
          c.hasHoliday ?
            React.createElement("div", { style: { fontSize: 14, fontWeight: 700, color: "#C4A97A", marginTop: 2 } }, "OFF") :
            React.createElement("div", { style: { marginTop: 2 } },
              React.createElement("span", { style: { fontSize: 18, fontWeight: 700, color: c.color } }, c.count),
              c.cap ? React.createElement("span", { style: { fontSize: 11, color: "rgba(246,239,237,0.5)" } }, "/" + c.cap) : null,
              c.isFull ? React.createElement("span", { style: { fontSize: 8, fontWeight: 700, color: "#4CAF50", background: "rgba(76,175,80,0.2)", padding: "1px 5px", borderRadius: 3, marginLeft: 4, textTransform: "uppercase" } }, "FULL") : null
            )
        );
      })
    ),
    // Openings
    openings.length > 0 && React.createElement("div", { style: { fontSize: 11, color: "#C4A97A", lineHeight: 1.5 } },
      openings.join("  |  ")
    )
  );
}

// ===== SERVICE LEGEND =====
function ServiceLegend() {
  var items = [
    { label: "Full Works", style: { background: "rgba(139,115,74,0.25)" } },
    { label: "Refresh", style: { background: "rgba(139,115,74,0.10)" } },
    { label: "Colour Correction", style: { background: "repeating-linear-gradient(135deg, rgba(139,115,74,0.12), rgba(139,115,74,0.12) 3px, rgba(139,115,74,0.04) 3px, rgba(139,115,74,0.04) 6px)" } },
    { label: "Cut / Blow Dry", style: { background: "transparent", border: "1px dashed #8B734A" } },
    { label: "Consultation", style: { background: "rgba(139,115,74,0.08)", fontSize: "smaller" } },
    { label: "Block / Break", style: { background: "rgba(138,132,144,0.12)" } }
  ];
  return React.createElement("div", {
    style: { display: "flex", gap: 10, flexWrap: "wrap", padding: "8px 0", marginBottom: 16, borderTop: "1px solid rgba(139,115,74,0.1)", paddingTop: 12 }
  },
    React.createElement("span", { style: { fontSize: 9, fontWeight: 600, color: "#8B734A", textTransform: "uppercase", letterSpacing: "0.05em", lineHeight: "20px" } }, "Key:"),
    items.map(function(item) {
      return React.createElement("div", { key: item.label, style: { display: "flex", alignItems: "center", gap: 4 } },
        React.createElement("div", { style: Object.assign({ width: 14, height: 14, borderRadius: 2, flexShrink: 0 }, item.style) }),
        React.createElement("span", { style: { fontSize: 10, color: "#8A8490" } }, item.label)
      );
    })
  );
}

// ===== CALENDAR TAB =====
function BookingPhotoButtons(props) {
  var ev = props.event;
  var _s = useState(""), status = _s[0], setStatus = _s[1];
  var _u = useState(""), uploading = _u[0], setUploading = _u[1];

  function trigger(kind, ev2) {
    var file = ev2.target.files && ev2.target.files[0];
    ev2.target.value = "";
    if (!file) return;
    uploadStaffPhoto({
      calendarEventId: ev.eventId || ev.id || "",
      kind: kind,
      file: file,
      onStart: function() { setUploading(kind); setStatus(""); },
      onDone: function() { setUploading(""); setStatus("✓ " + kind); setTimeout(function() { setStatus(""); }, 2400); },
      onError: function(msg) { setUploading(""); setStatus("✗ " + msg); setTimeout(function() { setStatus(""); }, 4000); }
    });
  }

  var btnStyle = { display:"inline-flex", alignItems:"center", gap:4, fontSize:9, fontWeight:600, color:"#8B734A", background:"rgba(139,115,74,0.08)", padding:"3px 8px", borderRadius:3, cursor:"pointer", border:"1px solid rgba(139,115,74,0.18)", letterSpacing:"0.04em", textTransform:"uppercase" };
  var disabled = !!uploading;
  if (disabled) btnStyle = Object.assign({}, btnStyle, { opacity:0.5, cursor:"wait" });

  return React.createElement("div", { style: { display:"flex", gap:6, alignItems:"center", marginTop:6, flexWrap:"wrap" } },
    React.createElement("label", { style: btnStyle, title: "Upload before photo" },
      React.createElement("span", null, uploading === "before" ? "···" : "📷"),
      React.createElement("span", null, " Before"),
      React.createElement("input", { type:"file", accept:"image/*", capture:"environment", style:{display:"none"}, onChange: function(e) { trigger("before", e); }, disabled: disabled })
    ),
    React.createElement("label", { style: btnStyle, title: "Upload after photo" },
      React.createElement("span", null, uploading === "after" ? "···" : "✨"),
      React.createElement("span", null, " After"),
      React.createElement("input", { type:"file", accept:"image/*", capture:"environment", style:{display:"none"}, onChange: function(e) { trigger("after", e); }, disabled: disabled })
    ),
    status && React.createElement("span", { style: { fontSize:9, color: status.charAt(0) === "✓" ? "#3a6a4a" : "#8a3a3a", fontWeight:500 } }, status)
  );
}

function CalendarTab() {
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _bm = useState(false), showBlockModal = _bm[0], setShowBlockModal = _bm[1];
  var _lm = useState(false), showLogModal = _lm[0], setShowLogModal = _lm[1];
  var _nb = useState(false), showNewBooking = _nb[0], setShowNewBooking = _nb[1];
  var _dl = useState(false), showDepositLink = _dl[0], setShowDepositLink = _dl[1];
  var _ee = useState(null), editEvent = _ee[0], setEditEvent = _ee[1];
  var _rs = useState(false), showReschedule = _rs[0], setShowReschedule = _rs[1];
  var _bt = useState(null), blockToast = _bt[0], setBlockToast = _bt[1];
  var _bte = useState(false), blockToastErr = _bte[0], setBlockToastErr = _bte[1];
  var today = getLondonDate();
  var dateStr = fmtDate(today);
  var dow = today.getDay();

  // FIX-050 — keep both string + Date form. Eliminates the parseDate round-trip from
  // the render, which was somehow returning Invalid Date in production despite identical
  // logic working in isolation. By storing the live Date object we never reparse.
  var tuesdayStr = null;
  var tuesdayDate = null;
  if (dow !== 2) {
    var tue = new Date(today.getTime());  // copy via timestamp — more reliable than new Date(today)
    var daysUntilTue = (2 - dow + 7) % 7;
    if (daysUntilTue === 0) daysUntilTue = 7;
    tue.setDate(tue.getDate() + daysUntilTue);
    tuesdayStr = fmtDate(tue);
    tuesdayDate = tue;
  } else {
    tuesdayStr = dateStr;
    tuesdayDate = today;
  }

  var fetchStart = dateStr < tuesdayStr ? dateStr : tuesdayStr;
  var fetchEnd = dateStr > tuesdayStr ? dateStr : tuesdayStr;

  useEffect(function() {
    setLoading(true);
    fetch(VIEW_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ startDate: fetchStart, endDate: fetchEnd, action: "getCalendarView" })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) { setData(d); setLoading(false); })
      .catch(function(err) { console.error("Calendar fetch failed:", err); setLoading(false); });
  }, [fetchStart, fetchEnd]);

  if (loading) {
    return React.createElement("div", { style: { textAlign: "center", padding: 60 } },
      React.createElement("div", { style: { width:24, height:24, border:"2px solid rgba(139,115,74,0.2)", borderTopColor:"#8B734A", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto 12px" } }),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A" } }, "Loading schedule...")
    );
  }

  var closures = (data && data[dateStr] && data[dateStr].closures) || [];
  var stylistData = (data && data[dateStr] && data[dateStr].stylists) || {};
  var isSalonDay = dow >= 3 && dow <= 6;

  // Build per-stylist event lists
  var perStylist = {};
  STYLISTS.forEach(function(st) { perStylist[st.name] = stylistData[st.name] || []; });

  // Flat list for count
  var allClientEvents = [];
  STYLISTS.forEach(function(st) {
    (stylistData[st.name] || []).forEach(function(ev) {
      var s = (ev.summary || "").toUpperCase();
      if (!s.includes("HOLIDAY") && !s.includes("CLOSED")) {
        allClientEvents.push(Object.assign({}, ev, { stylist: st.name }));
      }
    });
  });
  var clientCount = allClientEvents.length;

  // Tuesday consultations
  var tuesdayEvents = [];
  if (data && data[tuesdayStr]) {
    var catherineEvents = (data[tuesdayStr].stylists || {})["Catherine"] || [];
    catherineEvents.forEach(function(ev) { tuesdayEvents.push(Object.assign({}, ev, { stylist: "Catherine" })); });
  }
  tuesdayEvents.sort(function(a,b) { return (a.startTime || "").localeCompare(b.startTime || ""); });

  function handleModalSave(msg, errMsg) {
    setShowBlockModal(false);
    setShowLogModal(false);
    setShowNewBooking(false);
    if (errMsg) { setBlockToast(errMsg); setBlockToastErr(true); }
    else { setBlockToast(msg); setBlockToastErr(false); }
    setTimeout(function() { setBlockToast(null); }, 4000);
    if (!errMsg) setTimeout(function() { setData(null); setLoading(true); location.reload(); }, 1000);
  }

  return React.createElement("div", null,
    // Morning Briefing Panel
    React.createElement(MorningBriefing, { data: data, dateStr: dateStr, closures: closures }),
    // Header row
    React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:8 } },
      React.createElement("div", null,
        React.createElement("h3", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:400, color:"#2A2131" } }, "Today's Schedule"),
        React.createElement("p", { style: { fontSize:12, color:"#8B734A", marginTop:2 } }, fmtDayLong(today))
      ),
      React.createElement("div", { style: { display: "flex", gap: 6, flexWrap: "wrap" } },
        React.createElement("button", {
          className: "cbd-btn cbd-btn-primary",
          style: { fontSize:11, padding:"6px 14px" },
          onClick: function() { setShowNewBooking(true); }
        }, "+ New Booking"),
        React.createElement("button", {
          className: "cbd-btn cbd-btn-secondary",
          style: { fontSize:11, padding:"6px 14px" },
          onClick: function() { setShowDepositLink(true); }
        }, "Deposit Link"),
        React.createElement("button", {
          className: "cbd-btn cbd-btn-secondary",
          style: { fontSize:11, padding:"6px 14px" },
          onClick: function() { setShowReschedule(true); }
        }, "\u21BB Reschedule"),
        React.createElement("button", {
          className: "cbd-btn cbd-btn-secondary",
          style: { fontSize:11, padding:"6px 14px" },
          onClick: function() { setShowLogModal(true); }
        }, "\u260E Log Call"),
        React.createElement("button", {
          className: "cbd-btn cbd-btn-secondary",
          style: { fontSize:11, padding:"6px 14px" },
          onClick: function() { setShowBlockModal(true); }
        }, "Block Time")
      )
    ),
    showNewBooking && React.createElement(NewBookingModal, { onClose: function() { setShowNewBooking(false); }, onSave: handleModalSave }),
    showDepositLink && React.createElement(DepositLinkModal, { onClose: function() { setShowDepositLink(false); } }),
    showBlockModal && React.createElement(BlockTimeModal, { onClose: function() { setShowBlockModal(false); }, onSave: handleModalSave }),
    showLogModal && React.createElement(LogCallModal, { onClose: function() { setShowLogModal(false); }, onSave: handleModalSave }),
    showReschedule && React.createElement(RescheduleSearchModal, { onClose: function() { setShowReschedule(false); }, onSave: function(msg, errMsg) { setShowReschedule(false); handleModalSave(msg, errMsg); } }),
    editEvent && React.createElement(EditBookingModal, {
      event: editEvent.event,
      currentStylist: editEvent.stylist,
      currentDate: editEvent.date,
      onClose: function() { setEditEvent(null); },
      onSave: function(msg, errMsg) { setEditEvent(null); handleModalSave(msg, errMsg); }
    }),
    blockToast && React.createElement("div", {
      style: { padding:"10px 16px", marginBottom:16, borderRadius:6, fontSize:12, fontWeight:500, background: blockToastErr ? "rgba(220,80,80,0.1)" : "rgba(139,115,74,0.1)", color: blockToastErr ? "#c44" : "#8B734A", border: "1px solid " + (blockToastErr ? "rgba(220,80,80,0.3)" : "rgba(139,115,74,0.3)") }
    }, blockToast),
    // Service legend
    React.createElement(ServiceLegend, null),
    // Per-stylist columns (grid on desktop, stacked on mobile)
    React.createElement("div", { style: { display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))", gap:12, marginBottom:24 } },
      STYLISTS.map(function(st) {
        var evts = perStylist[st.name] || [];
        var hasHoliday = evts.some(function(e) { return (e.summary || "").toUpperCase().includes("HOLIDAY"); });
        var r = parseInt(st.color.slice(1,3), 16), g = parseInt(st.color.slice(3,5), 16), b = parseInt(st.color.slice(5,7), 16);
        return React.createElement("div", {
          key: st.name,
          style: { background:"#fff", borderRadius:8, overflow:"hidden", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }
        },
          // Stylist header with colour
          React.createElement("div", {
            style: { background: "rgba(" + r + "," + g + "," + b + ",0.3)", padding:"10px 12px", borderBottom:"2px solid " + st.color }
          },
            React.createElement("div", { style: { fontSize:13, fontWeight:700, color:"#2A2131" } }, st.name),
            React.createElement("div", { style: { fontSize:10, color:"#2A2131", opacity:0.7 } }, st.role)
          ),
          // Events
          React.createElement("div", { style: { padding:8, minHeight:60 } },
            hasHoliday ?
              React.createElement("div", { style: { textAlign:"center", padding:"16px 8px", color:"#8A8490", fontWeight:600, fontSize:14 } }, "OFF") :
              (!isSalonDay && evts.length === 0) ?
                React.createElement("div", { style: { textAlign:"center", padding:"12px 8px", color:"#8A8490", fontSize:11, fontStyle:"italic" } }, "Closed") :
                evts.length === 0 ?
                  React.createElement("div", { style: { textAlign:"center", padding:"12px 8px", color:"#8A8490", fontSize:11, fontStyle:"italic" } }, "No bookings") :
                  evts.map(function(ev, i) {
                    var sType = classifyService(ev.summary);
                    var evStyle = getEventStyle(sType, st.color);
                    var parsed = parseClientAndService(ev.summary);
                    var isBlock = sType === "blocked" || sType === "holiday";
                    // Real client bookings are clickable; blocks/holidays are not.
                    var clickStyle = isBlock ? evStyle : Object.assign({}, evStyle, { cursor: "pointer" });
                    return React.createElement("div", {
                      key: i,
                      style: clickStyle,
                      onClick: isBlock ? null : function(e) {
                        // Don't open the edit modal when the staff click the BEFORE/AFTER photo buttons.
                        if (e.target && e.target.closest && e.target.closest("button")) return;
                        setEditEvent({ event: ev, stylist: st.name, date: dateStr });
                      },
                      title: isBlock ? null : "Click to edit or cancel"
                    },
                      React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"flex-start" } },
                        React.createElement("div", { style: { fontSize:10, fontWeight:600, color:"#2A2131", opacity:0.7 } }, ev.startTime ? ev.startTime + (ev.endTime ? " - " + ev.endTime : "") : "All day"),
                        sType === "consultation" && React.createElement("span", { style: { fontSize:8, fontWeight:700, color:"#8B734A", background:"rgba(139,115,74,0.12)", padding:"1px 5px", borderRadius:3 } }, "CONSULT")
                      ),
                      React.createElement("div", { style: { fontSize:12, fontWeight: sType === "fullworks" ? 600 : 500, color: isBlock ? "#8A8490" : "#2A2131", marginTop:2 } },
                        isBlock ? ev.summary : parsed.client
                      ),
                      parsed.service && !isBlock && React.createElement("div", { style: { fontSize:10, color:"#8A8490", marginTop:1 } }, parsed.service),
                      !isBlock && React.createElement(BookingPhotoButtons, { event: ev })
                    );
                  })
          )
        );
      })
    ),
    // Overall count
    React.createElement("div", { style: { fontSize:11, fontWeight:600, color:"#8B734A", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:10 } },
      clientCount + " Booking" + (clientCount !== 1 ? "s" : "") + " Today"
    ),
    // Tuesday Consultations section
    React.createElement("div", { style: { marginTop:20, paddingTop:20, borderTop:"1px solid rgba(139,115,74,0.12)" } },
      React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 } },
        React.createElement("div", null,
          React.createElement("div", { style: { fontSize:11, fontWeight:600, color:"#8B734A", textTransform:"uppercase", letterSpacing:"0.05em" } }, "Tuesday Consultations"),
          React.createElement("p", { style: { fontSize:11, color:"#8A8490", marginTop:2 } },
            tuesdayStr === dateStr ? "Today" : (fmtDayLong(tuesdayDate) || tuesdayStr) + " (1pm - 3pm)"
          )
        ),
        React.createElement("div", { style: { fontSize:10, color:"#8B734A", background:"rgba(139,115,74,0.08)", padding:"3px 8px", borderRadius:3 } }, "Catherine only")
      ),
      tuesdayEvents.length === 0 ?
        React.createElement("p", { style: { fontSize:12, color:"#8A8490", fontStyle:"italic", paddingLeft:4 } }, "No consultations booked") :
        tuesdayEvents.map(function(ev, i) {
          var sType = classifyService(ev.summary);
          var evStyle = getEventStyle(sType, "#F5D76E");
          return React.createElement("div", {
            key: "tue-" + i,
            style: Object.assign({}, evStyle, { display:"flex", alignItems:"center", gap:12 })
          },
            React.createElement("div", { style: { fontSize:12, fontWeight:600, color:"#2A2131", width:44, flexShrink:0 } }, ev.startTime || ""),
            React.createElement("div", { style: { flex:1, fontSize:12, fontWeight:500, color:"#2A2131" } }, ev.summary)
          );
        })
    )
  );
}

// ===== HOLIDAYS TAB =====
function HolidaysTab() {
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _m = useState(false), showModal = _m[0], setShowModal = _m[1];
  var _t = useState(null), toast = _t[0], setToast = _t[1];
  var _te = useState(false), toastErr = _te[0], setToastErr = _te[1];
  var _del = useState(null), deleting = _del[0], setDeleting = _del[1];

  var today = getLondonDate();
  var startStr = fmtDate(today);
  var endDate = new Date(today);
  endDate.setMonth(endDate.getMonth() + 12);
  var endStr = fmtDate(endDate);

  var fetchData = useCallback(function() {
    setLoading(true);
    fetch(VIEW_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ startDate: startStr, endDate: endStr, action: "getCalendarView" })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) { setData(d); setLoading(false); })
      .catch(function() { setLoading(false); });
  }, [startStr, endStr]);

  useEffect(function() { fetchData(); }, [fetchData]);

  var holidays = [];
  if (data) {
    Object.keys(data).forEach(function(dateKey) {
      var dayData = data[dateKey];
      var stylists = dayData && dayData.stylists ? dayData.stylists : {};
      STYLISTS.forEach(function(st) {
        var evts = stylists[st.name] || [];
        evts.forEach(function(ev) {
          if (ev.summary && ev.summary.toUpperCase().includes("HOLIDAY")) {
            holidays.push({ stylist: st.name, date: dateKey, summary: ev.summary, eventId: ev.eventId, startTime: ev.startTime });
          }
        });
      });
    });
  }
  holidays.sort(function(a, b) { return a.date.localeCompare(b.date); });

  function handleDelete(stylist, eventId) {
    setDeleting(eventId);
    fetch(MANAGE_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "delete", stylist: stylist, eventId: eventId })
    })
    .then(function() {
      setToast("Holiday removed");
      setToastErr(false);
      setDeleting(null);
      setTimeout(fetchData, 500);
    })
    .catch(function() {
      setToast("Failed to remove");
      setToastErr(true);
      setDeleting(null);
    });
  }

  function handleSave(msg, errMsg) {
    setShowModal(false);
    if (errMsg) { setToast(errMsg); setToastErr(true); }
    else { setToast(msg); setToastErr(false); }
    setTimeout(fetchData, 500);
  }

  if (loading) {
    return React.createElement("div", { style: { textAlign: "center", padding: 60 } },
      React.createElement("div", { style: { width:24, height:24, border:"2px solid rgba(139,115,74,0.2)", borderTopColor:"#8B734A", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto 12px" } }),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A" } }, "Loading holidays...")
    );
  }

  return React.createElement("div", null,
    React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 } },
      React.createElement("div", null,
        React.createElement("h3", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:400, color:"#2A2131" } }, "Holidays & Time Off"),
        React.createElement("p", { style: { fontSize:12, color:"#8B734A", marginTop:2 } }, "Next 12 months")
      ),
      React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: function() { setShowModal(true); } }, "+ Add Holiday")
    ),
    // Holiday list grouped by stylist
    STYLISTS.map(function(st) {
      var stylistHolidays = holidays.filter(function(h) { return h.stylist === st.name; });
      return React.createElement("div", { key: st.name, style: { marginBottom:20 } },
        React.createElement("div", { style: { display:"flex", alignItems:"center", gap:8, marginBottom:8 } },
          React.createElement("div", { style: { width:10, height:10, borderRadius:"50%", background: st.color } }),
          React.createElement("span", { style: { fontSize:13, fontWeight:600, color:"#2A2131" } }, st.name),
          React.createElement("span", { style: { fontSize:11, color:"#8B734A" } }, "(" + stylistHolidays.length + " day" + (stylistHolidays.length !== 1 ? "s" : "") + ")")
        ),
        stylistHolidays.length === 0 ?
          React.createElement("p", { style: { fontSize:12, color:"#8A8490", fontStyle:"italic", paddingLeft:18, marginBottom:4 } }, "No holidays booked") :
          stylistHolidays.map(function(h) {
            var d = parseDate(h.date);
            var parts = h.summary.split(" \u2014 ");
            var reasonText = parts.length > 1 ? parts[1] : (h.summary.replace(/HOLIDAY\s*[-\u2014]?\s*/i, "") || "Holiday");
            return React.createElement("div", {
              key: h.eventId || h.date,
              style: { display:"flex", alignItems:"center", gap:10, padding:"8px 12px", background:"rgba(196,169,122,0.06)", borderRadius:4, marginBottom:4, marginLeft:18 }
            },
              React.createElement("div", { style: { fontSize:12, fontWeight:600, color:"#2A2131", width:90, flexShrink:0 } },
                DAYS[d.getDay()] + " " + d.getDate() + " " + MONTHS[d.getMonth()].substring(0,3)
              ),
              React.createElement("div", { style: { flex:1, fontSize:12, color:"#8B734A" } }, reasonText),
              React.createElement("button", {
                className: "cbd-btn cbd-btn-danger",
                style: { padding:"4px 10px", fontSize:10 },
                onClick: function() { handleDelete(h.stylist, h.eventId); },
                disabled: deleting === h.eventId
              }, deleting === h.eventId ? "..." : "\u2715")
            );
          })
      );
    }),
    showModal && React.createElement(AddHolidayModal, { onClose: function() { setShowModal(false); }, onSave: handleSave }),
    toast && React.createElement(Toast, { message: toast, isError: toastErr, onClose: function() { setToast(null); } })
  );
}

// ===== PERFORMANCE TAB =====
// ===== BUSINESS SUMMARY (Performance tab top block) =====
// Revenue (POS) · returning-client per stylist · reviews · complaints — via WF91 cb-business-metrics.
var METRICS_API = "https://n8n.catherineboden.com/webhook/cb-business-metrics";

function BusinessSummary(props) {
  var _m = useState(null), m = _m[0], setM = _m[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _e = useState(null), err = _e[0], setErr = _e[1];
  useEffect(function() {
    setLoading(true); setErr(null);
    fetch(METRICS_API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ startDate: props.startDate, endDate: props.endDate }) })
      .then(function(r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function(d) { setM(d); setLoading(false); })
      .catch(function(e) { setErr(e.message || "failed"); setLoading(false); });
  }, [props.startDate, props.endDate]);

  if (loading) return React.createElement("div", { style: { padding: "16px 0 24px", color: "#8B734A", fontSize: 12, textAlign: "center" } }, "Loading business summary...");
  if (err || !m || !m.ok) return React.createElement("div", { style: { padding: "12px 0 20px", color: "#9B8E8A", fontSize: 12 } }, "Business summary unavailable" + (err ? " (" + err + ")" : "") + ".");

  var t = m.totals || {};
  var money = function(n) { return "£" + (Number(n) || 0).toLocaleString("en-GB"); };
  var tile = function(label, value, sub, accent) {
    return React.createElement("div", { style: { background: "#fff", borderRadius: 6, padding: "14px 12px", textAlign: "center", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", borderTop: "2px solid " + (accent || "#8B734A") } },
      React.createElement("div", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 26, fontWeight: 600, color: "#2A2131" } }, value),
      React.createElement("div", { style: { fontSize: 10.5, color: "#8B734A", letterSpacing: "0.04em", textTransform: "uppercase", marginTop: 2 } }, label),
      sub ? React.createElement("div", { style: { fontSize: 10, color: "#9B8E8A", marginTop: 3 } }, sub) : null
    );
  };

  return React.createElement("div", { style: { marginBottom: 30 } },
    React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 400, color: "#2A2131", marginBottom: 2 } }, "Business performance"),
    React.createElement("p", { style: { fontSize: 12, color: "#8B734A", marginBottom: 14 } }, m.period ? ("Period " + m.period.start + " to " + m.period.end) : ""),
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px,1fr))", gap: 12, marginBottom: 18 } },
      tile("Revenue", money(t.revenue), m.revenueNote ? "POS - awaiting rollout" : ((t.transactions || 0) + " checkouts"), "#3E8E5A"),
      tile("Returning clients", (t.returningClients || 0), "of " + (t.totalClients || 0) + " (current)", "#89CFF0"),
      tile("Reviews", (m.reviews ? m.reviews.internalCount : 0), (m.reviews && m.reviews.avgRating ? m.reviews.avgRating + "★ avg" : "no ratings yet"), "#F5D76E"),
      tile("Complaints", (t.complaints || 0), "low ratings + staff issues", (t.complaints > 0 ? "#B23A48" : "#9B8E8A"))
    ),
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px,1fr))", gap: 12 } },
      STYLISTS.map(function(st) {
        var s = (m.byStylist || {})[st.name] || {};
        return React.createElement("div", { key: st.name, style: { background: "#fff", borderRadius: 6, padding: 14, borderLeft: "3px solid " + st.color, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" } },
          React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: "#2A2131", marginBottom: 8 } }, st.name),
          React.createElement("div", { style: { fontSize: 11.5, color: "#5C5158", lineHeight: 1.9 } },
            React.createElement("div", null, "Returning: ", React.createElement("strong", null, (s.returningClients || 0)), (s.returningRate != null ? " (" + s.returningRate + "%)" : "")),
            React.createElement("div", null, "Reviews: ", React.createElement("strong", null, (s.reviews || 0)), (s.avgRating != null ? " (" + s.avgRating + "★)" : "")),
            React.createElement("div", null, "Revenue: ", React.createElement("strong", null, money(s.revenue))),
            React.createElement("div", { style: { color: (s.complaints > 0 ? "#B23A48" : "#9B8E8A") } }, "Complaints: ", React.createElement("strong", null, (s.complaints || 0)))
          )
        );
      })
    )
  );
}

function PerformanceTab() {
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _mo = useState(6), monthsBack = _mo[0], setMonthsBack = _mo[1];

  var today = getLondonDate();

  useEffect(function() {
    setLoading(true);
    var start = new Date(today);
    start.setMonth(start.getMonth() - monthsBack);
    start.setDate(1);
    fetch(VIEW_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ startDate: fmtDate(start), endDate: fmtDate(today), action: "getCalendarView" })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) { setData(d); setLoading(false); })
      .catch(function() { setLoading(false); });
  }, [monthsBack]);

  if (loading) {
    return React.createElement("div", { style: { textAlign: "center", padding: 60 } },
      React.createElement("div", { style: { width:24, height:24, border:"2px solid rgba(139,115,74,0.2)", borderTopColor:"#8B734A", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto 12px" } }),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A" } }, "Crunching numbers...")
    );
  }

  // Build month labels and count per stylist per month
  var monthLabels = [];
  for (var i = monthsBack - 1; i >= 0; i--) {
    var md = new Date(today);
    md.setMonth(md.getMonth() - i);
    monthLabels.push({ key: md.getFullYear() + "-" + String(md.getMonth()+1).padStart(2,"0"), label: MONTHS[md.getMonth()].substring(0,3) + " " + md.getFullYear() });
  }

  var stats = {};
  var maxCount = 0;
  STYLISTS.forEach(function(st) {
    stats[st.name] = {};
    monthLabels.forEach(function(ml) { stats[st.name][ml.key] = 0; });

    if (!data) return;

    Object.keys(data).forEach(function(dateKey) {
      var monthKey = dateKey.substring(0, 7);
      if (!stats[st.name][monthKey] && stats[st.name][monthKey] !== 0) return;
      var dayData = data[dateKey];
      var stylists = dayData && dayData.stylists ? dayData.stylists : {};
      var evts = stylists[st.name] || [];
      evts.forEach(function(ev) {
        if (ev.summary && !ev.summary.toUpperCase().includes("HOLIDAY") && !ev.summary.toUpperCase().includes("CLOSED")) {
          stats[st.name][monthKey]++;
        }
      });
    });

    monthLabels.forEach(function(ml) {
      if (stats[st.name][ml.key] > maxCount) maxCount = stats[st.name][ml.key];
    });
  });

  // Totals per stylist
  var totals = {};
  STYLISTS.forEach(function(st) {
    totals[st.name] = 0;
    monthLabels.forEach(function(ml) { totals[st.name] += stats[st.name][ml.key]; });
  });

  var perfStart = new Date(today);
  perfStart.setMonth(perfStart.getMonth() - monthsBack);
  perfStart.setDate(1);

  return React.createElement("div", null,
    // Business performance summary (revenue / returning-client / reviews / complaints) — shares the range selector
    React.createElement(BusinessSummary, { startDate: fmtDate(perfStart), endDate: fmtDate(today) }),
    // Header with range selector
    React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24, flexWrap:"wrap", gap:12 } },
      React.createElement("div", null,
        React.createElement("h3", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:400, color:"#2A2131" } }, "Performance"),
        React.createElement("p", { style: { fontSize:12, color:"#8B734A", marginTop:2 } }, "Client count per stylist")
      ),
      React.createElement("div", { style: { display:"flex", gap:6 } },
        [3, 6, 12].map(function(m) {
          return React.createElement("button", {
            key: m,
            className: "cbd-btn " + (monthsBack === m ? "cbd-btn-primary" : "cbd-btn-secondary"),
            style: { padding:"5px 12px", fontSize:11 },
            onClick: function() { setMonthsBack(m); }
          }, m + " months");
        })
      )
    ),
    // Totals row
    React.createElement("div", { style: { display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(140px, 1fr))", gap:12, marginBottom:28 } },
      STYLISTS.map(function(st) {
        return React.createElement("div", {
          key: st.name,
          style: { background:"#fff", borderRadius:6, padding:14, borderLeft:"3px solid " + st.color, boxShadow:"0 1px 4px rgba(0,0,0,0.06)", textAlign:"center" }
        },
          React.createElement("div", { style: { fontSize:28, fontWeight:700, color: st.color } }, totals[st.name]),
          React.createElement("div", { style: { fontSize:11, color:"#8B734A", marginTop:2 } }, st.name),
          React.createElement("div", { style: { fontSize:10, color:"#8A8490" } }, "total clients")
        );
      })
    ),
    // Bar chart per month
    React.createElement("div", { style: { fontSize:11, fontWeight:600, color:"#8B734A", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:14 } }, "Month by Month"),
    monthLabels.map(function(ml) {
      return React.createElement("div", { key: ml.key, style: { marginBottom:16 } },
        React.createElement("div", { style: { fontSize:12, fontWeight:600, color:"#2A2131", marginBottom:6 } }, ml.label),
        STYLISTS.map(function(st) {
          var count = stats[st.name][ml.key];
          var pct = maxCount > 0 ? (count / maxCount) * 100 : 0;
          return React.createElement("div", {
            key: st.name,
            style: { display:"flex", alignItems:"center", gap:8, marginBottom:3 }
          },
            React.createElement("div", { style: { width:65, fontSize:10, color:"#8B734A", textAlign:"right", flexShrink:0 } }, st.name),
            React.createElement("div", { style: { flex:1, height:18, background:"rgba(139,115,74,0.06)", borderRadius:3, overflow:"hidden", position:"relative" } },
              React.createElement("div", {
                style: { height:"100%", width: Math.max(pct, count > 0 ? 3 : 0) + "%", background: st.color, borderRadius:3, transition:"width 0.6s ease" }
              })
            ),
            React.createElement("div", { style: { width:28, fontSize:11, fontWeight:600, color:"#2A2131", textAlign:"right" } }, count)
          );
        })
      );
    })
  );
}

// ===== ACADEMY TAB =====
// v22: Brevo key removed from the browser. The Academy waitlist now loads via a
// server-side n8n proxy (WF cb-academy-contacts) that holds the key in $env.BREVO_API_KEY
// and returns Brevo's list-5 response shape ({ contacts: [...] }) verbatim.
var ACADEMY_CONTACTS_API = "https://n8n.catherineboden.com/webhook/cb-academy-contacts";

function AcademyTab() {
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];

  useEffect(function() {
    setLoading(true);
    fetch(ACADEMY_CONTACTS_API)
      .then(function(r) { return r.json(); })
      .then(function(d) { setData(d.contacts || []); setLoading(false); })
      .catch(function() { setData([]); setLoading(false); });
  }, []);

  if (loading) {
    return React.createElement("div", { style: { textAlign: "center", padding: 60 } },
      React.createElement("div", { style: { width:24, height:24, border:"2px solid rgba(139,115,74,0.2)", borderTopColor:"#8B734A", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto 12px" } }),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A" } }, "Loading Academy waitlist...")
    );
  }

  // Group by course date
  var byDate = {};
  (data || []).forEach(function(c) {
    var attrs = c.attributes || {};
    var courseDate = attrs.ACADEMY_COURSE_DATE || "Unknown";
    var status = (attrs.ACADEMY_STATUS || "").toLowerCase();
    if (!byDate[courseDate]) byDate[courseDate] = [];
    byDate[courseDate].push({
      email: c.email,
      firstName: attrs.FIRSTNAME || "",
      lastName: attrs.LASTNAME || "",
      phone: attrs.SMS || "",
      status: status,
      depositDate: attrs.ACADEMY_DEPOSIT_DATE || "",
      depositAmount: attrs.ACADEMY_DEPOSIT_AMOUNT || 0,
      emailStage: attrs.ACADEMY_EMAIL_STAGE || 0,
      orderId: attrs.ACADEMY_SHOPIFY_ORDER_ID || "",
      rolledTo: attrs.ACADEMY_ROLLED_TO || ""
    });
  });

  var dateKeys = Object.keys(byDate).sort();
  var totalContacts = data ? data.length : 0;

  var statusColors = {
    waitlisted: "#C4A97A",
    confirmed: "#4CAF50",
    attended: "#8B734A",
    postponed: "#FF9800",
    refunded: "#c83c3c"
  };

  return React.createElement("div", null,
    React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24, flexWrap:"wrap", gap:12 } },
      React.createElement("div", null,
        React.createElement("h3", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:400, color:"#2A2131" } }, "Academy Waitlist"),
        React.createElement("p", { style: { fontSize:12, color:"#8B734A", marginTop:2 } }, totalContacts + " attendee" + (totalContacts !== 1 ? "s" : "") + " across " + dateKeys.length + " date" + (dateKeys.length !== 1 ? "s" : ""))
      ),
      React.createElement("a", {
        href: "https://catherineboden.com/products/cb-dep-academy-cc-200",
        target: "_blank",
        rel: "noopener",
        style: { fontSize:11, color:"#8B734A", textDecoration:"none", border:"1px solid rgba(139,115,74,0.3)", padding:"6px 14px", borderRadius:4, fontWeight:600, letterSpacing:"0.03em" }
      }, "Deposit Link \u2192")
    ),
    dateKeys.length === 0 ?
      React.createElement("p", { style: { fontSize:13, color:"#8A8490", fontStyle:"italic", padding:30, textAlign:"center" } }, "No Academy bookings yet") :
      dateKeys.map(function(dateKey) {
        var contacts = byDate[dateKey];
        var d = parseDate(dateKey);
        var dateLabel = fmtDayLong(d);
        var waitlistedCount = contacts.filter(function(c) { return c.status === "waitlisted"; }).length;
        var confirmedCount = contacts.filter(function(c) { return c.status === "confirmed"; }).length;
        var minMet = (waitlistedCount + confirmedCount) >= 3;

        return React.createElement("div", { key: dateKey, style: { marginBottom:24, background:"#fff", borderRadius:8, padding:20, boxShadow:"0 1px 6px rgba(0,0,0,0.05)" } },
          // Date header
          React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 } },
            React.createElement("div", null,
              React.createElement("div", { style: { fontSize:15, fontWeight:600, color:"#2A2131", fontFamily:"'Cormorant Garamond',serif" } }, "Monday " + dateLabel),
              React.createElement("div", { style: { fontSize:11, color:"#8B734A" } }, "Advanced Colour Correction Masterclass")
            ),
            React.createElement("div", { style: { textAlign:"right" } },
              React.createElement("div", { style: { fontSize:20, fontWeight:700, color: minMet ? "#4CAF50" : "#C4A97A" } }, contacts.length + "/6"),
              React.createElement("div", { style: { fontSize:9, fontWeight:600, color: minMet ? "#4CAF50" : "#c83c3c", textTransform:"uppercase", letterSpacing:"0.05em" } },
                minMet ? "MIN. MET" : "NEED " + (3 - waitlistedCount - confirmedCount) + " MORE"
              )
            )
          ),
          // Attendee list
          contacts.map(function(c, i) {
            return React.createElement("div", {
              key: i,
              style: { display:"flex", alignItems:"center", gap:10, padding:"8px 0", borderTop: i > 0 ? "1px solid rgba(139,115,74,0.08)" : "none" }
            },
              React.createElement("div", { style: { width:8, height:8, borderRadius:"50%", background: statusColors[c.status] || "#8A8490", flexShrink:0 } }),
              React.createElement("div", { style: { flex:1 } },
                React.createElement("div", { style: { fontSize:13, fontWeight:500, color:"#2A2131" } }, (c.firstName + " " + c.lastName).trim() || c.email),
                React.createElement("div", { style: { fontSize:10, color:"#8A8490" } }, c.email + (c.phone ? " | " + c.phone : ""))
              ),
              React.createElement("div", { style: { fontSize:9, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em", color: statusColors[c.status] || "#8A8490", background: (statusColors[c.status] || "#8A8490") + "18", padding:"3px 8px", borderRadius:3 } }, c.status || "unknown"),
              React.createElement("div", { style: { fontSize:10, color:"#8B734A", width:50, textAlign:"right" } },
                c.depositAmount ? "\u00a3" + c.depositAmount : ""
              )
            );
          }),
          // Status legend
          React.createElement("div", { style: { display:"flex", gap:12, marginTop:12, paddingTop:10, borderTop:"1px solid rgba(139,115,74,0.08)" } },
            React.createElement("span", { style: { fontSize:9, color:"#8A8490" } }, "Deposit paid: " + contacts.filter(function(c) { return c.depositAmount > 0; }).length),
            React.createElement("span", { style: { fontSize:9, color:"#8A8490" } }, "Email stage: " + Math.max.apply(null, contacts.map(function(c) { return c.emailStage; }).concat([0])) + "/5")
          )
        );
      })
  );
}

// ===== EMAIL FLOWS DATA =====
const FLOW_DATA = [
  {
    id: "wf7", name: "Meta Lead Follow-Up", code: "WF7", category: "lead",
    trigger: { type: "webhook", label: "Meta Lead Ad" },
    steps: [
      { label: "Receive lead", type: "trigger" },
      { label: "Format data", type: "process" },
      { label: "Parallel send", type: "process", parallel: true, branches: [
        { label: "Send welcome email", type: "email" },
        { label: "Create Brevo contact", type: "process" },
        { label: "Notify team via Gmail", type: "notify" }
      ]}
    ],
    emails: [{
      id: "wf7-welcome", label: "Welcome Email", subject: "Your HollywoodColourBlend\u00ae invitation \uD83E\uDDF4", recipient: "Lead's email address",
      html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Welcome to Colour Blend</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Thank you for your interest in HollywoodColourBlend\u00ae \u2014 we're so glad you found us.</p><p>At Colour Blend, we specialise in bespoke colour transformations using our exclusive HollywoodColourBlend\u00ae system. Every appointment is a one-to-one experience with your dedicated colourist.</p><p style=\"margin:20px 0;\"><a href=\"#\" style=\"display:inline-block;background:#8B734A;color:#F6EFED;padding:12px 28px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:600;letter-spacing:0.04em;\">BOOK YOUR CONSULTATION</a></p><p style=\"font-size:13px;color:#8A8490;\">We'll be in touch shortly to help you find the perfect appointment.</p><p style=\"margin-top:20px;\">With love,<br/>Catherine &amp; the Colour Blend team</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>"
    }]
  },
  {
    id: "wf11", name: "Academy Lead Follow-Up", code: "WF11", category: "academy",
    trigger: { type: "cron", label: "Daily at 10am" },
    steps: [
      { label: "Fetch Brevo list 9", type: "trigger" },
      { label: "Filter last 24h leads", type: "process" },
      { label: "Send follow-up email", type: "email" }
    ],
    emails: [{
      id: "wf11-followup", label: "Academy Follow-Up", subject: "Sarah, ready to book your place? \uD83E\uDDF4", recipient: "Academy brochure downloaders (last 24h)",
      html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Your Academy Brochure</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Thanks for downloading our Colour Correction Masterclass brochure \u2014 we hope you found it inspiring!</p><p>We wanted to follow up personally. Our next masterclass date is filling up quickly, and we'd love to have you join us.</p><p><strong>What you'll learn:</strong></p><ul style=\"padding-left:18px;color:#2A2131;\"><li>Advanced colour correction techniques</li><li>HollywoodColourBlend\u00ae application method</li><li>Live model demonstrations</li></ul><p style=\"margin:20px 0;\"><a href=\"#\" style=\"display:inline-block;background:#8B734A;color:#F6EFED;padding:12px 28px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:600;letter-spacing:0.04em;\">RESERVE YOUR PLACE</a></p><p style=\"font-size:13px;color:#8A8490;\">Spaces are limited to 6 per session for a truly hands-on experience.</p><p style=\"margin-top:20px;\">Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>"
    }]
  },
  {
    id: "wf18", name: "Booking Confirmation", code: "WF18", category: "booking",
    trigger: { type: "webhook", label: "Team Calendar Booking" },
    steps: [
      { label: "Receive booking data", type: "trigger" },
      { label: "Format appointment", type: "process" },
      { label: "Send confirmation email", type: "email" },
      { label: "Update Brevo contact", type: "process" }
    ],
    emails: [{
      id: "wf18-confirm", label: "Booking Confirmation", subject: "Your appointment is confirmed \u2013 Wednesday 16 April", recipient: "Client being booked",
      html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Appointment Confirmed</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Your appointment has been confirmed:</p><div style=\"background:rgba(139,115,74,0.06);padding:14px 16px;border-radius:6px;border-left:3px solid #8B734A;margin:16px 0;\"><strong>Hollywood Colour Blend \u2014 Full</strong> with Catherine<br/>Wednesday 16 April at 10:00am</div><p>A \u00a350 deposit has been received. The remaining balance is payable on the day.</p><p><strong>Please remember:</strong></p><ul style=\"padding-left:18px;\"><li>24-hour cancellation policy</li><li>Free on-site parking</li><li>Complimentary refreshments on arrival</li></ul><p style=\"font-size:13px;color:#8A8490;margin-top:16px;\">If you need to make any changes, please contact us on 07898 111240 or reply to this email.</p><p style=\"margin-top:20px;\">We look forward to welcoming you.<br/>The Colour Blend Team x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>"
    }]
  },
  {
    id: "cb20", name: "Thank You + Review Request", code: "CB20", category: "review",
    trigger: { type: "cron", label: "Daily at 6pm, Wed\u2013Sun" },
    steps: [
      { label: "Check day (Wed\u2013Sun)", type: "trigger" },
      { label: "Fetch 3 stylist calendars (yesterday)", type: "process" },
      { label: "For each client: Brevo lookup", type: "process" },
      { label: "Check 30-day cooldown", type: "process" },
      { label: "Send thank-you email", type: "email" },
      { label: "Update Brevo contact", type: "process" }
    ],
    emails: [{
      id: "cb20-thankyou", label: "Thank You + Review", subject: "Thank you for visiting us yesterday", recipient: "Yesterday's salon clients",
      html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Thank You, Sarah</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>It was lovely to see you at the salon yesterday. We hope you're absolutely loving your new colour!</p><p>If you have a moment, we'd be so grateful if you could leave us a quick review \u2014 it really helps other clients find us.</p><div style=\"text-align:center;margin:20px 0;\"><a href=\"#\" style=\"display:inline-block;background:#8B734A;color:#F6EFED;padding:12px 28px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:600;letter-spacing:0.04em;margin:0 6px;\">REVIEW ON GOOGLE</a> <a href=\"#\" style=\"display:inline-block;background:#2A2131;color:#F6EFED;padding:12px 28px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:600;letter-spacing:0.04em;margin:0 6px;\">REVIEW ON TRUSTPILOT</a></div><p style=\"font-size:13px;color:#8A8490;\">Your feedback means the world to us and helps our small team grow.</p><p style=\"margin-top:20px;\">Lots of love,<br/>Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>"
    }]
  },
  {
    id: "cb21", name: "Consultation Follow-Up", code: "CB21", category: "lead",
    trigger: { type: "webhook", label: "Post-consultation" },
    steps: [
      { label: "Receive consultation data", type: "trigger" },
      { label: "Validate fields", type: "process" },
      { label: "Build personalised email", type: "process" },
      { label: "Send via Brevo", type: "email" },
      { label: "Update contact", type: "process" }
    ],
    emails: [{
      id: "cb21-followup", label: "Consultation Follow-Up", subject: "Thanks for our consultation \u2013 let\u2019s get you booked in", recipient: "Consultation attendee",
      html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Your Colour Plan</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>It was a pleasure meeting you today for your consultation. I've put together a personalised colour plan based on everything we discussed.</p><p><strong>Your recommended service:</strong></p><div style=\"background:rgba(139,115,74,0.06);padding:14px 16px;border-radius:6px;border-left:3px solid #8B734A;margin:12px 0;\">Hollywood Colour Blend \u2014 Full<br/><span style=\"font-size:12px;color:#8A8490;\">Approx. 3 hours \u00b7 from \u00a3180</span></div><p>I'd love to get you booked in while we have some lovely slots available this month.</p><p style=\"margin:20px 0;\"><a href=\"#\" style=\"display:inline-block;background:#8B734A;color:#F6EFED;padding:12px 28px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:600;letter-spacing:0.04em;\">BOOK YOUR APPOINTMENT</a></p><p style=\"font-size:13px;color:#8A8490;\">Simply reply to this email or call us on 01625 926599 if you have any questions at all.</p><p style=\"margin-top:20px;\">Can't wait to get started!<br/>Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>"
    }]
  },
  {
    id: "cb15", name: "Academy Countdown", code: "CB15", category: "academy",
    trigger: { type: "cron", label: "Daily at 9am" },
    steps: [
      { label: "Fetch waitlist", type: "trigger" },
      { label: "Calculate days until course", type: "process" },
      { label: "Check milestones", type: "process" },
      { label: "Send milestone email", type: "email" },
      { label: "Update Brevo stage", type: "process" }
    ],
    emails: [
      { id: "cb15-14d", label: "14 Days Out", subject: "Update: Your masterclass on Monday 28 April", recipient: "Waitlisted attendees",
        html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">2 Weeks to Go!</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Just a quick update \u2014 your Colour Correction Masterclass is now <strong>2 weeks away</strong>!</p><p>We're currently at 4 out of 6 places filled. Once we reach our minimum of 3 confirmed attendees, we'll lock in the date and send your full joining details.</p><div style=\"background:rgba(139,115,74,0.06);padding:14px 16px;border-radius:6px;border-left:3px solid #C4A97A;margin:16px 0;\"><strong>Date:</strong> Monday 28 April<br/><strong>Time:</strong> 10:00am \u2013 4:00pm<br/><strong>Venue:</strong> Country Retreat Salon, Wilmslow</div><p style=\"font-size:13px;color:#8A8490;\">If you haven't yet paid your deposit, please do so soon to secure your place.</p><p style=\"margin-top:20px;\">Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>" },
      { id: "cb15-10d-confirm", label: "10d Confirmed", subject: "Your masterclass is confirmed!", recipient: "Waitlisted (group \u2265 3)",
        html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">It's Confirmed!</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Great news \u2014 your Colour Correction Masterclass is <strong>officially confirmed</strong>! We've hit our minimum group size and the date is now locked in.</p><div style=\"background:rgba(76,175,80,0.08);padding:14px 16px;border-radius:6px;border-left:3px solid #4CAF50;margin:16px 0;\"><strong>Date:</strong> Monday 28 April<br/><strong>Time:</strong> 10:00am \u2013 4:00pm<br/><strong>Location:</strong> Country Retreat Salon, Wilmslow<br/><strong>Bring:</strong> Notepad, your favourite brushes</div><p>Lunch and refreshments are included. We'll send a final reminder a few days before.</p><p style=\"margin-top:20px;\">So excited to see you there!<br/>Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>" },
      { id: "cb15-10d-postpone", label: "10d Postponed", subject: "Masterclass date update", recipient: "Waitlisted (group < 3)",
        html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Date Update</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Thank you for your patience. Unfortunately we haven't reached our minimum group size of 3 for the 28 April date, so we're going to move it to the next available Monday.</p><p>Your deposit is completely safe and will carry over automatically. We'll be in touch as soon as the new date is confirmed.</p><p style=\"font-size:13px;color:#8A8490;\">If you'd prefer a refund instead, simply reply to this email and we'll arrange it straight away.</p><p style=\"margin-top:20px;\">Apologies for the change \u2014 we want to make sure you get the best possible experience with a full group.<br/><br/>Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>" },
      { id: "cb15-3d", label: "3 Days Out", subject: "See you Monday!", recipient: "Confirmed attendees",
        html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">See You Monday!</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>Your masterclass is just <strong>3 days away</strong> \u2014 we can't wait!</p><div style=\"background:rgba(139,115,74,0.06);padding:14px 16px;border-radius:6px;border-left:3px solid #8B734A;margin:16px 0;\"><strong>When:</strong> Monday 28 April, 10:00am \u2013 4:00pm<br/><strong>Where:</strong> Country Retreat Salon, Wilmslow, SK9 1PW<br/><strong>Parking:</strong> Free on-site parking available<br/><strong>Bring:</strong> Notepad, your favourite brushes &amp; combs</div><p>Lunch, refreshments, and all colour products are provided. Just bring yourself and your enthusiasm!</p><p style=\"margin-top:20px;\">See you bright and early,<br/>Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>" },
      { id: "cb15-1d-after", label: "Day After", subject: "Thank you for attending", recipient: "Confirmed attendees (day after)",
        html: "<div style=\"max-width:600px;margin:0 auto;font-family:'Jost',Helvetica,sans-serif;background:#FDFAF8;\"><div style=\"background:#2A2131;padding:28px 24px;text-align:center;\"><p style=\"font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;color:#C4A97A;font-weight:300;margin:0;\">Thank You!</p><p style=\"font-size:10px;letter-spacing:3px;text-transform:uppercase;color:rgba(246,239,237,0.5);margin:6px 0 0;\">COLOUR BLEND BY CATHERINE BODEN</p></div><div style=\"padding:24px;font-size:14px;color:#2A2131;line-height:1.7;\"><p>Hi Sarah,</p><p>What an incredible day yesterday! Thank you so much for being part of our Colour Correction Masterclass \u2014 your energy and talent made it such a special session.</p><p>A few things to remember:</p><ul style=\"padding-left:18px;color:#2A2131;\"><li>Your certificate will be emailed within 48 hours</li><li>Practice the blending technique on a mannequin head first</li><li>Tag us on Instagram @hollywoodcolourblend for a feature</li></ul><p style=\"margin:20px 0;\"><a href=\"#\" style=\"display:inline-block;background:#8B734A;color:#F6EFED;padding:12px 28px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:600;letter-spacing:0.04em;\">LEAVE A REVIEW</a></p><p style=\"font-size:13px;color:#8A8490;\">We'd love to hear what you thought \u2014 your feedback helps us make the next one even better.</p><p style=\"margin-top:20px;\">Until next time,<br/>Catherine x</p></div><div style=\"padding:16px 24px;text-align:center;border-top:1px solid rgba(139,115,74,0.15);\"><p style=\"font-size:9px;color:rgba(139,115,74,0.4);letter-spacing:2px;text-transform:uppercase;\">Country Retreat Salon \u00b7 Wilmslow \u00b7 Cheshire</p></div></div>" }
    ]
  }
];

const COMMENT_API = "https://n8n.catherineboden.com/webhook/cb-flow-comments";
const CATEGORY_COLORS = { lead: "#C4A97A", booking: "#8B734A", review: "#4CAF50", academy: "#A08B6E" };
const CATEGORY_LABELS = { lead: "Lead", booking: "Booking", review: "Review", academy: "Academy" };
const STEP_ICONS = { trigger: "\u26A1", process: "\u2699\uFE0F", email: "\u2709\uFE0F", notify: "\uD83D\uDD14" };
const STEP_BORDER = { trigger: "#C4A97A", process: "#8A8490", email: "#8B734A", notify: "#A08B6E" };

// ===== FLOW CARD =====
function FlowCard(props) {
  var flow = props.flow, selected = props.selected, onSelect = props.onSelect;
  var catColor = CATEGORY_COLORS[flow.category] || "#8A8490";
  return React.createElement("div", {
    onClick: function() { onSelect(flow.id); },
    style: {
      background: "#fff", borderRadius: 8, padding: "14px 16px", cursor: "pointer",
      boxShadow: selected ? "0 2px 12px rgba(139,115,74,0.15)" : "0 1px 6px rgba(0,0,0,0.05)",
      borderLeft: selected ? "3px solid #8B734A" : "3px solid transparent",
      transition: "all 0.2s", marginBottom: 6
    }
  },
    React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } },
      React.createElement("div", { style: { width: 8, height: 8, borderRadius: "50%", background: catColor, flexShrink: 0 } }),
      React.createElement("span", {
        style: { fontSize: 9, fontWeight: 700, color: "#8B734A", background: "rgba(139,115,74,0.08)", padding: "2px 6px", borderRadius: 3, letterSpacing: "0.04em", flexShrink: 0 }
      }, flow.code),
      React.createElement("div", { style: { flex: 1, minWidth: 0 } },
        React.createElement("div", {
          style: { fontSize: 13, fontWeight: 600, color: "#2A2131", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }
        }, flow.name),
        React.createElement("div", { style: { fontSize: 10, color: "#8A8490", marginTop: 2 } },
          (flow.trigger.type === "webhook" ? "\u26A1 " : "\u23F0 ") + flow.trigger.label)
      ),
      React.createElement("span", {
        style: { fontSize: 9, fontWeight: 600, color: catColor, background: catColor + "18", padding: "3px 8px", borderRadius: 3, textTransform: "uppercase", letterSpacing: "0.04em", flexShrink: 0 }
      }, CATEGORY_LABELS[flow.category])
    )
  );
}

// ===== FLOW DIAGRAM =====
function FlowDiagram(props) {
  var steps = props.steps;
  function renderNode(step, key) {
    var borderColor = STEP_BORDER[step.type] || "#8A8490";
    var bg = step.type === "trigger" ? "rgba(196,169,122,0.06)" : step.type === "email" ? "rgba(139,115,74,0.04)" : "#fff";
    var borderStyle = step.type === "trigger" ? "dashed" : "solid";
    return React.createElement("div", {
      key: key,
      style: { background: bg, borderRadius: 8, padding: "10px 14px", borderLeft: "3px " + borderStyle + " " + borderColor, display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#2A2131", flex: 1 }
    },
      React.createElement("span", { style: { fontSize: 14 } }, STEP_ICONS[step.type] || "\u2699\uFE0F"),
      step.label
    );
  }
  function renderConnector(key) {
    return React.createElement("div", { key: "conn-" + key, style: { width: 2, height: 20, background: "rgba(139,115,74,0.25)", margin: "0 auto", borderRadius: 1 } });
  }
  var elements = [];
  steps.forEach(function(step, i) {
    if (i > 0) elements.push(renderConnector(i));
    if (step.parallel && step.branches) {
      elements.push(React.createElement("div", { key: "fork-" + i, style: { textAlign: "center", fontSize: 10, color: "#C4A97A", fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", padding: "4px 0" } }, "\u2014 parallel \u2014"));
      elements.push(React.createElement("div", { key: "branches-" + i, style: { display: "flex", gap: 8 } },
        step.branches.map(function(b, j) { return renderNode(b, "b-" + i + "-" + j); })
      ));
    } else {
      elements.push(renderNode(step, "step-" + i));
    }
  });
  return React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 0 } }, elements);
}

// ===== EMAIL PREVIEW =====
function EmailPreview(props) {
  var emails = props.emails;
  var _a = useState(0), activeIdx = _a[0], setActiveIdx = _a[1];
  var email = emails[activeIdx] || emails[0];
  return React.createElement("div", {
    style: { background: "#fff", borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", overflow: "hidden" }
  },
    emails.length > 1 && React.createElement("div", {
      style: { display: "flex", gap: 4, padding: "12px 16px", borderBottom: "1px solid rgba(139,115,74,0.1)", flexWrap: "wrap" }
    },
      emails.map(function(e, i) {
        var active = i === activeIdx;
        return React.createElement("button", {
          key: e.id, onClick: function() { setActiveIdx(i); },
          style: { background: active ? "#8B734A" : "rgba(139,115,74,0.08)", color: active ? "#F6EFED" : "#8B734A", border: "none", borderRadius: 20, padding: "5px 14px", fontSize: 11, fontWeight: 600, cursor: "pointer", letterSpacing: "0.02em", transition: "all 0.2s" }
        }, e.label);
      })
    ),
    React.createElement("div", { style: { padding: "14px 16px", borderBottom: "1px solid rgba(139,115,74,0.08)", fontSize: 12 } },
      React.createElement("div", { style: { display: "flex", gap: 6, marginBottom: 4 } },
        React.createElement("span", { style: { color: "#8A8490", fontWeight: 600, width: 50 } }, "To:"),
        React.createElement("span", { style: { color: "#2A2131" } }, email.recipient)
      ),
      React.createElement("div", { style: { display: "flex", gap: 6 } },
        React.createElement("span", { style: { color: "#8A8490", fontWeight: 600, width: 50 } }, "Subject:"),
        React.createElement("span", { style: { color: "#2A2131", fontWeight: 500 } }, email.subject)
      )
    ),
    React.createElement("iframe", {
      srcDoc: email.html, sandbox: "allow-same-origin",
      style: { width: "100%", height: 480, border: "none", display: "block" }
    })
  );
}

// ===== COMMENT SECTION =====
function CommentSection(props) {
  var flowId = props.flowId;
  var _c = useState([]), comments = _c[0], setComments = _c[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _n = useState(""), name = _n[0], setName = _n[1];
  var _t = useState(""), text = _t[0], setText = _t[1];
  var _s = useState(false), sending = _s[0], setSending = _s[1];
  var _ok = useState(""), sent = _ok[0], setSent = _ok[1];

  useEffect(function() {
    setComments([]); setLoading(false);
  }, [flowId]);

  function handleSend() {
    if (!name.trim() || !text.trim()) return;
    setSending(true);
    var flowName = (FLOW_DATA.find(function(f) { return f.id === flowId; }) || {}).name || flowId;
    // v22: send via server-side n8n proxy (WF65 cb-flow-comments) instead of calling Brevo
    // directly with a browser-exposed key. WF65 builds + sends the email using $env.BREVO_API_KEY.
    fetch(COMMENT_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: name.trim(), flowName: flowName, text: text.trim() })
    }).then(function() {
      setComments(function(prev) { return prev.concat([{ author: name.trim(), text: text.trim(), date: new Date().toISOString() }]); });
      setText(""); setSent("Comment sent!"); setTimeout(function() { setSent(""); }, 2500);
    }).catch(function() {
      // Still save locally even if email fails
      setComments(function(prev) { return prev.concat([{ author: name.trim(), text: text.trim(), date: new Date().toISOString() }]); });
      setText(""); setSent("Comment saved"); setTimeout(function() { setSent(""); }, 2500);
    }).finally(function() { setSending(false); });
  }

  return React.createElement("div", null,
    loading && React.createElement("p", { style: { fontSize: 12, color: "#8A8490", padding: "10px 0" } }, "Loading comments..."),
    !loading && comments.length === 0 && React.createElement("p", { style: { fontSize: 12, color: "#8A8490", padding: "10px 0" } }, "No comments yet. Be the first to leave feedback."),
    !loading && comments.map(function(c, i) {
      return React.createElement("div", { key: i, style: { background: "rgba(139,115,74,0.04)", borderRadius: 6, padding: "10px 14px", marginBottom: 6 } },
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: 4 } },
          React.createElement("span", { style: { fontSize: 12, fontWeight: 600, color: "#2A2131" } }, c.author || "Anonymous"),
          React.createElement("span", { style: { fontSize: 10, color: "#8A8490" } }, c.date ? new Date(c.date).toLocaleDateString("en-GB") : "")
        ),
        React.createElement("p", { style: { fontSize: 13, color: "#2A2131", lineHeight: 1.5, margin: 0 } }, c.text)
      );
    }),
    React.createElement("div", { style: { marginTop: 12, display: "flex", flexDirection: "column", gap: 8 } },
      React.createElement("input", { value: name, onChange: function(e) { setName(e.target.value); }, placeholder: "Your name", style: { padding: "8px 10px", fontSize: 13 } }),
      React.createElement("textarea", { value: text, onChange: function(e) { setText(e.target.value); }, placeholder: "Leave feedback on this email flow...", rows: 3, style: { padding: "8px 10px", fontSize: 13, fontFamily: "'DM Sans',sans-serif", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, resize: "vertical" } }),
      React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } },
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: handleSend, disabled: sending || !name.trim() || !text.trim(), style: { opacity: (!name.trim() || !text.trim()) ? 0.5 : 1 } }, sending ? "Sending..." : "Send"),
        sent && React.createElement("span", { style: { fontSize: 12, color: "#4CAF50", fontWeight: 500 } }, sent)
      )
    )
  );
}

// ===== FLOW DETAIL =====
function FlowDetail(props) {
  var flow = props.flow;
  var catColor = CATEGORY_COLORS[flow.category] || "#8A8490";
  return React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 24 } },
    React.createElement("div", null,
      React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" } },
        React.createElement("span", { style: { fontSize: 10, fontWeight: 700, color: "#8B734A", background: "rgba(139,115,74,0.08)", padding: "3px 8px", borderRadius: 3, letterSpacing: "0.04em" } }, flow.code),
        React.createElement("span", { style: { fontSize: 10, fontWeight: 600, color: catColor, background: catColor + "18", padding: "3px 8px", borderRadius: 3, textTransform: "uppercase", letterSpacing: "0.04em" } }, CATEGORY_LABELS[flow.category]),
        React.createElement("span", { style: { fontSize: 10, color: "#8A8490", background: "rgba(138,132,144,0.1)", padding: "3px 8px", borderRadius: 3 } },
          (flow.trigger.type === "webhook" ? "\u26A1 Webhook" : "\u23F0 Cron") + " \u2014 " + flow.trigger.label)
      ),
      React.createElement("h2", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 400, color: "#2A2131", margin: 0 } }, flow.name),
      React.createElement("p", { style: { fontSize: 13, color: "#8A8490", marginTop: 6, lineHeight: 1.5 } },
        flow.emails.length + " email" + (flow.emails.length > 1 ? "s" : "") + " \u00b7 " + flow.steps.length + " steps")
    ),
    React.createElement("div", { style: { background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 1px 6px rgba(0,0,0,0.05)" } },
      React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, color: "#2A2131", marginBottom: 14 } }, "Flow Steps"),
      React.createElement(FlowDiagram, { steps: flow.steps })
    ),
    React.createElement("div", null,
      React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, color: "#2A2131", marginBottom: 14 } }, "Email Preview"),
      React.createElement(EmailPreview, { emails: flow.emails })
    ),
    React.createElement("div", { style: { background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 1px 6px rgba(0,0,0,0.05)" } },
      React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, color: "#2A2131", marginBottom: 14 } }, "Team Feedback"),
      React.createElement(CommentSection, { flowId: flow.id })
    )
  );
}

// ===== EMAILS TAB =====
function EmailsTab() {
  var _s = useState(FLOW_DATA[0].id), selectedId = _s[0], setSelectedId = _s[1];
  var _f = useState("all"), filter = _f[0], setFilter = _f[1];
  var _m = useState(window.innerWidth < 640), isMobile = _m[0], setIsMobile = _m[1];
  useEffect(function() {
    function handleResize() { setIsMobile(window.innerWidth < 640); }
    window.addEventListener("resize", handleResize);
    return function() { window.removeEventListener("resize", handleResize); };
  }, []);
  var filteredFlows = filter === "all" ? FLOW_DATA : FLOW_DATA.filter(function(f) { return f.category === filter; });
  var selectedFlow = FLOW_DATA.find(function(f) { return f.id === selectedId; }) || FLOW_DATA[0];
  var filterPills = ["all", "lead", "booking", "review", "academy"];

  var sidebar = React.createElement("div", null,
    React.createElement("div", { style: { display: "flex", gap: 4, marginBottom: 12, flexWrap: "wrap" } },
      filterPills.map(function(f) {
        var active = filter === f;
        var col = f === "all" ? "#8B734A" : CATEGORY_COLORS[f];
        return React.createElement("button", {
          key: f, onClick: function() { setFilter(f); },
          style: { background: active ? col : "transparent", color: active ? "#F6EFED" : col, border: "1px solid " + (active ? col : col + "44"), borderRadius: 20, padding: "4px 12px", fontSize: 10, fontWeight: 600, cursor: "pointer", textTransform: "capitalize", letterSpacing: "0.03em", transition: "all 0.2s" }
        }, f === "all" ? "All" : CATEGORY_LABELS[f]);
      })
    ),
    filteredFlows.map(function(flow) {
      return React.createElement(FlowCard, { key: flow.id, flow: flow, selected: flow.id === selectedId, onSelect: setSelectedId });
    }),
    filteredFlows.length === 0 && React.createElement("p", { style: { fontSize: 12, color: "#8A8490", padding: 12, textAlign: "center" } }, "No flows in this category.")
  );

  if (isMobile) {
    return React.createElement("div", { style: { animation: "fadeIn 0.3s ease" } },
      React.createElement("div", { style: { overflowX: "auto", paddingBottom: 12, marginBottom: 16 } },
        React.createElement("div", { style: { display: "flex", gap: 4, marginBottom: 10 } },
          filterPills.map(function(f) {
            var active = filter === f; var col = f === "all" ? "#8B734A" : CATEGORY_COLORS[f];
            return React.createElement("button", { key: f, onClick: function() { setFilter(f); }, style: { background: active ? col : "transparent", color: active ? "#F6EFED" : col, border: "1px solid " + (active ? col : col + "44"), borderRadius: 20, padding: "4px 12px", fontSize: 10, fontWeight: 600, cursor: "pointer", textTransform: "capitalize", flexShrink: 0 } }, f === "all" ? "All" : CATEGORY_LABELS[f]);
          })
        ),
        React.createElement("div", { style: { display: "flex", gap: 8, overflowX: "auto" } },
          filteredFlows.map(function(flow) {
            var sel = flow.id === selectedId; var catColor = CATEGORY_COLORS[flow.category] || "#8A8490";
            return React.createElement("div", {
              key: flow.id, onClick: function() { setSelectedId(flow.id); },
              style: { minWidth: 160, background: "#fff", borderRadius: 8, padding: "10px 12px", cursor: "pointer", boxShadow: sel ? "0 2px 10px rgba(139,115,74,0.15)" : "0 1px 4px rgba(0,0,0,0.05)", borderTop: sel ? "2px solid #8B734A" : "2px solid transparent", flexShrink: 0 }
            },
              React.createElement("div", { style: { fontSize: 9, fontWeight: 700, color: "#8B734A", marginBottom: 4 } }, flow.code),
              React.createElement("div", { style: { fontSize: 12, fontWeight: 600, color: "#2A2131", lineHeight: 1.3 } }, flow.name),
              React.createElement("div", { style: { fontSize: 9, color: catColor, fontWeight: 600, marginTop: 4, textTransform: "uppercase" } }, CATEGORY_LABELS[flow.category])
            );
          })
        )
      ),
      React.createElement(FlowDetail, { flow: selectedFlow })
    );
  }

  return React.createElement("div", {
    style: { display: "grid", gridTemplateColumns: "280px 1fr", gap: 24, animation: "fadeIn 0.3s ease", alignItems: "start" }
  }, sidebar, React.createElement(FlowDetail, { flow: selectedFlow }));
}

// ===== MAIN APP =====
// ===== INTERACTIONS TAB =====
const CHANNEL_COLOURS = {
  email: "#8B734A",
  website_chat: "#4CAF50",
  instagram: "#E4405F",
  facebook: "#1877F2",
  whatsapp: "#25D366",
  telephone: "#C4A97A",
  meta_lead: "#0866FF",
  academy_lead: "#A08B6E",
  social_dm: "#E4405F"
};

// ===== ACTIVITY TAB (v40) =====
// Concise daily "what the system did" feed: booking actions (cb-activity, new
// bookings by created-time) merged with a per-day conversation summary
// (cb-interactions-v2). Read-only. See CHANGELOG 2026-07-24 + WF103.
function ActivityTab() {
  var _b = useState(null), book = _b[0], setBook = _b[1];
  var _i = useState(null), inter = _i[0], setInter = _i[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _e = useState(null), error = _e[0], setError = _e[1];

  useEffect(function() {
    setLoading(true);
    Promise.all([
      fetch(ACTIVITY_API + "?days=7").then(function(r) { return r.json(); }),
      fetch(INTERACTIONS_API).then(function(r) { return r.json(); })
    ]).then(function(res) { setBook(res[0]); setInter(res[1]); setLoading(false); })
      .catch(function(err) { setError(err.message); setLoading(false); });
  }, []);

  if (loading) {
    return React.createElement("div", { style: { textAlign: "center", padding: 60 } },
      React.createElement("div", { style: { width:24, height:24, border:"2px solid rgba(139,115,74,0.2)", borderTopColor:"#8B734A", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto 12px" } }),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A" } }, "Loading activity...")
    );
  }
  if (error || !book || !inter) {
    return React.createElement("div", { style: { padding: 40, textAlign: "center", color:"#8A8490" } }, "Could not load activity. Try refreshing.");
  }

  var channelLabels = inter.channelLabels || {};
  var interDays = inter.days || [];

  function londonDate(iso) { try { return new Date(iso).toLocaleDateString("en-CA", { timeZone: "Europe/London" }); } catch (e) { return String(iso).slice(0, 10); } }
  function londonTime(iso) { try { return new Date(iso).toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit" }); } catch (e) { return ""; } }
  function shortSvc(s) { return String(s || "").replace("Appointment Deposit — ", "").replace("HollywoodColourBlend®", "HCB").replace("Hollywood Colour Blend - ", "HCB ").slice(0, 34); }

  var bookByDay = {};
  (book.events || []).forEach(function(e) { var d = londonDate(e.ts); (bookByDay[d] = bookByDay[d] || []).push(e); });

  function actionLine(e, i) {
    var colour = "#8B734A", bg = "rgba(139,115,74,0.05)", icon = "✅", title, sub;
    if (e.type === "rescheduled") {
      icon = "📅"; title = "Rescheduled " + e.client;
      sub = shortSvc(e.service) + (e.stylist ? (" · " + e.stylist) : "") + (e.from ? ("  " + e.from + " → " + e.to) : "");
    } else if (e.type === "cancelled") {
      colour = "#c07a7a"; bg = "rgba(192,122,122,0.06)"; icon = "❌"; title = "Cancelled " + e.client;
      sub = shortSvc(e.service) + (e.stylist ? (" · " + e.stylist) : "") + (e.from ? ("  was " + e.from) : "");
    } else {
      title = "Booked " + e.client + (e.cancelled ? " (later cancelled)" : "");
      sub = shortSvc(e.service) + " · " + e.stylist + " · " + e.date + (e.time ? (" " + e.time) : "");
    }
    return React.createElement("div", { key: "e" + i, style: { display:"flex", gap:10, padding:"7px 10px", borderLeft:"2px solid " + colour, background:bg, borderRadius:4, marginBottom:4, alignItems:"flex-start" } },
      React.createElement("div", { style: { fontSize:10, fontWeight:600, color:"#2A2131", width:40, flexShrink:0 } }, londonTime(e.ts)),
      React.createElement("div", { style: { flex:1, minWidth:0 } },
        React.createElement("div", { style: { fontSize:12, fontWeight:600, color:"#2A2131" } }, icon + " " + title),
        React.createElement("div", { style: { fontSize:10, color:"#8A8490", marginTop:2 } }, sub)
      )
    );
  }

  function convSummary(day) {
    if (!day || !day.total) return null;
    var cc = day.channelCounts || {};
    var parts = Object.keys(cc).sort().map(function(ch) { return (channelLabels[ch] || ch) + " " + cc[ch]; });
    return React.createElement("div", { style: { display:"flex", gap:10, padding:"7px 10px", borderLeft:"2px solid #C4A97A", background:"rgba(196,169,122,0.06)", borderRadius:4, marginBottom:4 } },
      React.createElement("div", { style: { fontSize:12, color:"#2A2131" } },
        "💬 Talked to clients — " + day.total + " message" + (day.total > 1 ? "s" : "") + (parts.length ? (" (" + parts.join(", ") + ")") : "") + (day.escalations > 0 ? ("  · " + day.escalations + " escalated") : ""))
    );
  }

  return React.createElement("div", null,
    React.createElement("div", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:400, color:"#2A2131", marginBottom:4 } }, "Activity"),
    React.createElement("div", { style: { fontSize:11, color:"#8B734A", marginBottom:18 } }, "What the system did — last 7 days"),
    interDays.map(function(day) {
      var bks = bookByDay[day.date] || [];
      var nothing = bks.length === 0 && !day.total;
      return React.createElement("div", { key: day.date, style: { background:"#fff", borderRadius:6, padding:"12px 14px", marginBottom:10, boxShadow:"0 1px 3px rgba(0,0,0,0.04)" } },
        React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:10 } },
          React.createElement("div", { style: { fontSize:13, fontWeight:600, color:"#2A2131" } }, day.dayName + (day.isToday ? "  · Today" : "")),
          React.createElement("div", { style: { fontSize:10, color:"#8A8490" } }, day.displayDate)
        ),
        bks.length > 0 && React.createElement("div", { style: { fontSize:9, fontWeight:600, color:"#8B734A", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:4 } }, bks.length + " booking action" + (bks.length > 1 ? "s" : "")),
        bks.map(actionLine),
        convSummary(day),
        nothing && React.createElement("div", { style: { fontSize:11, color:"#C4C0C5", fontStyle:"italic", padding:"4px 0" } }, "Quiet — no activity")
      );
    })
  );
}

function InteractionsTab() {
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _e = useState(null), error = _e[0], setError = _e[1];
  var _exp = useState({}), expanded = _exp[0], setExpanded = _exp[1];

  useEffect(function() {
    setLoading(true);
    fetch(INTERACTIONS_API)
      .then(function(r) { return r.json(); })
      .then(function(d) { setData(d); setLoading(false); })
      .catch(function(err) { setError(err.message); setLoading(false); });
  }, []);

  if (loading) {
    return React.createElement("div", { style: { textAlign: "center", padding: 60 } },
      React.createElement("div", { style: { width:24, height:24, border:"2px solid rgba(139,115,74,0.2)", borderTopColor:"#8B734A", borderRadius:"50%", animation:"spin 0.8s linear infinite", margin:"0 auto 12px" } }),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A" } }, "Loading interactions...")
    );
  }

  if (error || !data) {
    return React.createElement("div", { style: { padding: 40, textAlign: "center", color:"#8A8490" } }, "Could not load interactions. Try refreshing.");
  }

  var channelLabels = data.channelLabels || {};
  var days = data.days || [];
  var today = days[0] || { total: 0, byChannel: {}, channelCounts: {} };

  function toggleExpanded(key) {
    setExpanded(function(prev) { var n = Object.assign({}, prev); n[key] = !n[key]; return n; });
  }

  function channelPill(ch, count) {
    var colour = CHANNEL_COLOURS[ch] || "#8B734A";
    return React.createElement("div", {
      key: ch,
      style: { display: "inline-flex", alignItems: "center", gap: 6, background: colour + "14", color: colour, padding: "4px 10px", borderRadius: 12, fontSize: 11, fontWeight: 600, border: "1px solid " + colour + "33" }
    },
      React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: colour } }),
      (channelLabels[ch] || ch) + " \u00b7 " + count
    );
  }

  function renderInteraction(item, i) {
    var colour = CHANNEL_COLOURS[item.channel] || "#8B734A";
    return React.createElement("div", {
      key: i,
      style: { display:"flex", gap:10, padding:"8px 10px", borderLeft:"2px solid " + colour, background:"rgba(139,115,74,0.03)", borderRadius:4, marginBottom:4, alignItems:"flex-start" }
    },
      React.createElement("div", { style: { fontSize:10, fontWeight:600, color:"#2A2131", width:44, flexShrink:0 } }, item.time || ""),
      React.createElement("div", { style: { flex:1, minWidth:0 } },
        React.createElement("div", { style: { fontSize:12, fontWeight:500, color:"#2A2131" } }, item.client_name || "Unknown"),
        item.summary && React.createElement("div", { style: { fontSize:10, color:"#8A8490", marginTop:2 } }, item.summary),
        item.client_email && React.createElement("div", { style: { fontSize:9, color:"#8B734A", marginTop:1 } }, item.client_email)
      ),
      item.escalated && React.createElement("span", { style: { fontSize:8, fontWeight:700, color:"#c83c3c", background:"rgba(200,60,60,0.1)", padding:"2px 6px", borderRadius:3, flexShrink:0 } }, "ESCALATED"),
      React.createElement("span", { style: { fontSize:9, color:"#8A8490", flexShrink:0 } }, item.handled_by || "")
    );
  }

  return React.createElement("div", null,
    // Today summary header
    React.createElement("div", {
      style: { background:"#2A2131", borderRadius:8, padding:"18px 20px", marginBottom:20, color:"#F6EFED" }
    },
      React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8 } },
        React.createElement("div", null,
          React.createElement("div", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:18, fontWeight:400 } }, "Today's Interactions"),
          React.createElement("div", { style: { fontSize:11, color:"#C4A97A", marginTop:2 } }, today.dayName + " " + today.displayDate)
        ),
        React.createElement("div", { style: { textAlign:"right" } },
          React.createElement("div", { style: { fontSize:28, fontWeight:700, color:"#C4A97A" } }, today.total),
          React.createElement("div", { style: { fontSize:9, color:"rgba(246,239,237,0.5)", textTransform:"uppercase", letterSpacing:"0.06em" } }, "total")
        )
      ),
      today.escalations > 0 && React.createElement("div", {
        style: { marginTop:10, padding:"6px 10px", background:"rgba(200,60,60,0.2)", borderRadius:4, fontSize:11, color:"#ffc4c4" }
      }, "\u26A0 " + today.escalations + " escalation" + (today.escalations>1?"s":"") + " today"),
      today.total > 0 && React.createElement("div", { style: { display:"flex", gap:6, flexWrap:"wrap", marginTop:12 } },
        Object.keys(today.channelCounts).sort().map(function(ch) { return channelPill(ch, today.channelCounts[ch]); })
      )
    ),
    // Today's interactions detail
    today.total > 0 && React.createElement("div", { style: { marginBottom:24 } },
      Object.keys(today.byChannel).sort().map(function(ch) {
        return React.createElement("div", { key: ch, style: { marginBottom:14 } },
          React.createElement("div", { style: { fontSize:10, fontWeight:600, color: CHANNEL_COLOURS[ch] || "#8B734A", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:6 } },
            (channelLabels[ch] || ch) + " (" + today.byChannel[ch].length + ")"
          ),
          today.byChannel[ch].map(renderInteraction)
        );
      })
    ),
    today.total === 0 && React.createElement("div", {
      style: { padding:30, textAlign:"center", background:"rgba(139,115,74,0.04)", borderRadius:6, marginBottom:24, fontSize:12, color:"#8A8490", fontStyle:"italic" }
    }, "No interactions yet today"),
    // Previous 6 days header
    React.createElement("div", { style: { fontSize:11, fontWeight:600, color:"#8B734A", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:10 } }, "Previous 6 days"),
    // Day cards
    days.slice(1).map(function(day) {
      var isExp = !!expanded[day.date];
      return React.createElement("div", {
        key: day.date,
        style: { background:"#fff", borderRadius:6, padding:"12px 14px", marginBottom:8, boxShadow:"0 1px 3px rgba(0,0,0,0.04)", cursor: day.total > 0 ? "pointer" : "default" },
        onClick: function() { if (day.total > 0) toggleExpanded(day.date); }
      },
        React.createElement("div", { style: { display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, flexWrap:"wrap" } },
          React.createElement("div", null,
            React.createElement("div", { style: { fontSize:13, fontWeight:600, color:"#2A2131" } }, day.dayName),
            React.createElement("div", { style: { fontSize:10, color:"#8A8490" } }, day.displayDate)
          ),
          React.createElement("div", { style: { display:"flex", alignItems:"center", gap:10 } },
            day.escalations > 0 && React.createElement("span", { style: { fontSize:9, fontWeight:700, color:"#c83c3c", background:"rgba(200,60,60,0.08)", padding:"2px 6px", borderRadius:3 } }, day.escalations + " ESC"),
            React.createElement("span", { style: { fontSize:18, fontWeight:700, color: day.total > 0 ? "#8B734A" : "#C4C0C5" } }, day.total),
            day.total > 0 && React.createElement("span", { style: { fontSize:10, color:"#8B734A" } }, isExp ? "\u25B2" : "\u25BC")
          )
        ),
        day.total > 0 && React.createElement("div", { style: { display:"flex", gap:4, flexWrap:"wrap", marginTop:8 } },
          Object.keys(day.channelCounts).sort().map(function(ch) { return channelPill(ch, day.channelCounts[ch]); })
        ),
        isExp && day.total > 0 && React.createElement("div", { style: { marginTop:12, paddingTop:10, borderTop:"1px solid rgba(139,115,74,0.1)" } },
          Object.keys(day.byChannel).sort().map(function(ch) {
            return React.createElement("div", { key: ch, style: { marginBottom:8 } },
              React.createElement("div", { style: { fontSize:9, fontWeight:600, color: CHANNEL_COLOURS[ch] || "#8B734A", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:4 } },
                channelLabels[ch] || ch
              ),
              day.byChannel[ch].map(renderInteraction)
            );
          })
        )
      );
    })
  );
}

// ===== TASKS TAB (Salon Manager) =====
// Field readers are defensive: the salon manager owns the task schema, so we accept a
// spread of likely key names/casings and never crash on a missing field.
function taskVal(obj, keys, fallback) {
  if (!obj) return fallback;
  for (var i = 0; i < keys.length; i++) {
    var v = obj[keys[i]];
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return fallback;
}
function taskId(t)      { return taskVal(t, ["task_id", "id", "taskId", "_id", "uuid"], ""); }
function taskStylist(t) { return taskVal(t, ["assigned_to", "assignedTo", "stylist", "assigned_stylist", "assignedStylist", "staff", "stylist_name"], ""); }
// FIX-163: score a task so the board can show highest-priority first (the team is out-paced
// by task volume — they want urgent/client-facing ones at the top, not creation order).
function taskPriority(t) {
  var title = String(taskVal(t, ["title", "summary", "subject", "description"], "")).toLowerCase();
  var type  = String(taskVal(t, ["type", "task_type", "kind", "category"], "")).toLowerCase();
  var s = 0;
  if (title.indexOf("[urgent]") >= 0 || title.indexOf("urgent") >= 0) s += 100;
  else if (title.indexOf("[high]") >= 0) s += 60;
  else if (title.indexOf("[normal]") >= 0) s += 10;
  if (/chargeback|legal|threat|recover .*fund|bank details/.test(title)) s += 90;
  if (title.indexOf("escalation") >= 0) s += 55;
  if (title.indexOf("refund") >= 0) s += 45;
  if (/missed|waiting since|no response|did ?n.t receive|chasing|has ?n.t received|not received/.test(title)) s += 45;
  if (/no deposit link|deposit link not sent/.test(title)) s += 40;
  if (/ghost|duplicate booking|desync|double.{0,8}deposit|charged twice/.test(title)) s += 35;
  if (type.indexOf("squeeze") >= 0) s += 50;   // time-sensitive booking ask
  if (type.indexOf("callback") >= 0) s += 45;  // someone's waiting for a call
  if (/kb change request|possible duplicate client|model (slot|call|enquiry)|hcb model/.test(title)) s -= 30; // low-urgency -> sink
  return s;
}
function taskPrioTier(t) { var s = taskPriority(t); return s >= 90 ? "urgent" : s >= 45 ? "high" : s >= 10 ? "normal" : "low"; }

// v33 (2026-07-07): the team asked for fewer tasks on the board. Robot-generated system
// suggestions (KB change proposals, duplicate-client merges, ghost/desync alerts, build
// requests) stay resolvable but live in a collapsed section UNDER the client work, so the
// default view is only "do this for a client". Client-facing enquiries (model calls,
// callbacks, escalations) are NOT system suggestions and stay on the main board.
function isSystemSuggestion(t) {
  var title = String(taskVal(t, ["title", "summary", "subject", "description"], "")).toLowerCase();
  var type  = String(taskVal(t, ["type", "task_type", "kind", "category"], "")).toLowerCase();
  if (type === "kb_change" || type === "build_request") return true;
  return /kb change request|possible duplicate client|duplicate client record|merge (these |the )?client|ghost booking|airtable desync|calendar\/airtable|build request logged/.test(title);
}

var TASK_TYPE_LABELS = {
  "squeeze_in": "Squeeze-in request",
  "squeeze-in": "Squeeze-in request",
  "squeeze_in_request": "Squeeze-in request",
  "squeezein": "Squeeze-in request"
};
function taskTypeLabel(raw) {
  if (!raw) return "Task";
  var key = String(raw).trim().toLowerCase();
  if (TASK_TYPE_LABELS[key]) return TASK_TYPE_LABELS[key];
  var s = String(raw).replace(/[_-]+/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function stylistColour(name) {
  if (!name) return "#8B734A";
  var n = String(name).trim().toLowerCase();
  for (var i = 0; i < STYLISTS.length; i++) {
    if (STYLISTS[i].name.toLowerCase() === n) return STYLISTS[i].color;
  }
  for (var j = 0; j < STYLISTS.length; j++) {
    var sn = STYLISTS[j].name.toLowerCase();
    if (n.indexOf(sn) !== -1 || sn.indexOf(n) !== -1) return STYLISTS[j].color;
  }
  return "#8B734A";
}
function stylistMatches(raw, name) {
  var a = String(raw || "").trim().toLowerCase();
  var b = String(name || "").trim().toLowerCase();
  if (!a || !b) return false;
  return a === b || a.indexOf(b) !== -1 || b.indexOf(a) !== -1;
}

function parseWhen(raw) {
  if (raw === undefined || raw === null || raw === "") return null;
  var str = String(raw).trim();
  if (/^\d+$/.test(str)) {
    var num = Number(str);
    var ms = num < 1e12 ? num * 1000 : num; // treat 10-digit values as epoch seconds
    var de = new Date(ms);
    return isNaN(de.getTime()) ? null : de;
  }
  var d = new Date(str);
  return isNaN(d.getTime()) ? null : d;
}
function relativeOpen(raw) {
  var d = parseWhen(raw);
  if (!d) return "";
  var secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 0) secs = 0;
  if (secs < 60) return "just now";
  var mins = Math.floor(secs / 60);
  if (mins < 60) return mins + "m open";
  var hrs = Math.floor(mins / 60);
  if (hrs < 24) return hrs + "h open";
  var days = Math.floor(hrs / 24);
  return days + "d open";
}

var RESOLVED_BY_OPTIONS = ["Catherine", "Amber", "Jess L", "Jess S", "Team"];

// Resolution routing depends on task type (per the salon manager contract):
//  - squeeze_in  -> POST /api/webhook/task-resolved  { task_id, resolution, team_notes, resolved_by }
//  - everything else -> POST /api/tasks/{id}/resolve { status, team_notes }
var MODE_META = {
  can_fit:      { phrase: "Confirming the team can fit this in", colour: "#3F8F5B" },
  cannot_fit:   { phrase: "Confirming the team cannot fit this in", colour: "#c83c3c" },
  done:         { phrase: "Marking this task done", colour: "#3F8F5B" },
  in_progress:  { phrase: "Marking this task in progress", colour: "#8B734A" },
  not_possible: { phrase: "Marking this task not possible", colour: "#c83c3c" }
};

function TaskCard(props) {
  var task = props.task, onResolved = props.onResolved;
  var _m = useState(null), mode = _m[0], setMode = _m[1];        // null | "can_fit" | "cannot_fit"
  var _n = useState(""), notes = _n[0], setNotes = _n[1];
  var _rb = useState("Team"), resolvedBy = _rb[0], setResolvedBy = _rb[1];
  var _sub = useState(false), submitting = _sub[0], setSubmitting = _sub[1];
  var _err = useState(""), err = _err[0], setErr = _err[1];

  var id       = taskId(task);
  var ctxNote  = taskVal(task, ["team_notes","context","teamNotes","team_note"], ""); // v35: creation context the agent wrote
  var rawType  = taskVal(task, ["type", "task_type", "kind", "category"], "");
  var title    = taskVal(task, ["title", "summary", "subject", "description"], "");
  var client   = taskVal(task, ["client_name", "clientName", "client", "customer_name", "customerName", "name"], "");
  var channel  = taskVal(task, ["client_channel", "channel", "source"], "");
  var service  = taskVal(task, ["requested_service", "service", "service_name", "serviceName", "service_requested"], "");
  var reqDate  = taskVal(task, ["requested_date", "requestedDate", "booking_date", "slot_date", "preferred_date"], "");
  var reqTime  = taskVal(task, ["requested_time", "requestedTime", "slot_time", "preferred_time"], "");
  var reqWhen  = taskVal(task, ["requested_datetime", "requestedDateTime", "requested_at", "datetime", "slot"], "");
  var stylist  = taskStylist(task);
  var created  = taskVal(task, ["created_at", "createdAt", "created", "created_time", "createdTime", "timestamp", "raised_at"], "");
  var fallback = taskVal(task, ["fallback_offered", "fallback_slot", "fallbackSlot", "offered_slot", "offeredSlot", "alternative_slot", "fallback", "offered"], "");

  var col = stylistColour(stylist);
  var ageStr = relativeOpen(created);
  var isSqueeze = String(rawType).toLowerCase().indexOf("squeeze") !== -1;

  var whenStr = "";
  if (reqDate || reqTime) {
    whenStr = [reqDate, reqTime].filter(Boolean).join(" · ");
  } else if (reqWhen) {
    var pw = parseWhen(reqWhen);
    whenStr = pw ? pw.toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : String(reqWhen);
  }

  function submit() {
    if (submitting || !mode) return;
    setSubmitting(true); setErr("");
    var url, payload, okMsg;
    if (isSqueeze) {
      url = TASK_RESOLVED_API;                                    // re-runs the agent to book + message the client
      payload = { task_id: id, resolution: mode, team_notes: notes, resolved_by: resolvedBy };
      okMsg = "Sent to the salon manager, it will update the client.";
    } else {
      url = CB_AGENT_BASE + "/api/tasks/" + encodeURIComponent(id) + "/resolve";
      payload = { status: mode, team_notes: notes };             // status: done | not_possible | in_progress
      okMsg = "Task updated, the salon manager has it.";
    }
    fetch(url, {
      method: "POST",
      headers: Object.assign({ "Content-Type": "application/json" }, window.CB_AUTH ? window.CB_AUTH.headers() : {}),
      body: JSON.stringify(payload)
    }).then(function(r) {
      if (r.status === 401 && window.CB_AUTH) { window.CB_AUTH.onAuthFail(); }
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json().catch(function() { return {}; });
    }).then(function(d) {
      if (d && (d.ok === false || d.error)) throw new Error((d && d.error) || "Rejected by the salon manager");
      // v34 (2026-07-07): close the 12-Aug "resolved-but-never-told" gap — after a GENERAL
      // task resolves in the store, also notify the agent so it can message the CLIENT with
      // the outcome (squeeze_in already does this via its own path above). Fire-and-forget:
      // the primary resolve has already succeeded, so a notify failure must never break the
      // UX. DARK-LAUNCH: the agent webhook currently rejects general resolutions (only
      // can_fit|cannot_fit) — this call harmlessly 400s until the VPS relaxes it per the
      // spine §8 (7 Jul) contract, then client messaging starts working with no re-deploy.
      // The two resolve paths stay separate (registry rule) — this is notify-only, on top.
      if (!isSqueeze && (mode === "done" || mode === "not_possible")) {
        try {
          fetch(TASK_RESOLVED_API, {
            method: "POST",
            headers: Object.assign({ "Content-Type": "application/json" }, window.CB_AUTH ? window.CB_AUTH.headers() : {}),
            body: JSON.stringify({ task_id: id, resolution: mode, team_notes: notes, resolved_by: resolvedBy, task_type: rawType || "general", notify_only: true })
          })["catch"](function() {});
        } catch (e2) {}
      }
      onResolved(id, okMsg);       // parent removes the card, decrements the badge, shows the toast
    }).catch(function(e) {
      setSubmitting(false);
      setErr("Could not send. " + (e.message || "Please try again."));
    });
  }

  var meta = function(label, value) {
    return React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 3 } },
      React.createElement("span", { style: { color: "#8B734A", fontWeight: 600 } }, label + " "),
      value
    );
  };

  var prioTier = taskPrioTier(task);   // FIX-163: urgent | high | normal | low
  var header = React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 } },
    React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" } },
      React.createElement("span", {
        style: { background: "rgba(139,115,74,0.12)", color: "#8B734A", fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", padding: "3px 8px", borderRadius: 4 }
      }, taskTypeLabel(rawType)),
      (prioTier === "urgent" || prioTier === "high") && React.createElement("span", {
        style: { background: prioTier === "urgent" ? "#C0392B" : "#D98324", color: "#FFFFFF", fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", padding: "3px 8px", borderRadius: 4 }
      }, prioTier),
      id && React.createElement("span", { title: "Task ref " + id, style: { background: "rgba(42,33,49,0.06)", color: "#8A8490", fontSize: 9, fontWeight: 600, letterSpacing: "0.02em", padding: "3px 7px", borderRadius: 4, fontFamily: "ui-monospace,monospace" } }, "#" + String(id).slice(-6))
    ),
    ageStr && React.createElement("span", { style: { fontSize: 10, color: "#A39FA8", flexShrink: 0, whiteSpace: "nowrap" } }, ageStr)
  );

  var body = React.createElement("div", { style: { marginTop: 8 } },
    (title || client) && React.createElement("div", { style: { fontSize: 15, fontWeight: 600, color: "#2A2131", fontFamily: "'Cormorant Garamond',serif", lineHeight: 1.3 } }, title || client),
    title && client && React.createElement("div", { style: { fontSize: 12, color: "#6E6675", marginTop: 2 } }, client + (channel ? " · " + channel : "")),
    !title && channel && React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginTop: 2 } }, channel),
    ctxNote && React.createElement("div", { style: { marginTop: 8, padding: "7px 10px", background: "rgba(139,115,74,0.06)", borderRadius: 4, fontSize: 12, color: "#5d5566", lineHeight: 1.4 } },
      React.createElement("span", { style: { color: "#8B734A", fontWeight: 600 } }, "Context: "), ctxNote),
    service && meta("Service:", service),
    whenStr && meta("Requested:", whenStr),
    stylist && React.createElement("div", { style: { marginTop: 8 } },
      React.createElement("span", {
        style: { display: "inline-block", background: col, color: "#2A2131", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 12 }
      }, stylist === "Any" ? "Any stylist" : stylist)
    ),
    isSqueeze && fallback && React.createElement("div", {
      style: { marginTop: 8, padding: "6px 10px", background: "rgba(139,115,74,0.06)", borderRadius: 4, fontSize: 11, color: "#6E6675" }
    },
      React.createElement("span", { style: { color: "#8B734A", fontWeight: 600 } }, "Fallback offered to client: "),
      fallback
    )
  );

  var actionDefs = isSqueeze
    ? [ { key: "can_fit", label: "Can fit", cls: "cbd-btn-primary" },
        { key: "cannot_fit", label: "Can't fit", cls: "cbd-btn-danger" } ]
    : [ { key: "done", label: "Mark done", cls: "cbd-btn-primary" },
        { key: "in_progress", label: "In progress", cls: "cbd-btn-secondary" },
        { key: "not_possible", label: "Not possible", cls: "cbd-btn-danger" } ];

  var actions;
  if (!mode) {
    actions = React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" } },
      actionDefs.map(function(a) {
        return React.createElement("button", {
          key: a.key, className: "cbd-btn " + a.cls, onClick: function() { setMode(a.key); }
        }, a.label);
      }),
      React.createElement("button", {
        key: "ask-manager", className: "cbd-btn",
        style: { background: "rgba(74,25,66,0.08)", color: "#4a1942", border: "1px solid rgba(74,25,66,0.25)", fontWeight: 600 },
        title: "Hand this task to the salon manager to action",
        onClick: function() { if (window.cbAskManagerAboutTask) { window.cbAskManagerAboutTask("Please handle task " + id + ": " + (title || client || "")); } else { alert("Team chat is still loading, try again in a moment."); } }
      }, "Ask salon manager")
    );
  } else {
    var mm = MODE_META[mode] || { phrase: "Resolving this task", colour: "#8B734A" };
    actions = React.createElement("div", { style: { marginTop: 14, paddingTop: 12, borderTop: "1px solid rgba(139,115,74,0.12)" } },
      React.createElement("div", { style: { fontSize: 11, fontWeight: 600, color: mm.colour, marginBottom: 8 } }, mm.phrase),
      React.createElement("label", { style: { display: "block", fontSize: 10, color: "#8B734A", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 } }, "Team notes"),
      // FIX-174 (2026-07-17): steer, never nag. A bare "done" is trusted (human testimony), but one
      // line of "what happened" is what lets the salon manager + audits reason correctly later —
      // today the agent honestly closed stale tasks purely off notes like "been in"/"rang her".
      // And on MONEY tasks the one fact that matters is refunded-or-not: this week's ~£500 backlog
      // existed because "handled" and "refunded" look identical on the board. Hint only on tasks
      // whose title reads like money (refund/owed/not received); nothing is required or validated.
      (/refund|owed|not received/i.test(String(title)) ? React.createElement("div", {
        style: { fontSize: 11, color: "#8B734A", background: "rgba(139,115,74,0.08)", border: "1px solid rgba(139,115,74,0.2)", borderRadius: 4, padding: "6px 10px", marginBottom: 6, lineHeight: 1.45 }
      }, "💷 Money task — was the deposit actually refunded? Please say so here (“refunded” vs “spoke to her, will sort” read the same later).") : null),
      React.createElement("textarea", {
        value: notes,
        onChange: function(e) { setNotes(e.target.value); },
        placeholder: "One line: what did you do? e.g. “rang her — moved to Thu, changed in calendar” / “refunded in salon”",
        rows: 3,
        style: { width: "100%", fontFamily: "'DM Sans',sans-serif", fontSize: 13, padding: "8px 10px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, background: "#fff", color: "#2A2131", outline: "none", resize: "vertical", boxSizing: "border-box" }
      }),
      isSqueeze && React.createElement("label", { key: "rb-l", style: { display: "block", fontSize: 10, color: "#8B734A", textTransform: "uppercase", letterSpacing: "0.05em", margin: "12px 0 4px" } }, "Resolved by"),
      isSqueeze && React.createElement("select", {
        key: "rb-s", value: resolvedBy,
        onChange: function(e) { setResolvedBy(e.target.value); },
        style: { width: 160 }
      }, RESOLVED_BY_OPTIONS.map(function(o) { return React.createElement("option", { key: o, value: o }, o); })),
      err && React.createElement("div", { style: { fontSize: 11, color: "#c83c3c", marginTop: 10 } }, err),
      React.createElement("div", { className: "cbd-btn-row" },
        React.createElement("button", {
          className: "cbd-btn cbd-btn-secondary", onClick: function() { if (!submitting) { setMode(null); setErr(""); } }
        }, "Cancel"),
        React.createElement("button", {
          className: "cbd-btn cbd-btn-primary", onClick: submit, disabled: submitting,
          style: submitting ? { opacity: 0.6, cursor: "default" } : null
        }, submitting ? "Sending..." : "Confirm")
      )
    );
  }

  return React.createElement("div", {
    style: { background: "#fff", borderRadius: 8, padding: "14px 16px", marginBottom: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.05)", borderLeft: "4px solid " + col, animation: "fadeIn 0.3s ease" }
  }, header, body, actions);
}

function DoneTaskCard(props) {
  var t = props.task || {};
  var isNP = t.status === "not_possible";
  var when = "";
  if (t.resolved_at) {
    try {
      var dt = new Date(t.resolved_at);
      when = dt.toLocaleDateString("en-GB", { day: "numeric", month: "short" }) + " " + dt.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    } catch (e) {}
  }
  return React.createElement("div", { style: { background: "#fff", border: "1px solid rgba(139,115,74,0.15)", borderRadius: 8, padding: "14px 16px", marginBottom: 10, opacity: 0.92 } },
    React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 6 } },
      React.createElement("span", { style: { fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", padding: "3px 9px", borderRadius: 12, background: isNP ? "rgba(200,60,60,0.1)" : "rgba(63,143,91,0.12)", color: isNP ? "#c83c3c" : "#3F8F5B" } }, isNP ? "NOT POSSIBLE" : "DONE"),
      when && React.createElement("span", { style: { fontSize: 10, color: "#8A8490" } }, when)
    ),
    React.createElement("div", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 15, color: "#2A2131", lineHeight: 1.35, marginBottom: t.team_notes ? 6 : 0 } }, String(t.title || "(untitled task)")),
    (t.client_name || t.assigned_to) && React.createElement("div", { style: { fontSize: 11, color: "#8A8490", marginBottom: t.team_notes ? 6 : 0 } },
      [t.client_name, t.assigned_to && t.assigned_to !== "Any" ? "for " + t.assigned_to : null].filter(Boolean).join(" \u00b7 ")),
    t.team_notes && React.createElement("div", { style: { fontSize: 11, color: "#5d5566", background: "rgba(139,115,74,0.05)", borderRadius: 4, padding: "6px 10px" } }, String(t.team_notes))
  );
}

function TasksTab(props) {
  var tasks = props.tasks || [], loading = props.loading, error = props.error, onResolved = props.onResolved;
  var _f = useState("all"), filter = _f[0], setFilter = _f[1];
  var _t = useState(null), toast = _t[0], setToast = _t[1];
  // View: open (actionable board) | in_progress | completed (done + not_possible, read-only history)
  var _v = useState("open"), view = _v[0], setView = _v[1];
  var _ss = useState(false), showSys = _ss[0], setShowSys = _ss[1]; // v33: system-suggestions collapsed by default
  var _sb = useState(false), showBacklog = _sb[0], setShowBacklog = _sb[1]; // FIX-172: earlier backlog collapsed by default
  var _d = useState([]), closedTasks = _d[0], setClosedTasks = _d[1];
  var _dl = useState(false), closedLoading = _dl[0], setClosedLoading = _dl[1];
  var _de = useState(false), closedError = _de[0], setClosedError = _de[1];

  function fetchStatus(status) {
    return fetch(TASKS_API + "?status=" + status, { headers: Object.assign({ "Accept": "application/json" }, window.CB_AUTH ? window.CB_AUTH.headers() : {}) })
      .then(function(r) { if (r.status === 401 && window.CB_AUTH) { window.CB_AUTH.onAuthFail(); } if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function(d) { return (d && Array.isArray(d.tasks)) ? d.tasks : (Array.isArray(d) ? d : []); });
  }

  function loadClosed(v) {
    setClosedLoading(true); setClosedError(false);
    var wanted = v === "in_progress" ? ["in_progress"] : ["done", "not_possible"];
    Promise.all(wanted.map(function(st) { return fetchStatus(st)["catch"](function() { return []; }); }))
      .then(function(lists) {
        var merged = [].concat.apply([], lists);
        merged.sort(function(a, b) { return String(b.resolved_at || "").localeCompare(String(a.resolved_at || "")); });
        setClosedTasks(merged); setClosedLoading(false);
      })
      ["catch"](function() { setClosedError(true); setClosedLoading(false); });
  }

  function switchView(v) {
    setView(v);
    if (v !== "open") loadClosed(v); // always refresh on switch — cheap, and picks up tasks resolved this session
  }

  function handleResolved(id, msg) {
    setToast(msg || "Task updated, the salon manager has it.");
    onResolved(id);
  }

  var filterPills = ["all"].concat(STYLISTS.map(function(s) { return s.name; }));
  var filtered = filter === "all" ? tasks : tasks.filter(function(t) { return stylistMatches(taskStylist(t), filter); });
  // FIX-163: highest-priority at the top (urgent/escalation/refund/callback first), oldest-first within a tier
  // so the longest-waiting client wins. Stable copy — never mutate props.tasks.
  filtered = filtered.slice().sort(function(a, b) {
    var pa = taskPriority(a), pb = taskPriority(b);
    if (pb !== pa) return pb - pa;
    var ca = String(taskVal(a, ["created_at", "createdAt", "created", "created_time", "createdTime", "timestamp", "raised_at"], ""));
    var cb = String(taskVal(b, ["created_at", "createdAt", "created", "created_time", "createdTime", "timestamp", "raised_at"], ""));
    return ca < cb ? -1 : ca > cb ? 1 : 0;
  });
  // v33: split the board — client work front and centre, robot suggestions collapsed below.
  var teamTasks = filtered.filter(function(t) { return !isSystemSuggestion(t); });
  var sysTasks = filtered.filter(isSystemSuggestion);
  var teamAll = tasks.filter(function(t) { return !isSystemSuggestion(t); }).length;
  var sysAll = tasks.length - teamAll;
  // FIX-172: split the team's work into what's NEW vs the backlog FIX-170 uncovered. When v36
  // merged in_progress into this board the count jumped 2 -> 78 overnight with no explanation,
  // and the team reasonably read it as "79 new problems". Nothing was created: 76 were already
  // open, the board had just been hiding anything marked in_progress. Label it, don't bury it.
  var newTasks = teamTasks.filter(function(t) { return t.__cbBucket !== "backlog"; });
  var backlogTasks = teamTasks.filter(function(t) { return t.__cbBucket === "backlog"; });
  var newAll = tasks.filter(function(t) { return !isSystemSuggestion(t) && t.__cbBucket !== "backlog"; }).length;
  var backlogAll = teamAll - newAll;

  var viewDefs = [
    // FIX-170: this board now carries open + in_progress (all unresolved work), so "To do" is
    // the accurate label — "Open" would under-describe it and re-hide the in_progress items.
    { id: "open", label: "To do" + (tasks.length ? " (" + tasks.length + ")" : "") },
    { id: "in_progress", label: "In progress" },
    { id: "completed", label: "Completed" }
  ];
  var viewRow = React.createElement("div", { style: { display: "flex", gap: 6, marginBottom: 12 } },
    viewDefs.map(function(v) {
      var active = view === v.id;
      return React.createElement("button", {
        key: v.id, onClick: function() { switchView(v.id); },
        style: { background: active ? "#2A2131" : "transparent", color: active ? "#F6EFED" : "#2A2131", border: "1px solid " + (active ? "#2A2131" : "rgba(42,33,49,0.3)"), borderRadius: 6, padding: "6px 16px", fontSize: 11, fontWeight: 600, cursor: "pointer", letterSpacing: "0.03em", transition: "all 0.2s" }
      }, v.label);
    })
  );

  var pillRow = React.createElement("div", { style: { display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" } },
    filterPills.map(function(f) {
      var active = filter === f;
      var col = f === "all" ? "#8B734A" : stylistColour(f);
      var textCol = active ? (f === "all" ? "#F6EFED" : "#2A2131") : col;
      return React.createElement("button", {
        key: f, onClick: function() { setFilter(f); },
        style: { background: active ? col : "transparent", color: textCol, border: "1px solid " + (active ? col : col + "55"), borderRadius: 20, padding: "5px 14px", fontSize: 11, fontWeight: 600, cursor: "pointer", letterSpacing: "0.03em", transition: "all 0.2s" }
      }, f === "all" ? "All" : f);
    })
  );

  var heading = React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 4 } },
    React.createElement("h2", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 400, color: "#2A2131" } }, "Team Tasks"),
    React.createElement("span", { style: { fontSize: 11, color: "#8B734A" } }, view === "open" ? (newAll + (newAll === 1 ? " new task" : " new tasks") + (backlogAll ? " · " + backlogAll + " earlier backlog" : "") + (sysAll ? " · " + sysAll + " system" : "")) : (closedTasks.length + " task" + (closedTasks.length === 1 ? "" : "s")))
  );
  var subhead = React.createElement("p", { style: { fontSize: 11, color: "#8A8490", marginBottom: 12 } },
    view === "open" ? "Raised by the salon manager. Resolve and it will update the client." : (view === "in_progress" ? "Tasks someone has picked up but not finished yet." : "Resolved history \u2014 what was done and when."));

  var content;
  if (view === "open") {
    if (loading && tasks.length === 0) {
      content = React.createElement("div", { style: { textAlign: "center", padding: 60 } },
        React.createElement("div", { style: { width: 24, height: 24, border: "2px solid rgba(139,115,74,0.2)", borderTopColor: "#8B734A", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" } }),
        React.createElement("p", { style: { fontSize: 12, color: "#8B734A" } }, "Loading tasks...")
      );
    } else if (error && tasks.length === 0) {
      content = React.createElement("div", {
        style: { padding: "30px 20px", textAlign: "center", background: "rgba(200,60,60,0.06)", border: "1px solid rgba(200,60,60,0.2)", borderRadius: 6, color: "#c83c3c", fontSize: 13 }
      }, "Can't reach the salon manager, check the agent is running");
    } else {
      // v33: client tasks first; system suggestions in a collapsed section below.
      var sysSection = sysTasks.length ? React.createElement("div", { key: "sys-section", style: { marginTop: 18 } },
        React.createElement("button", {
          onClick: function() { setShowSys(!showSys); },
          style: { width: "100%", textAlign: "left", background: "rgba(139,115,74,0.06)", border: "1px dashed rgba(139,115,74,0.35)", borderRadius: 6, padding: "10px 14px", fontSize: 12, color: "#8B734A", cursor: "pointer", fontWeight: 600, letterSpacing: "0.02em" }
        }, (showSys ? "▾ " : "▸ ") + "System suggestions (" + sysTasks.length + ") — KB proposals, duplicate-client merges, data checks. For Shane/office review, not day-to-day salon work."),
        showSys && React.createElement("div", { style: { marginTop: 10 } },
          sysTasks.map(function(t, i) {
            return React.createElement(TaskCard, { key: taskId(t) || ("sys" + i), task: t, onResolved: handleResolved });
          })
        )
      ) : null;
      // FIX-172: the earlier backlog gets its own labelled, collapsed section with a plain-English
      // explanation. Collapsed-with-a-visible-count is NOT the FIX-170 bug (silently vanishing with
      // no indication) — the count is stated, it's in the tab badge, and one tap opens it.
      var backlogSection = backlogTasks.length ? React.createElement("div", { key: "backlog-section", style: { marginTop: 18 } },
        React.createElement("button", {
          onClick: function() { setShowBacklog(!showBacklog); },
          style: { width: "100%", textAlign: "left", background: "rgba(139,115,74,0.06)", border: "1px solid rgba(139,115,74,0.18)", borderRadius: 6, padding: "10px 12px", fontSize: 11, color: "#8B734A", fontWeight: 600, cursor: "pointer", letterSpacing: "0.02em", lineHeight: 1.5 }
        }, (showBacklog ? "▾ " : "▸ ") + "Earlier backlog (" + backlogTasks.length + ") — these are NOT new. They were already open; the board was hiding anything marked “in progress” until we fixed it on 16 July. Some are weeks old and still need action."),
        showBacklog && React.createElement("div", { style: { marginTop: 10 } },
          backlogTasks.map(function(t, i) {
            return React.createElement(TaskCard, { key: taskId(t) || i, task: t, onResolved: handleResolved });
          })
        )
      ) : null;

      var emptyTeam = newTasks.length === 0 ? React.createElement("div", {
        key: "empty-team",
        style: { padding: 40, textAlign: "center", background: "rgba(139,115,74,0.04)", borderRadius: 6, fontSize: 13, color: "#8A8490", fontStyle: "italic" }
      }, tasks.length === 0 ? "No open tasks right now." : (filter !== "all" && filtered.length === 0 ? "No open tasks for " + filter + "." : (backlogTasks.length ? "Nothing new today — the earlier backlog is below." : "No client tasks right now — nice work."))) : null;
      content = (emptyTeam ? [emptyTeam] : newTasks.map(function(t, i) {
        return React.createElement(TaskCard, { key: taskId(t) || i, task: t, onResolved: handleResolved });
      })).concat(backlogSection ? [backlogSection] : []).concat(sysSection ? [sysSection] : []);
    }
  } else {
    if (closedLoading) {
      content = React.createElement("div", { style: { textAlign: "center", padding: 60 } },
        React.createElement("div", { style: { width: 24, height: 24, border: "2px solid rgba(139,115,74,0.2)", borderTopColor: "#8B734A", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" } }),
        React.createElement("p", { style: { fontSize: 12, color: "#8B734A" } }, "Loading...")
      );
    } else if (closedError) {
      content = React.createElement("div", {
        style: { padding: "30px 20px", textAlign: "center", background: "rgba(200,60,60,0.06)", border: "1px solid rgba(200,60,60,0.2)", borderRadius: 6, color: "#c83c3c", fontSize: 13 }
      }, "Can't reach the salon manager, check the agent is running");
    } else if (closedTasks.length === 0) {
      content = React.createElement("div", {
        style: { padding: 40, textAlign: "center", background: "rgba(139,115,74,0.04)", borderRadius: 6, fontSize: 13, color: "#8A8490", fontStyle: "italic" }
      }, view === "in_progress" ? "Nothing marked in progress." : "No completed tasks yet.");
    } else {
      content = closedTasks.map(function(t, i) {
        return React.createElement(DoneTaskCard, { key: taskId(t) || i, task: t });
      });
    }
  }

  return React.createElement("div", { style: { animation: "fadeIn 0.3s ease" } },
    heading,
    subhead,
    // Thin banner when a poll fails but we still have cached tasks to show.
    view === "open" && error && tasks.length > 0 && React.createElement("div", {
      style: { padding: "6px 12px", background: "rgba(200,60,60,0.08)", borderRadius: 4, color: "#c83c3c", fontSize: 11, marginBottom: 12 }
    }, "Can't reach the salon manager, check the agent is running"),
    viewRow,
    view === "open" && pillRow,
    content,
    toast && React.createElement(Toast, { message: toast, isError: false, onClose: function() { setToast(null); } })
  );
}

function StaffDashboard() {
  var fromCalendar = window.location.search.indexOf("from=calendar") !== -1;
  // Persist unlock for the browser tab so refreshes don't re-prompt staff during a shift.
  // Uses sessionStorage (not localStorage) — closing the tab/browser still requires PIN.
  // 8-hour expiry as a backstop in case the tab stays open across shifts.
  var SESS_KEY = "cb_staff_unlocked_until";
  var sessionUnlocked = false;
  try {
    var raw = window.sessionStorage.getItem(SESS_KEY);
    if (raw && parseInt(raw, 10) > Date.now()) sessionUnlocked = true;
  } catch (e) {}
  var _u = useState(!STAFF_PIN || fromCalendar || sessionUnlocked), unlocked = _u[0], setUnlocked = _u[1];
  var _t = useState("calendar"), tab = _t[0], setTab = _t[1];

  // Session-expiry bounce: any agent call that 401s fires `cb-auth-expired` -> re-lock to the PIN screen.
  useEffect(function () {
    function onExpired() { setUnlocked(false); }
    window.addEventListener("cb-auth-expired", onExpired);
    return function () { window.removeEventListener("cb-auth-expired", onExpired); };
  }, []);

  // ===== Salon manager tasks — shared so the tab badge stays live on every tab =====
  var _tk = useState([]), openTasks = _tk[0], setOpenTasks = _tk[1];
  var _tkl = useState(true), tasksLoading = _tkl[0], setTasksLoading = _tkl[1];
  var _tke = useState(false), tasksError = _tke[0], setTasksError = _tke[1];
  // Ids resolved this session — suppressed from re-appearing if a poll lands before the agent closes them.
  var resolvedRef = React.useRef({});

  // FIX-170 (2026-07-16): the actionable board + tab badge fetched status=open ONLY, so the
  // moment a task became in_progress it vanished from the board and stopped counting toward
  // the badge — a one-way trip off the queue, with nothing to bring it back. 66 tasks (60 real
  // client items, the oldest 30+ days: Saffa Abrar's double deposit, Nashwah urgent x2, a
  // patch-test reaction) were invisible this way while the board read "all done" to the team.
  // Cause of the flip is both the agent marking work started and tasks STRANDED there when the
  // agent crashed mid-task. in_progress is NOT done — pull it alongside open so a status change
  // can never hide client work again. Dedup by id (a task can only appear once).
  var fetchOpenTasks = useCallback(function() {
    var pull = function(status) {
      return fetch(TASKS_API + "?status=" + status, { headers: Object.assign({ "Accept": "application/json" }, window.CB_AUTH ? window.CB_AUTH.headers() : {}) })
        .then(function(r) { if (r.status === 401 && window.CB_AUTH) { window.CB_AUTH.onAuthFail(); } if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
        .then(function(d) { return (d && Array.isArray(d.tasks)) ? d.tasks : (Array.isArray(d) ? d : []); });
    };
    // open must succeed; in_progress degrades to [] so one failing call can never blank the board.
    return Promise.all([pull("open"), pull("in_progress")["catch"](function() { return []; })])
      .then(function(res) {
        // FIX-172 (2026-07-17): tag which endpoint each task came from, so the board can say
        // "2 new + 76 earlier backlog" instead of one alarming pile of 78. Tagging at fetch time
        // is robust — it doesn't depend on guessing the API's status field name. "new" wins on
        // a dedup collision (a task should never be in both).
        (res[0] || []).forEach(function(t) { if (t) t.__cbBucket = "new"; });
        (res[1] || []).forEach(function(t) { if (t) t.__cbBucket = "backlog"; });
        var seen = {}, list = [];
        res[0].concat(res[1]).forEach(function(t) {
          var id = taskId(t);
          if (id && seen[id]) return;
          if (id) seen[id] = 1;
          if (!resolvedRef.current[id]) list.push(t);
        });
        setOpenTasks(list); setTasksError(false); setTasksLoading(false);
      })
      .catch(function() { setTasksError(true); setTasksLoading(false); });
  }, []);

  useEffect(function() {
    if (!unlocked) return;
    fetchOpenTasks();
    var iv = setInterval(fetchOpenTasks, 45000);
    function onFocus() { fetchOpenTasks(); }
    function onVis() { if (!document.hidden) fetchOpenTasks(); }
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    return function() {
      clearInterval(iv);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [unlocked, fetchOpenTasks]);

  // Refresh the moment staff switch to the Tasks tab.
  useEffect(function() { if (unlocked && tab === "tasks") fetchOpenTasks(); }, [tab, unlocked, fetchOpenTasks]);

  function removeTask(id) {
    resolvedRef.current[id] = true;
    setOpenTasks(function(prev) { return prev.filter(function(t) { return taskId(t) !== id; }); });
  }

  function handleUnlock() {
    try { window.sessionStorage.setItem(SESS_KEY, String(Date.now() + 8 * 60 * 60 * 1000)); } catch (e) {}
    setUnlocked(true);
  }

  if (!unlocked) {
    return React.createElement(PinScreen, { onUnlock: handleUnlock });
  }

  // FIX-179 (2026-07-18): "Something not working?" \u2014 the team's route into cb-ops.
  // Until now the autonomous fixer only woke for errors WF71 detected (21 of 25 build
  // requests were error-triage; ZERO came from the salon team). So a fault that didn't throw
  // an exception had no path from the person who noticed it to the thing that fixes systems \u2014
  // it sat on the task board waiting for a human. The quiet faults are the costly ones: none
  // of this week's real damage (a buried colour complaint, the voice agent with no date, this
  // board hiding in_progress) raised a single error. Lives in the header, not a tab, because
  // you notice a problem wherever you happen to be.
  var reportBtn = React.createElement(ReportProblem, { surface: tab });

  var tabs = [
    { id: "calendar", label: "Today", icon: "\uD83D\uDCC5" },
    { id: "checkout", label: "Checkout", icon: "\uD83D\uDCB3", href: "/pages/salon-checkout" },
    { id: "fullcalendar", label: "Calendar", icon: "\uD83D\uDDD3", href: "/pages/team-calendar" },
    { id: "tasks", label: "Tasks", icon: "\uD83D\uDCCB", badge: openTasks.length },
    { id: "activity", label: "Activity", icon: "\uD83D\uDCDD" },
    { id: "interactions", label: "Interactions", icon: "\uD83D\uDCAC" },
    { id: "academy", label: "Academy", icon: "\uD83C\uDF93" },
    { id: "holidays", label: "Holidays", icon: "\uD83C\uDF34" },
    { id: "performance", label: "Performance", icon: "\uD83D\uDCCA" },
    { id: "clients", label: "Clients", icon: "\uD83D\uDC65" },
    { id: "emails", label: "Emails", icon: "\u2709\uFE0F" },
    { id: "knowledge", label: "Knowledge", icon: "\uD83D\uDCDA" },
    { id: "finance", label: "Finance", icon: "\uD83D\uDCB7" },
    { id: "feedback", label: "Feedback", icon: "\uD83D\uDCAC" },
    { id: "builds", label: "Builds", icon: "\uD83D\uDEE0\uFE0F" }
  ];

  return React.createElement("div", { style: { maxWidth:900, margin:"0 auto", padding:"20px 16px 60px", animation:"fadeIn 0.3s ease" } },
    // Header
    React.createElement("div", { style: { textAlign:"center", marginBottom:28 } },
      React.createElement("h1", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontWeight:400, color:"#2A2131", letterSpacing:"0.02em" } }, "Staff Dashboard"),
      React.createElement("p", { style: { fontSize:12, color:"#8B734A", letterSpacing:"0.04em" } }, "COLOUR BLEND BY CATHERINE BODEN"),
      reportBtn
    ),
    // Tab bar
    React.createElement("div", {
      style: { display:"flex", gap:4, marginBottom:24, borderBottom:"1px solid rgba(139,115,74,0.15)", paddingBottom:0, overflowX:"auto" }
    },
      tabs.map(function(t) {
        var active = tab === t.id;
        var tabStyle = {
          background: "transparent",
          border: "none",
          borderBottom: active ? "2px solid #8B734A" : "2px solid transparent",
          padding: "10px 18px",
          fontSize: 12,
          fontWeight: active ? 600 : 400,
          color: active ? "#2A2131" : "#8B734A",
          cursor: "pointer",
          letterSpacing: "0.03em",
          transition: "all 0.2s",
          display: "flex",
          alignItems: "center",
          gap: 6,
          textDecoration: "none"
        };
        var badgeEl = (t.badge && t.badge > 0) ? React.createElement("span", {
          style: { marginLeft: 2, background: "#8B734A", color: "#F6EFED", fontSize: 9, fontWeight: 700, minWidth: 16, height: 16, lineHeight: "16px", borderRadius: 8, padding: "0 5px", display: "inline-block", textAlign: "center" }
        }, t.badge) : null;
        if (t.href) {
          return React.createElement("a", {
            key: t.id,
            href: t.href,
            style: tabStyle
          },
            React.createElement("span", { style: { fontSize: 14 } }, t.icon),
            t.label,
            badgeEl
          );
        }
        return React.createElement("button", {
          key: t.id,
          onClick: function() { setTab(t.id); },
          style: tabStyle
        },
          React.createElement("span", { style: { fontSize: 14 } }, t.icon),
          t.label,
          badgeEl
        );
      })
    ),
    // Tab content
    tab === "calendar" && React.createElement(CalendarTab, null),
    tab === "tasks" && React.createElement(TasksTab, { tasks: openTasks, loading: tasksLoading, error: tasksError, onResolved: removeTask }),
    tab === "activity" && React.createElement(ActivityTab, null),
    tab === "interactions" && React.createElement(InteractionsTab, null),
    tab === "academy" && React.createElement(AcademyTab, null),
    tab === "holidays" && React.createElement(HolidaysTab, null),
    tab === "performance" && React.createElement(PerformanceTab, null),
    tab === "clients" && React.createElement(ClientsTab, null),
    tab === "emails" && React.createElement(EmailsTab, null),
    tab === "knowledge" && React.createElement(KnowledgeTab, null),
    tab === "finance" && (window.CBFinanceTab
      ? React.createElement(window.CBFinanceTab, null)
      : React.createElement("div", { style: { padding: 40, textAlign: "center", color: "#9B8E8A", fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic" } }, "Finance tab not loaded. Refresh the page — if it persists, check that cb-salon-finance-v1.js is loaded.")),
    tab === "feedback" && React.createElement(FeedbackTab, null),
    tab === "builds" && React.createElement(BuildsTab, null)
  );
}

// ===== BUILDS TAB =====
// Supervised build pipeline approval surface. LISTS Build Requests via WF88 cb-build-requests
// (read-only). APPROVE/REJECT route through the agent decide-endpoint (Bearer-gated, same PII
// gate as /api/tasks), which flips the Airtable row via its PAT — WF88 stays read-only and the
// dashboard never carries a static secret (FIX-117; cb-ops auth = Option B, 2026-06-15).
var BUILDS_API = "https://n8n.catherineboden.com/webhook/cb-build-requests";

// FIX-179 (2026-07-18): staff-reported problems -> cb-ops. Files a NEW build request only
// (WF88 'report'); it cannot approve or apply anything, so this is not a deploy trigger.
// Deliberately plain-English: the team describes the SYMPTOM, cb-ops investigates from the
// real system state. Never asks them to diagnose — "what did you expect / what happened".
function ReportProblem(props) {
  var _o = useState(false), open = _o[0], setOpen = _o[1];
  var _t = useState(""), text = _t[0], setText = _t[1];
  var _w = useState(""), who = _w[0], setWho = _w[1];
  var _s = useState(""), state = _s[0], setState = _s[1];   // "" | sending | ok:msg | err:msg
  var busy = state === "sending";

  function send() {
    if (busy || text.trim().length < 10) return;
    setState("sending");
    fetch(BUILDS_API, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action: "report",
        description: text.trim(),
        reported_by: (who || "").trim() || "salon team",
        surface: props.surface || "staff-dashboard"
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.ok) { setState("ok:" + (d.message || "Logged, thank you.")); setText(""); }
        else { setState("err:" + ((d && d.message) || (d && d.error) || "Could not log that — please tell Shane.")); }
      })
      .catch(function() { setState("err:Could not reach the system — please tell Shane directly."); });
  }

  if (!open) {
    return React.createElement("button", {
      onClick: function() { setOpen(true); setState(""); },
      style: { marginTop: 10, background: "transparent", border: "1px solid rgba(139,115,74,0.3)", borderRadius: 20,
               padding: "5px 14px", fontSize: 11, color: "#8B734A", cursor: "pointer", letterSpacing: "0.03em" }
    }, "⚠ Something not working?");
  }

  var okMsg = state.indexOf("ok:") === 0 ? state.slice(3) : "";
  var errMsg = state.indexOf("err:") === 0 ? state.slice(4) : "";

  return React.createElement("div", {
    style: { marginTop: 12, textAlign: "left", background: "rgba(139,115,74,0.05)", border: "1px solid rgba(139,115,74,0.25)",
             borderRadius: 8, padding: 14, maxWidth: 560, marginLeft: "auto", marginRight: "auto" }
  },
    React.createElement("div", { style: { fontSize: 12, fontWeight: 600, color: "#2A2131", marginBottom: 4 } }, "Tell the system what's not working"),
    React.createElement("div", { style: { fontSize: 11, color: "#8B734A", marginBottom: 8, lineHeight: 1.5 } },
      "Describe what you saw in your own words — you don't need to know why it happened. It gets looked at automatically within about 15 minutes, and nothing changes without a person approving it."),
    okMsg
      ? React.createElement("div", { style: { fontSize: 12, color: "#2e7d4f", padding: "8px 0", lineHeight: 1.5 } }, "✓ " + okMsg)
      : React.createElement("div", null,
          React.createElement("textarea", {
            value: text, onChange: function(e) { setText(e.target.value); }, rows: 3, autoFocus: true,
            placeholder: "e.g. “Amber's Thursday isn't showing on the calendar” or “a client got two confirmation emails for the same booking”",
            style: { width: "100%", fontFamily: "'DM Sans',sans-serif", fontSize: 13, padding: "8px 10px",
                     border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, background: "#fff", color: "#2A2131",
                     outline: "none", resize: "vertical", boxSizing: "border-box" }
          }),
          React.createElement("input", {
            value: who, onChange: function(e) { setWho(e.target.value); }, placeholder: "Your name (optional)",
            style: { width: "100%", marginTop: 6, fontSize: 12, padding: "6px 10px",
                     border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, boxSizing: "border-box" }
          }),
          errMsg ? React.createElement("div", { style: { fontSize: 11, color: "#c83c3c", marginTop: 6 } }, errMsg) : null,
          React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 10, justifyContent: "flex-end" } },
            React.createElement("button", {
              onClick: function() { setOpen(false); setState(""); }, disabled: busy,
              style: { background: "rgba(139,115,74,0.12)", color: "#8B734A", border: "1px solid rgba(139,115,74,0.2)",
                       borderRadius: 4, padding: "7px 14px", fontSize: 12, cursor: "pointer" }
            }, "Cancel"),
            React.createElement("button", {
              onClick: send, disabled: busy || text.trim().length < 10,
              style: { background: text.trim().length < 10 ? "rgba(139,115,74,0.35)" : "#8B734A", color: "#F6EFED",
                       border: "none", borderRadius: 4, padding: "7px 16px", fontSize: 12, fontWeight: 600,
                       cursor: text.trim().length < 10 ? "default" : "pointer" }
            }, busy ? "Sending…" : "Send")
          )
        ),
    okMsg ? React.createElement("button", {
      onClick: function() { setOpen(false); setState(""); },
      style: { background: "transparent", border: "1px solid rgba(139,115,74,0.3)", borderRadius: 4,
               padding: "5px 12px", fontSize: 11, color: "#8B734A", cursor: "pointer" }
    }, "Close") : null
  );
}
var BUILDS_DECIDE_API = CB_AGENT_BASE + "/api/build-requests/";

function BuildsTab() {
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _e = useState(null), err = _e[0], setErr = _e[1];
  var _a = useState(null), acting = _a[0], setActing = _a[1];
  var _o = useState({}), openDiff = _o[0], setOpenDiff = _o[1];

  function load() {
    setLoading(true); setErr(null);
    fetch(BUILDS_API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "list" }) })
      .then(function(r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function(d) { setData((d && d.requests) || []); setLoading(false); })
      .catch(function(e) { setErr(e.message || "Failed to load"); setLoading(false); });
  }
  useEffect(function() { load(); }, []);

  function decide(req, action) {
    var notes = window.prompt((action === "approve" ? "Approve" : "Reject") + " this build request — optional note:", "");
    if (notes === null) return;
    setActing(req.id);
    fetch(BUILDS_DECIDE_API + encodeURIComponent(req.id) + "/decide", {
      method: "POST",
      headers: Object.assign({ "Content-Type": "application/json" }, window.CB_AUTH ? window.CB_AUTH.headers() : {}),
      body: JSON.stringify({ action: action, notes: notes })
    })
      .then(function(r) { if (r.status === 401 && window.CB_AUTH) { window.CB_AUTH.onAuthFail(); } if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function() { setActing(null); load(); })
      .catch(function(e) { setActing(null); window.alert("Failed: " + (e.message || "")); });
  }

  function statusColor(s) {
    return ({ "new": "#9B8E8A", triaged: "#8B734A", awaiting_approval: "#C19A3E", approved: "#3E8E5A", applied: "#2E7D46", escalated: "#C0622F", rejected: "#B23A48" })[s] || "#9B8E8A";
  }

  if (loading) return React.createElement("div", { style: { textAlign: "center", padding: 60 } }, React.createElement("p", { style: { fontSize: 12, color: "#8B734A" } }, "Loading build requests..."));
  if (err) return React.createElement("div", { style: { textAlign: "center", padding: 40, color: "#B23A48", fontSize: 13 } }, "Could not load build requests: " + err);

  var reqs = data || [];
  return React.createElement("div", null,
    React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 } },
      React.createElement("div", null,
        React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 400, color: "#2A2131" } }, "Builds"),
        React.createElement("p", { style: { fontSize: 11, color: "#8B734A", letterSpacing: "0.04em" } }, "System change requests — review the diff, then approve or reject")
      ),
      React.createElement("button", { onClick: load, style: { background: "transparent", border: "1px solid rgba(139,115,74,0.3)", borderRadius: 4, padding: "6px 12px", fontSize: 11, color: "#8B734A", cursor: "pointer" } }, "Refresh")
    ),
    reqs.length === 0
      ? React.createElement("div", { style: { textAlign: "center", padding: 50, color: "#9B8E8A", fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", fontSize: 15 } }, "No build requests yet. They appear here when the salon manager raises a system change.")
      : reqs.map(function(req) {
          var st = req.Status || "new";
          var isPending = st === "awaiting_approval";
          var diffOpen = !!openDiff[req.id];
          return React.createElement("div", { key: req.id, style: { border: "1px solid rgba(139,115,74,0.18)", borderRadius: 6, padding: "14px 16px", marginBottom: 12, background: "#fff" } },
            React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 } },
              React.createElement("div", { style: { fontSize: 14, fontWeight: 600, color: "#2A2131" } }, req.Title || "(untitled)"),
              React.createElement("span", { style: { fontSize: 10, fontWeight: 700, color: "#fff", background: statusColor(st), borderRadius: 10, padding: "2px 8px", whiteSpace: "nowrap" } }, String(st).replace(/_/g, " "))
            ),
            React.createElement("div", { style: { fontSize: 11, color: "#8B734A", margin: "6px 0", display: "flex", gap: 12, flexWrap: "wrap" } },
              req.Surface ? React.createElement("span", null, "Surface: " + req.Surface) : null,
              req.Severity ? React.createElement("span", null, "Severity: " + req.Severity) : null,
              req["Requested By"] ? React.createElement("span", null, "By: " + req["Requested By"]) : null,
              req["Created At"] ? React.createElement("span", null, String(req["Created At"]).substring(0, 16).replace("T", " ")) : null
            ),
            req.Summary ? React.createElement("div", { style: { fontSize: 12, color: "#4a4a4a", lineHeight: 1.5, marginBottom: 8 } }, req.Summary) : null,
            req.Description ? React.createElement("div", { style: { fontSize: 11.5, color: "#6a6a6a", lineHeight: 1.5, marginBottom: 8, whiteSpace: "pre-wrap" } }, req.Description) : null,
            req.Diff ? React.createElement("div", null,
              React.createElement("button", { onClick: function() { var n = Object.assign({}, openDiff); n[req.id] = !diffOpen; setOpenDiff(n); }, style: { background: "transparent", border: "none", color: "#8B734A", fontSize: 11, cursor: "pointer", padding: 0, textDecoration: "underline" } }, diffOpen ? "Hide diff" : "View diff"),
              diffOpen ? React.createElement("pre", { style: { background: "#2A2131", color: "#E6E0DC", fontSize: 11, lineHeight: 1.45, padding: 12, borderRadius: 4, overflowX: "auto", marginTop: 8, whiteSpace: "pre", fontFamily: "monospace" } }, req.Diff) : null
            ) : null,
            req["Decision Notes"] ? React.createElement("div", { style: { fontSize: 11, color: "#8B734A", marginTop: 8, fontStyle: "italic" } }, "Note: " + req["Decision Notes"]) : null,
            isPending ? React.createElement("div", { style: { display: "flex", gap: 8, marginTop: 12 } },
              React.createElement("button", { disabled: acting === req.id, onClick: function() { decide(req, "approve"); }, style: { background: "#3E8E5A", color: "#fff", border: "none", borderRadius: 4, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer", opacity: acting === req.id ? 0.6 : 1 } }, acting === req.id ? "..." : "Approve"),
              React.createElement("button", { disabled: acting === req.id, onClick: function() { decide(req, "reject"); }, style: { background: "transparent", color: "#B23A48", border: "1px solid #B23A48", borderRadius: 4, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" } }, "Reject")
            ) : null
          );
        })
  );
}

// ===== FEEDBACK TAB =====
const FEEDBACK_API = "https://n8n.catherineboden.com/webhook/cb-staff-feedback";
const FEEDBACK_TYPES = ["Issue", "Suggestion", "Question", "Praise"];
const FEEDBACK_AREAS = ["Booking page","Dashboard","AI agents","Clients tab","Calendar","Email","Voice / Phone","Finance / Checkout","Other"];
const FEEDBACK_SEVERITY = ["Blocker","Annoying","Minor"];

function FeedbackTab() {
  var _type = useState("Issue"), type = _type[0], setType = _type[1];
  var _area = useState("Dashboard"), area = _area[0], setArea = _area[1];
  var _severity = useState("Annoying"), severity = _severity[0], setSeverity = _severity[1];
  var _description = useState(""), description = _description[0], setDescription = _description[1];
  var _submitter = useState(""), submitter = _submitter[0], setSubmitter = _submitter[1];
  var _submitting = useState(false), submitting = _submitting[0], setSubmitting = _submitting[1];
  var _result = useState(null), result = _result[0], setResult = _result[1];
  var _error = useState(null), error = _error[0], setError = _error[1];

  function submit() {
    if (!description.trim() || description.trim().length < 3) {
      setError("Please add a short description.");
      return;
    }
    setSubmitting(true); setError(null); setResult(null);
    fetch(FEEDBACK_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: type,
        area: area,
        severity: type === "Issue" ? severity : null,
        description: description.trim(),
        submitter: submitter.trim() || null,
        source: "dashboard:feedback-tab",
      })
    })
      .then(function(r) { return r.json().then(function(j) { return {ok: r.ok, body: j}; }); })
      .then(function(r) {
        if (!r.ok || !r.body.ok) {
          throw new Error(r.body && r.body.error ? r.body.error : "Submit failed (HTTP " + r.ok + ")");
        }
        setResult(r.body);
        setDescription("");
      })
      .catch(function(e) { setError(e.message || "Unknown error"); })
      .finally(function() { setSubmitting(false); });
  }

  var labelStyle = { display:"block", fontSize:11, fontWeight:600, color:"#8B734A", letterSpacing:"0.05em", textTransform:"uppercase", marginBottom:6 };
  var inputStyle = { width:"100%", padding:"10px 12px", border:"1px solid rgba(139,115,74,0.25)", borderRadius:6, fontSize:14, fontFamily:"inherit", background:"#fff", boxSizing:"border-box" };
  var chipStyle = function(active, color) {
    return {
      padding:"8px 14px", borderRadius:20, border: active ? "1px solid " + color : "1px solid rgba(139,115,74,0.25)",
      background: active ? color + "15" : "#fff", color: active ? color : "#8B734A", fontSize:13, fontWeight: active ? 600 : 400,
      cursor:"pointer", transition:"all 0.15s", fontFamily:"inherit"
    };
  };

  if (result) {
    return React.createElement("div", { style: { maxWidth:560, margin:"40px auto", textAlign:"center", padding:"32px 24px", background:"rgba(34,139,34,0.04)", border:"1px solid rgba(34,139,34,0.15)", borderRadius:12 } },
      React.createElement("div", { style: { fontSize:36, marginBottom:12 } }, "🤍"),
      React.createElement("h3", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:24, color:"#2A2131", margin:"0 0 8px 0" } }, "Thanks for the feedback"),
      React.createElement("p", { style: { fontSize:14, color:"#5C5249", margin:"0 0 20px 0", lineHeight:1.5 } }, "Logged and emailed to Shane. He'll review it and respond if needed."),
      React.createElement("p", { style: { fontSize:11, color:"#9B8E8A", margin:"0 0 24px 0", fontFamily:"monospace" } }, "Reference: " + result.id),
      React.createElement("button", {
        onClick: function() { setResult(null); setError(null); },
        style: { padding:"10px 22px", background:"#8B734A", color:"#fff", border:"none", borderRadius:6, fontSize:13, fontWeight:500, cursor:"pointer", letterSpacing:"0.04em" }
      }, "Send another")
    );
  }

  return React.createElement("div", { style: { maxWidth:640, margin:"0 auto" } },
    React.createElement("div", { style: { marginBottom:24 } },
      React.createElement("h2", { style: { fontFamily:"'Cormorant Garamond',serif", fontSize:24, color:"#2A2131", margin:"0 0 6px 0", fontWeight:400 } }, "Tell us what's not working"),
      React.createElement("p", { style: { fontSize:13, color:"#8B734A", margin:0, lineHeight:1.5 } }, "Anything broken, confusing, or annoying? Or an idea to make the system better? Drop it here — every submission goes straight to Shane.")
    ),

    // Type chips
    React.createElement("div", { style: { marginBottom:18 } },
      React.createElement("label", { style: labelStyle }, "What is this?"),
      React.createElement("div", { style: { display:"flex", flexWrap:"wrap", gap:8 } },
        FEEDBACK_TYPES.map(function(t) {
          var colors = { "Issue":"#c0392b", "Suggestion":"#8B734A", "Question":"#2980b9", "Praise":"#27ae60" };
          return React.createElement("button", {
            key: t, onClick: function() { setType(t); },
            style: chipStyle(type === t, colors[t])
          }, t);
        })
      )
    ),

    // Area select
    React.createElement("div", { style: { marginBottom:18 } },
      React.createElement("label", { style: labelStyle }, "Where in the system?"),
      React.createElement("select", {
        value: area, onChange: function(e) { setArea(e.target.value); },
        style: inputStyle
      },
        FEEDBACK_AREAS.map(function(a) { return React.createElement("option", { key:a, value:a }, a); })
      )
    ),

    // Severity (only if Issue)
    type === "Issue" && React.createElement("div", { style: { marginBottom:18 } },
      React.createElement("label", { style: labelStyle }, "How bad?"),
      React.createElement("div", { style: { display:"flex", gap:8 } },
        FEEDBACK_SEVERITY.map(function(s) {
          var colors = { "Blocker":"#c0392b", "Annoying":"#d4ac0d", "Minor":"#7f8c8d" };
          return React.createElement("button", {
            key: s, onClick: function() { setSeverity(s); },
            style: chipStyle(severity === s, colors[s])
          }, s);
        })
      ),
      React.createElement("p", { style: { fontSize:11, color:"#9B8E8A", margin:"6px 0 0 0", fontStyle:"italic" } }, "Blocker = can't do my job. Annoying = workaround needed. Minor = cosmetic.")
    ),

    // Description
    React.createElement("div", { style: { marginBottom:18 } },
      React.createElement("label", { style: labelStyle }, "What happened? / What would help?"),
      React.createElement("textarea", {
        value: description, onChange: function(e) { setDescription(e.target.value); },
        placeholder: type === "Issue"
          ? "e.g. When I tried to add Sarah's booking the page froze and I had to refresh — happened twice this morning."
          : "e.g. Could the calendar show stylist initials on each booking? Hard to tell at a glance whose client it is.",
        rows: 6,
        style: Object.assign({}, inputStyle, { resize:"vertical", fontFamily:"inherit", lineHeight:1.5 })
      })
    ),

    // Submitter
    React.createElement("div", { style: { marginBottom:24 } },
      React.createElement("label", { style: labelStyle }, "Your name (optional)"),
      React.createElement("input", {
        type:"text", value: submitter, onChange: function(e) { setSubmitter(e.target.value); },
        placeholder: "Leave blank if you'd rather stay anonymous",
        style: inputStyle
      })
    ),

    error && React.createElement("div", {
      style: { padding:"10px 14px", background:"rgba(192,57,43,0.08)", border:"1px solid rgba(192,57,43,0.25)", borderRadius:6, color:"#c0392b", fontSize:13, marginBottom:16 }
    }, error),

    React.createElement("button", {
      onClick: submit, disabled: submitting,
      style: {
        width:"100%", padding:"14px 22px",
        background: submitting ? "#bcb0a3" : "#4a1942",
        color:"#fff", border:"none", borderRadius:6,
        fontSize:14, fontWeight:500, cursor: submitting ? "wait" : "pointer",
        letterSpacing:"0.04em", transition:"all 0.2s"
      }
    }, submitting ? "Sending…" : "Send to Shane")
  );
}

// ===== KNOWLEDGE TAB =====
function KnowledgeTab() {
  var _kb = useState(null), kb = _kb[0], setKb = _kb[1];
  var _kbErr = useState(null), kbErr = _kbErr[0], setKbErr = _kbErr[1];
  var _section = useState(""), section = _section[0], setSection = _section[1];
  var _path = useState(""), path = _path[0], setPath = _path[1];
  var _proposed = useState(""), proposed = _proposed[0], setProposed = _proposed[1];
  var _reason = useState(""), reason = _reason[0], setReason = _reason[1];
  var _by = useState(""), submittedBy = _by[0], setSubmittedBy = _by[1];
  var _saving = useState(false), saving = _saving[0], setSaving = _saving[1];
  var _msg = useState(null), msg = _msg[0], setMsg = _msg[1];

  useEffect(function() {
    fetch(KB_API).then(function(r){ return r.json(); }).then(setKb).catch(function(){ setKbErr("Could not load Knowledge Base."); });
  }, []);

  var sections = ["pricing","hours","bookingPolicy","refundPolicy","aftercare","technique","team","salon","contact","brand","slotDurations","escalationRules","aiRules","videoConsultations","products","academy"];

  function getCurrentValue() {
    if (!kb || !section) return "";
    var sec = kb[section];
    if (!path) return JSON.stringify(sec, null, 2);
    try {
      var tokens = []; var i = 0;
      while (i < path.length) {
        if (path[i] === '.') { i++; continue; }
        if (path[i] === '[') {
          var end = path.indexOf(']', i);
          if (end === -1) break;
          tokens.push({ type:'lookup', value: path.slice(i+1, end) });
          i = end + 1;
        } else {
          var j = i;
          while (j < path.length && path[j] !== '.' && path[j] !== '[') j++;
          tokens.push({ type:'key', name: path.slice(i, j) });
          i = j;
        }
      }
      var cur = sec;
      for (var k = 0; k < tokens.length; k++) {
        var t = tokens[k];
        if (cur == null) return "";
        if (t.type === 'key') cur = cur[t.name];
        else if (Array.isArray(cur)) {
          var idx = cur.findIndex(function(r){ return r && (r.service === t.value || r.name === t.value); });
          cur = idx >= 0 ? cur[idx] : null;
        } else return "";
      }
      return typeof cur === 'string' ? cur : JSON.stringify(cur, null, 2);
    } catch(e) { return ""; }
  }

  var currentValue = getCurrentValue();

  function submit() {
    setMsg(null);
    if (!submittedBy.trim()) { setMsg({ ok:false, text:"Please enter your name." }); return; }
    if (!section) { setMsg({ ok:false, text:"Pick a section." }); return; }
    if (!proposed.trim()) { setMsg({ ok:false, text:"Enter the proposed value." }); return; }
    setSaving(true);
    fetch(KB_SUGGEST_API, {
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body: JSON.stringify({
        submittedBy: submittedBy.trim(),
        section: section,
        fieldPath: path.trim(),
        currentValue: currentValue,
        proposedValue: proposed.trim(),
        reason: reason.trim()
      })
    }).then(function(r){ return r.json(); }).then(function(d){
      if (d && d.success) {
        setMsg({ ok:true, text:"Sent to Catherine for review (" + d.suggestionId + "). She'll get an email with Approve / Reject buttons. The change goes live the moment she approves." });
        setProposed(""); setReason(""); setPath("");
      } else {
        setMsg({ ok:false, text:(d && d.error) || "Failed to submit." });
      }
    }).catch(function(){ setMsg({ ok:false, text:"Network error. Try again." }); }).finally(function(){ setSaving(false); });
  }

  var labelStyle = { display:"block", fontSize:11, color:"#8B734A", textTransform:"uppercase", letterSpacing:"0.06em", marginTop:14, marginBottom:4 };
  var inputStyle = { width:"100%", padding:"8px 10px", border:"1px solid rgba(139,115,74,0.3)", borderRadius:4, fontSize:13, fontFamily:"inherit", boxSizing:"border-box" };

  return React.createElement("div", { style:{ background:"#fff", borderRadius:8, padding:24, boxShadow:"0 1px 3px rgba(42,33,49,0.06)" } },
    React.createElement("h2", { style:{ fontFamily:"'Cormorant Garamond',serif", fontWeight:400, fontSize:22, marginBottom:6 } }, "Suggest a Knowledge Base change"),
    React.createElement("p", { style:{ fontSize:12, color:"#8B734A", marginBottom:18 } }, "Pricing, hours, services, policies, team \u2014 propose a change here. Catherine will get an email and one click approves it. The change goes live for the AI agents, website chat and emails immediately."),
    kbErr && React.createElement("div", { style:{ background:"#fce8e8", color:"#a13b3b", padding:10, borderRadius:4, marginBottom:12, fontSize:12 } }, kbErr),
    React.createElement("label", { style: labelStyle }, "Your name"),
    React.createElement("input", { style: inputStyle, value: submittedBy, onChange:function(e){ setSubmittedBy(e.target.value); }, placeholder:"e.g. Amber" }),
    React.createElement("label", { style: labelStyle }, "Section"),
    React.createElement("select", { style: inputStyle, value: section, onChange:function(e){ setSection(e.target.value); setPath(""); } },
      React.createElement("option", { value:"" }, "\u2014 Choose a section \u2014"),
      sections.map(function(s){ return React.createElement("option", { key:s, value:s }, s); })
    ),
    React.createElement("label", { style: labelStyle }, "Field path", React.createElement("span", { style:{ textTransform:"none", color:"#8A8490", marginLeft:6, fontSize:10, letterSpacing:0 } }, "(optional \u2014 leave blank to replace whole section)")),
    React.createElement("input", { style: Object.assign({}, inputStyle, { fontFamily:"monospace" }), value: path, onChange:function(e){ setPath(e.target.value); }, placeholder:"e.g. cancellationNotice  or  colourServices[Colour Correction].catherine" }),
    React.createElement("p", { style:{ fontSize:11, color:"#8A8490", marginTop:4, lineHeight:1.4 } }, "Examples: ", React.createElement("code", null, "cancellationNotice"), ", ", React.createElement("code", null, "patchTest.cost"), ", ", React.createElement("code", null, "colourServices[Cut & Blow Dry].catherine"), ". Bracket lookups match a row's ", React.createElement("code", null, "service"), " or ", React.createElement("code", null, "name"), " field."),
    section && React.createElement("div", null,
      React.createElement("label", { style: labelStyle }, "Current value"),
      React.createElement("pre", { style:{ background:"#F7F2EB", padding:10, borderRadius:4, fontSize:12, maxHeight:160, overflow:"auto", margin:0, whiteSpace:"pre-wrap", wordBreak:"break-word" } }, currentValue || "(empty / not found)")
    ),
    React.createElement("label", { style: labelStyle }, "Proposed value"),
    React.createElement("textarea", { style: Object.assign({}, inputStyle, { minHeight:80, fontFamily:"monospace" }), value: proposed, onChange:function(e){ setProposed(e.target.value); }, placeholder:"Type the new value. For numbers use 48, for strings use \"48 hours\", for arrays use [\"a\",\"b\"]." }),
    React.createElement("label", { style: labelStyle }, "Reason"),
    React.createElement("textarea", { style: Object.assign({}, inputStyle, { minHeight:60 }), value: reason, onChange:function(e){ setReason(e.target.value); }, placeholder:"Why this change? (optional but helpful for Catherine)" }),
    msg && React.createElement("div", { style:{ marginTop:12, padding:10, borderRadius:4, fontSize:12, background: msg.ok ? "#e6f4ec" : "#fce8e8", color: msg.ok ? "#2e7d4f" : "#a13b3b" } }, msg.text),
    React.createElement("div", { style:{ marginTop:18, textAlign:"right" } },
      React.createElement("button", { onClick: submit, disabled: saving || !kb, style:{ background:"#8B734A", color:"#fff", border:"none", padding:"10px 24px", borderRadius:4, fontSize:13, fontWeight:600, letterSpacing:"0.04em", cursor: saving ? "wait" : "pointer", opacity: saving ? 0.6 : 1 } }, saving ? "Sending\u2026" : "Send for review")
    )
  );
}

// ===== CLIENTS TAB (mini-CRM) =====
var CB_CLIENTS_API = "https://n8n.catherineboden.com/webhook/cb-clients";

// FIX-051 (2026-05-13) — Originally named fmtDate, which shadowed the existing fmtDate
// at top of file (line ~122 — that one returns ISO YYYY-MM-DD for API payloads).
// JS function hoisting meant THIS definition won, so every fmtDate(today) call across
// CalendarTab / HolidaysTab / PerformanceTab / NewBookingModal etc. was producing
// "13 May 2026" strings instead of "2026-05-13" — which then failed validation in WF13
// (regex /^\d{4}-\d{2}-\d{2}$/), producing 32+ system error emails and an empty
// dashboard. Renamed to fmtDateDisplay to avoid the collision.
function fmtDateDisplay(s) {
  if (!s) return "";
  try {
    var d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch (e) { return s; }
}
function fmtMoney(n) { return "£" + Number(n || 0).toFixed(2).replace(/\.00$/, ""); }
function initials(name) {
  if (!name) return "·";
  var p = name.trim().split(/\s+/);
  return ((p[0] || "")[0] || "") + ((p[1] || "")[0] || "");
}

var TAG_COLOR = {
  "Active Client": { bg: "#dbeedf", fg: "#2e7d4f" },
  "Lead":          { bg: "#fbeec0", fg: "#8a6a1a" },
  "VIP":           { bg: "#ecdcf4", fg: "#6e3a8c" },
  "Lapsed":        { bg: "#e6e3e8", fg: "#5a4f63" },
  "Allergy":       { bg: "#fbdcdc", fg: "#a13b3b" },
  "Sensitive Scalp":{ bg: "#fbe6d2", fg: "#a16435" },
  "Photo Shy":     { bg: "#d6e6f7", fg: "#3a6a8c" },
  "Wedding / Bride":{ bg: "#fbe2ec", fg: "#a13b6a" },
  "Referral":      { bg: "#d4ecef", fg: "#2e6a73" },
  "Do Not Contact":{ bg: "#3a2e44", fg: "#fbeec0" }
};
var ALL_TAGS = ["Active Client", "Lead", "VIP", "Lapsed", "Allergy", "Sensitive Scalp", "Photo Shy", "Wedding / Bride", "Referral", "Do Not Contact"];
var LEAD_SOURCES = ["AI Chat", "Social DM", "Email", "Voice", "Walk-in", "Referral", "Meta Ad", "Other"];
var LEAD_STATUSES = ["New", "Contacted", "Booking Link Sent", "Booked", "Lost"];

function TagChip(props) {
  var col = TAG_COLOR[props.tag] || { bg: "#eee", fg: "#444" };
  return React.createElement("span", {
    style: { display:"inline-block", padding:"2px 9px", borderRadius:10, background:col.bg, color:col.fg, fontSize:10.5, fontWeight:600, letterSpacing:"0.04em", marginRight:4, marginBottom:3 }
  }, props.tag);
}

function ClientsTab() {
  var _f = useState("all"), filter = _f[0], setFilter = _f[1];
  var _q = useState(""), q = _q[0], setQ = _q[1];
  var _list = useState([]), list = _list[0], setList = _list[1];
  var _offset = useState(null), offset = _offset[0], setOffset = _offset[1];
  var _loading = useState(false), loading = _loading[0], setLoading = _loading[1];
  var _loadingMore = useState(false), loadingMore = _loadingMore[0], setLoadingMore = _loadingMore[1];
  var _err = useState(""), err = _err[0], setErr = _err[1];
  var _sel = useState(null), selected = _sel[0], setSelected = _sel[1];
  var _newOpen = useState(false), newOpen = _newOpen[0], setNewOpen = _newOpen[1];
  var _msg = useState(null), msg = _msg[0], setMsg = _msg[1];

  function load(append, currentOffset) {
    if (append) setLoadingMore(true); else { setLoading(true); setList([]); }
    setErr("");
    var url = CB_CLIENTS_API + "?action=list&filter=" + filter
      + (q ? "&q=" + encodeURIComponent(q) : "")
      + (append && currentOffset ? "&offset=" + encodeURIComponent(currentOffset) : "");
    fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: "{}" })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d.ok) throw new Error(d.error || "Load failed");
        setList(function(prev) { return append ? prev.concat(d.clients || []) : (d.clients || []); });
        setOffset(d.offset || null);
      })
      .catch(function(e) { setErr(e.message || "Load failed"); })
      .finally(function() { setLoading(false); setLoadingMore(false); });
  }

  useEffect(function() { load(false); /* eslint-disable-next-line */ }, [filter]);

  function onSearchKey(e) { if (e.key === "Enter") load(false); }

  var filterBtnStyle = function(active) {
    return {
      background: active ? "#8B734A" : "transparent",
      border: "1px solid " + (active ? "#8B734A" : "rgba(139,115,74,0.3)"),
      color: active ? "#fff" : "#8B734A",
      padding: "6px 14px", borderRadius: 18, fontSize: 12, fontWeight: 600,
      letterSpacing: "0.04em", cursor: "pointer", marginRight: 6
    };
  };

  var activeCount = list.filter(function(c) { return (c.tags || []).indexOf("Active Client") !== -1; }).length;
  var leadCount = list.filter(function(c) { return (c.tags || []).indexOf("Lead") !== -1; }).length;

  return React.createElement("div", { style: { animation: "fadeIn 0.2s ease" } },
    // Toolbar
    React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 14 } },
      React.createElement("input", {
        type: "search", placeholder: "Search by name, email, or phone…",
        value: q, onChange: function(e) { setQ(e.target.value); }, onKeyDown: onSearchKey,
        style: { flex: "1 1 280px", padding: "8px 12px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, fontSize: 13, fontFamily: "'Jost',sans-serif" }
      }),
      React.createElement("button", { onClick: function() { load(false); }, style: filterBtnStyle(false) }, "Search"),
      React.createElement("div", { style: { display: "flex", alignItems: "center" } },
        React.createElement("button", { onClick: function() { setFilter("all"); }, style: filterBtnStyle(filter === "all") }, "All"),
        React.createElement("button", { onClick: function() { setFilter("active"); }, style: filterBtnStyle(filter === "active") }, "Active"),
        React.createElement("button", { onClick: function() { setFilter("lead"); }, style: filterBtnStyle(filter === "lead") }, "Leads")
      ),
      React.createElement("button", {
        onClick: function() { setNewOpen(true); },
        style: { background:"#2A2131", color:"#fff", border:"none", padding:"8px 14px", borderRadius:4, fontSize:12, fontWeight:600, letterSpacing:"0.04em", cursor:"pointer" }
      }, "+ New Client")
    ),
    // Stats strip
    React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 18, fontSize: 11, color: "#8B734A", marginBottom: 14, letterSpacing: "0.04em" } },
      React.createElement("span", null, list.length + " shown"),
      React.createElement("span", null, "🟢 " + activeCount + " active"),
      React.createElement("span", null, "🟡 " + leadCount + " leads")
    ),
    err && React.createElement("div", { style: { background: "#fce8e8", color: "#a13b3b", padding: 10, borderRadius: 4, fontSize: 12, marginBottom: 12 } }, err),
    msg && React.createElement("div", { style: { background: "#e6f4ec", color: "#2e7d4f", padding: 10, borderRadius: 4, fontSize: 12, marginBottom: 12 } }, msg),
    loading && React.createElement("div", { style: { padding: 30, textAlign: "center", color: "#9B8E8A", fontStyle: "italic" } }, "Loading…"),
    !loading && list.length === 0 && React.createElement("div", { style: { padding: 40, textAlign: "center", color: "#9B8E8A", fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic" } }, "No clients match that filter."),
    // Client list (card-table hybrid)
    !loading && list.length > 0 && React.createElement("div", { style: { display: "grid", gap: 8 } },
      list.map(function(c) {
        return React.createElement("div", {
          key: c.id,
          onClick: function() { setSelected(c.id); },
          style: { display: "grid", gridTemplateColumns: "44px 1fr auto", gap: 12, alignItems: "center", padding: "12px 14px", background: "#fff", border: "1px solid rgba(139,115,74,0.15)", borderRadius: 6, cursor: "pointer", transition: "all 0.15s ease" },
          onMouseEnter: function(e) { e.currentTarget.style.borderColor = "#8B734A"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(42,33,49,0.06)"; },
          onMouseLeave: function(e) { e.currentTarget.style.borderColor = "rgba(139,115,74,0.15)"; e.currentTarget.style.boxShadow = "none"; }
        },
          // avatar
          React.createElement("div", { style: { width: 40, height: 40, borderRadius: "50%", background: "#F7F2EB", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Cormorant Garamond',serif", fontSize: 16, color: "#8B734A", fontWeight: 500 } }, initials(c.name).toUpperCase()),
          // main
          React.createElement("div", null,
            React.createElement("div", { style: { fontSize: 14, fontWeight: 500, color: "#2A2131", marginBottom: 2 } }, c.name || "(no name)"),
            React.createElement("div", { style: { fontSize: 11, color: "#8B734A" } },
              (c.email || "—") + " · " + (c.phone || "no phone")
            ),
            React.createElement("div", { style: { marginTop: 4 } }, (c.tags || []).map(function(t) { return React.createElement(TagChip, { key: t, tag: t }); }))
          ),
          // right stats
          React.createElement("div", { style: { textAlign: "right", fontSize: 11, color: "#5a4f63" } },
            React.createElement("div", { style: { fontWeight: 600, color: "#2A2131", fontSize: 13 } }, fmtMoney(c.totalSpend)),
            React.createElement("div", null, c.totalVisits + " visit" + (c.totalVisits === 1 ? "" : "s")),
            c.lastVisit && React.createElement("div", { style: { color: "#9B8E8A", fontSize: 10 } }, "last " + fmtDateDisplay(c.lastVisit))
          )
        );
      })
    ),
    // Load more
    !loading && offset && React.createElement("div", { style: { textAlign: "center", marginTop: 16 } },
      React.createElement("button", {
        onClick: function() { load(true, offset); }, disabled: loadingMore,
        style: { background: "transparent", border: "1px solid #8B734A", color: "#8B734A", padding: "8px 24px", borderRadius: 4, fontSize: 12, fontWeight: 600, letterSpacing: "0.04em", cursor: loadingMore ? "wait" : "pointer", opacity: loadingMore ? 0.5 : 1 }
      }, loadingMore ? "Loading…" : "Load more (" + list.length + " shown — more available)")
    ),
    !loading && !offset && list.length > 0 && React.createElement("div", { style: { textAlign: "center", marginTop: 16, fontSize: 11, color: "#9B8E8A", letterSpacing: "0.04em" } },
      "End of list — " + list.length + " client" + (list.length === 1 ? "" : "s")
    ),
    selected && React.createElement(ClientProfileModal, {
      id: selected,
      onClose: function() { setSelected(null); },
      onSave: function(m) { setMsg(m); load(); }
    }),
    newOpen && React.createElement(NewClientModal, {
      onClose: function() { setNewOpen(false); },
      onSave: function(client) { setNewOpen(false); setMsg("Client added — opening profile."); setSelected(client.id); load(); }
    })
  );
}

function ClientProfileModal(props) {
  var _data = useState(null), data = _data[0], setData = _data[1];
  var _loading = useState(true), loading = _loading[0], setLoading = _loading[1];
  var _err = useState(""), err = _err[0], setErr = _err[1];
  var _section = useState("bookings"), section = _section[0], setSection = _section[1];
  var _editing = useState(false), editing = _editing[0], setEditing = _editing[1];
  var _saving = useState(false), saving = _saving[0], setSaving = _saving[1];
  // editable fields buffer
  var _draft = useState({}), draft = _draft[0], setDraft = _draft[1];
  // booking modal (re-uses EditBookingModal which expects an event object)
  var _amendBooking = useState(null), amendBooking = _amendBooking[0], setAmendBooking = _amendBooking[1];

  function reload() {
    setLoading(true); setErr("");
    fetch(CB_CLIENTS_API + "?action=detail&id=" + props.id, { method: "POST", headers: { "Content-Type": "application/json" }, body: "{}" })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d.ok) throw new Error(d.error || "Load failed");
        setData(d);
        setDraft({
          "Full Name": d.client.name || "",
          "First Name": d.client.firstName || "",
          "Last Name": d.client.lastName || "",
          "Email": d.client.email || "",
          "Phone": d.client.phone || "",
          "Tags": (d.client.tags || []).slice(),
          "Internal Notes": d.client.internalNotes || "",
          "Lead Source": d.client.leadSource || null,
          "Lead Status": d.client.leadStatus || null,
          "Marketing Consent": !!d.client.marketingConsent,
          "Instagram Handle": d.client.instagram || ""
        });
      })
      .catch(function(e) { setErr(e.message || "Load failed"); })
      .finally(function() { setLoading(false); });
  }
  useEffect(reload, [props.id]);

  function saveDraft() {
    setSaving(true);
    fetch(CB_CLIENTS_API + "?action=update", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: props.id, fields: draft })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d.ok) throw new Error(d.error || "Save failed");
        setEditing(false);
        if (props.onSave) props.onSave("Saved — " + (draft["Full Name"] || "client"));
        reload();
      })
      .catch(function(e) { setErr(e.message || "Save failed"); })
      .finally(function() { setSaving(false); });
  }

  function toggleTag(tag) {
    var cur = (draft["Tags"] || []).slice();
    var i = cur.indexOf(tag);
    if (i === -1) cur.push(tag); else cur.splice(i, 1);
    setDraft(Object.assign({}, draft, { "Tags": cur }));
  }

  if (loading || !data) {
    return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) props.onClose(); } },
      React.createElement("div", { className: "cb-modal", style: { maxWidth: 480 } },
        loading ? "Loading profile…" : (err || "No data")
      )
    );
  }

  var c = data.client;
  var hasLead = (c.tags || []).indexOf("Lead") !== -1;

  function fieldRow(label, key, type) {
    type = type || "text";
    return React.createElement("div", { style: { display: "grid", gridTemplateColumns: "120px 1fr", gap: 10, marginBottom: 8, alignItems: "center" } },
      React.createElement("label", { style: { fontSize: 11, color: "#8B734A", letterSpacing: "0.04em", textTransform: "uppercase" } }, label),
      editing
        ? React.createElement("input", {
            type: type, value: draft[key] || "",
            onChange: function(e) { setDraft(Object.assign({}, draft, (function() { var o = {}; o[key] = e.target.value; return o; })())); },
            style: { padding: "6px 10px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, fontSize: 13 }
          })
        : React.createElement("div", { style: { fontSize: 13, color: "#2A2131" } }, (draft[key] || "—"))
    );
  }

  var sectionBtn = function(id, label, count) {
    var active = section === id;
    return React.createElement("button", {
      onClick: function() { setSection(id); },
      style: { background: active ? "#F7F2EB" : "transparent", border: "none", borderBottom: active ? "2px solid #8B734A" : "2px solid transparent", padding: "8px 14px", fontSize: 12, fontWeight: active ? 600 : 400, color: active ? "#2A2131" : "#8B734A", cursor: "pointer", letterSpacing: "0.04em" }
    }, label + (count != null ? " (" + count + ")" : ""));
  };

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) props.onClose(); } },
    React.createElement("div", { className: "cb-modal", style: { maxWidth: 720 } },
      // Floating close button — always reachable even if modal scrolls
      React.createElement("button", {
        onClick: props.onClose,
        title: "Close",
        style: { position: "sticky", top: 0, marginLeft: "auto", marginBottom: -32, marginRight: -8, display: "block", zIndex: 5, background: "#FDFAF8", border: "1px solid rgba(139,115,74,0.2)", borderRadius: "50%", width: 32, height: 32, fontSize: 18, color: "#8B734A", cursor: "pointer", lineHeight: 1, padding: 0, boxShadow: "0 2px 6px rgba(0,0,0,0.08)" }
      }, "×"),
      // Header
      React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14, marginBottom: 18, marginTop: 0 } },
        React.createElement("div", { style: { width: 56, height: 56, borderRadius: "50%", background: "#F7F2EB", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#8B734A", fontWeight: 500, flexShrink: 0 } }, initials(c.name).toUpperCase()),
        React.createElement("div", { style: { flex: 1, minWidth: 0 } },
          React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 500, margin: 0, color: "#2A2131" } }, c.name || "(no name)"),
          React.createElement("div", { style: { fontSize: 12, color: "#8B734A", marginTop: 2, wordBreak: "break-word" } }, c.email + (c.phone ? " · " + c.phone : ""))
        ),
        React.createElement("button", {
          onClick: function() { setEditing(!editing); },
          style: { background: editing ? "#2A2131" : "transparent", color: editing ? "#fff" : "#8B734A", border: "1px solid #8B734A", padding: "6px 14px", borderRadius: 4, fontSize: 12, cursor: "pointer", letterSpacing: "0.04em", flexShrink: 0 }
        }, editing ? "Cancel edit" : "Edit")
      ),

      // Quick stats — responsive: 4 cols on wide, wraps to 2 cols on phone
      React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: 10, marginBottom: 18, padding: 12, background: "#F7F2EB", borderRadius: 6 } },
        React.createElement("div", null,
          React.createElement("div", { style: { fontSize: 10, color: "#8B734A", letterSpacing: "0.06em" } }, "TOTAL SPEND"),
          React.createElement("div", { style: { fontSize: 16, fontWeight: 600, color: "#2A2131", fontFamily: "'Cormorant Garamond',serif" } }, fmtMoney(c.totalSpend))
        ),
        React.createElement("div", null,
          React.createElement("div", { style: { fontSize: 10, color: "#8B734A", letterSpacing: "0.06em" } }, "VISITS"),
          React.createElement("div", { style: { fontSize: 16, fontWeight: 600, color: "#2A2131", fontFamily: "'Cormorant Garamond',serif" } }, c.totalVisits || 0)
        ),
        React.createElement("div", null,
          React.createElement("div", { style: { fontSize: 10, color: "#8B734A", letterSpacing: "0.06em" } }, "LAST VISIT"),
          React.createElement("div", { style: { fontSize: 13, color: "#2A2131" } }, fmtDateDisplay(c.lastVisit) || "—")
        ),
        React.createElement("div", null,
          React.createElement("div", { style: { fontSize: 10, color: "#8B734A", letterSpacing: "0.06em" } }, "PRIMARY STYLIST"),
          React.createElement("div", { style: { fontSize: 13, color: "#2A2131" } }, c.lastStylist || "—")
        )
      ),

      // Tags
      React.createElement("div", { style: { marginBottom: 14 } },
        React.createElement("div", { style: { fontSize: 11, color: "#8B734A", letterSpacing: "0.04em", textTransform: "uppercase", marginBottom: 6 } }, "Tags"),
        editing
          ? React.createElement("div", null,
              ALL_TAGS.map(function(t) {
                var on = (draft["Tags"] || []).indexOf(t) !== -1;
                var col = TAG_COLOR[t] || { bg: "#eee", fg: "#444" };
                return React.createElement("button", {
                  key: t, onClick: function() { toggleTag(t); },
                  style: { display: "inline-block", padding: "3px 10px", borderRadius: 12, background: on ? col.bg : "transparent", color: on ? col.fg : "#8B734A", fontSize: 11, fontWeight: 600, letterSpacing: "0.04em", marginRight: 5, marginBottom: 5, border: "1px solid " + (on ? col.bg : "rgba(139,115,74,0.3)"), cursor: "pointer" }
                }, t);
              })
            )
          : ((c.tags || []).length === 0
              ? React.createElement("div", { style: { fontSize: 12, color: "#9B8E8A", fontStyle: "italic" } }, "No tags yet — click Edit to add.")
              : (c.tags || []).map(function(t) { return React.createElement(TagChip, { key: t, tag: t }); })
            )
      ),

      // Lead pipeline (only if Lead tag)
      (hasLead || editing) && React.createElement("div", { style: { marginBottom: 14, padding: 10, background: "#fbeec0", borderRadius: 4, borderLeft: "3px solid #c98b3a" } },
        React.createElement("div", { style: { fontSize: 11, color: "#8a6a1a", letterSpacing: "0.04em", textTransform: "uppercase", marginBottom: 6, fontWeight: 600 } }, "Lead pipeline"),
        editing
          ? React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 } },
              React.createElement("select", {
                value: draft["Lead Source"] || "", onChange: function(e) { setDraft(Object.assign({}, draft, { "Lead Source": e.target.value || null })); },
                style: { padding: "6px 8px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, fontSize: 12 }
              },
                React.createElement("option", { value: "" }, "— Lead source —"),
                LEAD_SOURCES.map(function(s) { return React.createElement("option", { key: s, value: s }, s); })
              ),
              React.createElement("select", {
                value: draft["Lead Status"] || "", onChange: function(e) { setDraft(Object.assign({}, draft, { "Lead Status": e.target.value || null })); },
                style: { padding: "6px 8px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, fontSize: 12 }
              },
                React.createElement("option", { value: "" }, "— Lead status —"),
                LEAD_STATUSES.map(function(s) { return React.createElement("option", { key: s, value: s }, s); })
              )
            )
          : React.createElement("div", { style: { fontSize: 12, color: "#5a4f63" } },
              "Source: " + (c.leadSource || "—") + " · Status: " + (c.leadStatus || "—")
            )
      ),

      // Contact details (editable)
      editing && React.createElement("div", { style: { marginBottom: 14 } },
        fieldRow("Full Name", "Full Name"),
        fieldRow("Email", "Email", "email"),
        fieldRow("Phone", "Phone", "tel"),
        fieldRow("Instagram", "Instagram Handle")
      ),

      // Internal notes
      React.createElement("div", { style: { marginBottom: 14 } },
        React.createElement("div", { style: { fontSize: 11, color: "#8B734A", letterSpacing: "0.04em", textTransform: "uppercase", marginBottom: 6 } }, "Internal notes (private)"),
        editing
          ? React.createElement("textarea", {
              value: draft["Internal Notes"] || "",
              onChange: function(e) { setDraft(Object.assign({}, draft, { "Internal Notes": e.target.value })); },
              style: { width: "100%", minHeight: 80, padding: "8px 10px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, fontSize: 13, fontFamily: "inherit", resize: "vertical" },
              placeholder: "Allergies, preferences, conversation context, special requests…"
            })
          : React.createElement("div", { style: { fontSize: 13, color: "#2A2131", whiteSpace: "pre-wrap", padding: 8, background: "#FBF8F5", borderRadius: 4, minHeight: 30 } }, c.internalNotes || React.createElement("em", { style: { color: "#9B8E8A" } }, "No notes yet."))
      ),

      // Save row (× at top is the cancel/exit affordance — no separate Cancel button needed)
      editing && React.createElement("div", { style: { textAlign: "right", marginBottom: 18 } },
        React.createElement("button", {
          onClick: saveDraft, disabled: saving,
          style: { background: "#8B734A", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 4, fontSize: 13, fontWeight: 600, letterSpacing: "0.04em", cursor: saving ? "wait" : "pointer", opacity: saving ? 0.6 : 1 }
        }, saving ? "Saving…" : "Save changes")
      ),

      // Section tabs
      React.createElement("div", { style: { display: "flex", borderBottom: "1px solid rgba(139,115,74,0.15)", marginBottom: 12 } },
        sectionBtn("bookings", "Bookings", data.bookings.length),
        sectionBtn("communications", "Communications", data.communications.length),
        sectionBtn("activity", "Activity")
      ),

      // Bookings section
      section === "bookings" && React.createElement("div", null,
        data.bookings.length === 0
          ? React.createElement("div", { style: { padding: 20, textAlign: "center", color: "#9B8E8A", fontStyle: "italic", fontSize: 12 } }, "No bookings yet.")
          : data.bookings.map(function(b) {
              return React.createElement("div", {
                key: b.id,
                style: { display: "grid", gridTemplateColumns: "minmax(78px,auto) 1fr auto auto", gap: 10, alignItems: "center", padding: "8px 10px", borderBottom: "1px solid rgba(139,115,74,0.08)" }
              },
                React.createElement("div", { style: { fontSize: 12, color: "#2A2131", fontWeight: 500, whiteSpace: "nowrap" } }, fmtDateDisplay(b.date)),
                React.createElement("div", { style: { minWidth: 0 } },
                  React.createElement("div", { style: { fontSize: 13, color: "#2A2131", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, b.service || "—"),
                  React.createElement("div", { style: { fontSize: 11, color: "#8B734A" } }, b.stylist + " · " + (b.status || "—"))
                ),
                React.createElement("div", { style: { fontSize: 13, color: "#2A2131", textAlign: "right", fontWeight: 500, whiteSpace: "nowrap" } }, b.priceCharged != null ? fmtMoney(b.priceCharged) : "—"),
                React.createElement("button", {
                  onClick: function() {
                    // Construct event-shape object for EditBookingModal compatibility
                    setAmendBooking({
                      id: b.calendarEventId || b.id,
                      summary: (c.name || "") + " — " + (b.service || ""),
                      description: "Service: " + (b.service || "") + "\nStylist: " + (b.stylist || "") + "\nEmail: " + (c.email || "") + "\nPhone: " + (c.phone || ""),
                      start: { dateTime: b.startTime || (b.date + "T10:00:00") },
                      _airtableBookingId: b.id,
                      _stylist: b.stylist
                    });
                  },
                  style: { background: "transparent", border: "1px solid rgba(139,115,74,0.3)", color: "#8B734A", padding: "4px 10px", borderRadius: 4, fontSize: 11, cursor: "pointer" }
                }, "Amend")
              );
            })
      ),

      // Communications section
      section === "communications" && React.createElement("div", null,
        data.communications.length === 0
          ? React.createElement("div", { style: { padding: 20, textAlign: "center", color: "#9B8E8A", fontStyle: "italic", fontSize: 12 } }, "No communications logged.")
          : data.communications.map(function(m) {
              return React.createElement("div", {
                key: m.id,
                style: { padding: "8px 10px", borderBottom: "1px solid rgba(139,115,74,0.08)" }
              },
                React.createElement("div", { style: { fontSize: 11, color: "#8B734A", marginBottom: 2 } },
                  (m.channel || "?") + " · " + (m.direction === "in" ? "from client" : "from us") + " · " + (m.handledBy || "?") + " · " + fmtDateDisplay(m.timestamp)
                ),
                React.createElement("div", { style: { fontSize: 13, color: "#2A2131", fontWeight: 500 } }, m.subject || "(no subject)"),
                m.summary && React.createElement("div", { style: { fontSize: 12, color: "#5a4f63", marginTop: 2 } }, m.summary)
              );
            })
      ),

      // Activity section (combined timeline)
      section === "activity" && React.createElement("div", { style: { padding: 12, fontSize: 12, color: "#5a4f63" } },
        React.createElement("p", { style: { margin: "0 0 6px" } }, "Sourced from comms + bookings + transactions. Full unified feed coming next."),
        React.createElement("p", { style: { margin: 0, fontSize: 11, color: "#9B8E8A", fontStyle: "italic" } }, "Use Communications + Bookings tabs for now.")
      ),

      amendBooking && React.createElement(EditBookingModal, {
        event: amendBooking,
        currentStylist: amendBooking._stylist || "Catherine",
        currentDate: (amendBooking.start && amendBooking.start.dateTime) ? amendBooking.start.dateTime.slice(0, 10) : "",
        onClose: function() { setAmendBooking(null); },
        onSave: function(msg, err) {
          setAmendBooking(null);
          if (props.onSave) props.onSave(msg || err || "Booking updated");
          reload();
        }
      })
    )
  );
}

function NewClientModal(props) {
  var _name = useState(""), name = _name[0], setName = _name[1];
  var _email = useState(""), email = _email[0], setEmail = _email[1];
  var _phone = useState(""), phone = _phone[0], setPhone = _phone[1];
  var _src = useState("Walk-in"), src = _src[0], setSrc = _src[1];
  var _saving = useState(false), saving = _saving[0], setSaving = _saving[1];
  var _err = useState(""), err = _err[0], setErr = _err[1];

  function submit() {
    if (!name && !email && !phone) { setErr("At least name, email, or phone required."); return; }
    setSaving(true); setErr("");
    var parts = (name || "").trim().split(/\s+/);
    var fields = {
      "Full Name": name,
      "First Name": parts[0] || "",
      "Last Name": parts.slice(1).join(" ") || "",
      "Email": email,
      "Phone": phone,
      "Tags": ["Lead"],
      "Lead Source": src,
      "Lead Status": "New"
    };
    fetch(CB_CLIENTS_API + "?action=create", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fields: fields })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d.ok) throw new Error(d.error || "Create failed");
        if (props.onSave) props.onSave({ id: d.client.id });
      })
      .catch(function(e) { setErr(e.message || "Create failed"); })
      .finally(function() { setSaving(false); });
  }

  var inp = { width: "100%", padding: "8px 10px", border: "1px solid rgba(139,115,74,0.25)", borderRadius: 4, fontSize: 13, marginBottom: 10, fontFamily: "inherit" };

  return React.createElement("div", { className: "cb-overlay", onClick: function(e) { if (e.target === e.currentTarget) props.onClose(); } },
    React.createElement("div", { className: "cb-modal", style: { maxWidth: 460 } },
      React.createElement("h3", null, "New Client / Lead"),
      React.createElement("p", { style: { fontSize: 12, color: "#8B734A", marginTop: -8, marginBottom: 14 } }, "Defaults to Lead tag. Convert once they book."),
      React.createElement("input", { style: inp, placeholder: "Full Name", value: name, onChange: function(e) { setName(e.target.value); } }),
      React.createElement("input", { style: inp, type: "email", placeholder: "Email", value: email, onChange: function(e) { setEmail(e.target.value); } }),
      React.createElement("input", { style: inp, type: "tel", placeholder: "Phone", value: phone, onChange: function(e) { setPhone(e.target.value); } }),
      React.createElement("label", { style: { fontSize: 11, color: "#8B734A", letterSpacing: "0.04em", textTransform: "uppercase" } }, "Lead source"),
      React.createElement("select", { style: inp, value: src, onChange: function(e) { setSrc(e.target.value); } },
        LEAD_SOURCES.map(function(s) { return React.createElement("option", { key: s, value: s }, s); })
      ),
      err && React.createElement("div", { style: { background: "#fce8e8", color: "#a13b3b", padding: 8, borderRadius: 4, fontSize: 12, marginBottom: 10 } }, err),
      React.createElement("div", { style: { textAlign: "right" } },
        React.createElement("button", { className: "cbd-btn cbd-btn-secondary", onClick: props.onClose, style: { marginRight: 6 } }, "Cancel"),
        React.createElement("button", { className: "cbd-btn cbd-btn-primary", onClick: submit, disabled: saving }, saving ? "Saving…" : "Create")
      )
    )
  );
}

// ===== MOUNT =====
var root = document.getElementById("cb-staff-dashboard-root");
if (root) {
  ReactDOM.createRoot(root).render(React.createElement(StaffDashboard, null));
}
// v16 — 2026-05-13 — FIX-054 EditBookingModal endTime default no longer hardcoded "10:45" (which caused endTime < startTime when staff edited startTime → Google Calendar rejected). Computes startTime+45min as the default. Also bundles FIX-052 + FIX-053 (n8n side) for unified deploy.
